import axios from 'axios'
//import admixworker from '@/web-worker/admix-worker'
const Social = () => import("@/components/Social.vue");
import copy from 'copy-html-to-clipboard';
import debounce from "lodash.debounce";
import {
    throttle
} from "lodash";
import * as markerjs2 from '@/plugins/markerjs2';
markerjs2.Activator.addKey('MJS2-P186-M739-3506');
import {
    HighlightEllipseMarker
} from "@/components/ellipsehighlighter";
import {
    EllipseMarker2
} from "@/components/ellipse";
import Table from 'table-builder';
import * as turf from '@turf/helpers'
import centerMean from '@turf/center-mean';
import tablecss from '../table.js'
import TransitionExpand from '../components/TransitionExpand.vue';
import VueApexCharts from 'vue-apexcharts'
import ECharts from 'vue-echarts'
const SamplesModal = () => import('../components/modals/dataSamples.vue')
const CalcSamplesModal = () => import('../components/modals/calcSamples.vue')
const CalcModal = () => import('../components/modals/calculator.vue')
const CheckFitsModal = () => import('../components/modals/CheckFitsModal.vue')
const OraclesModal = () => import('../components/modals/OraclesModal.vue')
const EditSamplesModal = () => import('../components/modals/EditSamplesModal.vue')
import GetKeyModal from '../components/modals/getKey.vue'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/effectScatter'
import 'echarts/lib/chart/map'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/geo'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/dataset'
import {
    Checkbox,
    Collapse,
    CollapseItem,
    Button,
    Tabs,
    TabPane
} from '@/components'
import {
    Switch
} from 'element-ui'
import getResultQuery from "@/graphql/getResultQuery"
import getCalcResultQuery from "@/graphql/getCalcResultQuery"
import getCalcRResultQuery from "@/graphql/getCalcRResultQuery"
import getFitsQuery from "@/graphql/getFitsQuery"
import invokeAnalyzeResults from "@/graphql/invokeAnalyzeResults"
import getConfigQuery from "@/graphql/getConfigQuery.js"
import getRawCalcResultQuery from "@/graphql/getRawCalcResultQuery"
import getS3SignatureQuery from "@/graphql/getS3SignatureQuery"
import getFitQuery from "@/graphql/getFitQuery"
import getShareQuery from "@/graphql/getShareQuery"
import getOraclesQuery from "@/graphql/getOraclesQuery"
import getFreeFormOraclesQuery from "@/graphql/getFreeFormOraclesQuery"
import invokeCalcQuery from "@/graphql/invokeCalcQuery"
import invokeCalcModalQuery from "@/graphql/invokeCalcModalQuery"
import invokeSimQuery from "@/graphql/invokeSimQuery"
import invokeOptiFitQuery from "@/graphql/invokeOptiFitQuery"
import onPublishResultSub from "@/graphql/onPublishResult"
import getOwnerSamplesQuery from "@/graphql/getOwnerSamplesQuery"
import getRawResultQuery from "@/graphql/getRawResultQuery"
import getRefsQuery from "@/graphql/getRefsQuery"
import getOwnerCalcsQuery from "@/graphql/getOwnerCalcsQuery"
import getFilebaseSignatureQuery from "@/graphql/getFilebaseSignatureQuery"
import createSimMutation from "@/graphql/createSimMutation"
import queryByOwnerType from "@/graphql/queryByOwnerType"
import Vue from "vue";
import {
    ProgressPlugin
} from 'bootstrap-vue'
Vue.use(ProgressPlugin)
import {
    dragscroll
} from 'vue-dragscroll'
import {
    mapState
} from 'vuex'
import legend from "../components/legend"
import LZString from 'lz-string'
import {
    AgGridVue
} from "../plugins/ag-grid-vue";
import domtoimage from 'dom-to-image-improved';
import rightpanel from '../components/RightPanel/';
import {
    saveAs
} from 'file-saver';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import gql from 'graphql-tag';
import map from '@/data/worldmap';
import worldMap from '@/data/world.json'
import {
    analyzeResults
} from '@/components/methods/sharedMethods.js'
ECharts.registerMap('world', worldMap)
var _ = require('lodash');

function detectScrollContainer(el) {
    while (el) {
        if (el.scrollHeight > el.clientHeight) {
            return el;
        }
        el = el.parentElement;
    }
    return null;
}

function consoleWithNoSource(...params) {
    setTimeout(console.log.bind(console, ...params));
}
let mapMax = -Infinity;
let mapMin = Infinity;
Vue.component('apexchart', VueApexCharts)
Vue.component('v-chart', ECharts)
export default {
    name: 'app-page',
    bodyClass: 'app-page,calc',
    computed: {
        ...mapState({
            onLine: 'onLine',
            decryptToken: 'lastsync',
            topClass: 'topClass',
            geo: 'geo',
            alias: 'alias',
            credits: 'credits',
            isAdmin: 'isAdmin',
            proxyUser: 'proxyUser',
            fadeIn: 'fadeIn',
            activePane: 'activePane',
            primaryT: 'primaryTabs',
            secondaryT: 'secondaryTabs',
            lastQuery: 'lastQuery',
            firstRun: 'g25firstRun',
            subs: 'subscription',
            themes: 'themes',
            loading: 'rawchartLoading',
            statusMessage: 'statusMessage',
            running: 'spinner',
            showGrid: 'showGrid',
            chartJSON: 'rawchartJSON',
            chartRefs: 'rawchartRefs',
            categories: 'rawchartCategories',
            chartKey: 'rawchartKey',
            slider: 'slider',
            testData: 'testData',
            lastSort: 'lastSort',
            switches: 'switches',
            slider: 'slider',
            subId: 'subId',
        }),
        globalDebounce() {
            return debounce;
        },
        ahistory: {
            get: function() {
                return this.$store.getters.get(`ahistory`) ? true : false
            },
            set: function(value) {
                this.$store.commit('change', {
                    ahistory: value
                })
            },
        },
        mergedClasses() {
            const el = this.$refs.myEl;
            //const externalClasses = el?.className?.split(' ') || [];
            const active = this.activeItemIndex === this.i ? ['active'] : [];
            return [...new Set([...externalClasses, ...active])];
        },
        newUser() {
            let created = this.subs && this.subs.created ? this.subs.created : 0
            let now = Date.now()
            let days = Math.ceil((now - (created * 1000)) / 86400000)
            let name = this.user.username + ':' + 'addsamples'
            name = localStorage.getItem(name)
            return !name && days < 7 ? true : false
        },
        validCalcResults() {
            let w = this;
            let index = w.currentIndex || 0
            let slug = w.calcArray[0] && w.calcArray[0].slug || w.calcArray[0] && w.calcArray[0].usage >= 10 || w.calcArray[0] && w.calcArray[0].owner == "Genoplot" ? true : false
            let valid = (w.chartJSON && w.chartJSON[index] && (w.chartJSON[index].distance <= 10) && slug) || w.chartJSON && w.chartJSON[index] && slug && !w.G25calc ? true : false
            return valid;
        },
        nocredits() {
            let credits = this.credits || 0
            console.log('credits', credits, credits <= 0 ? true : false);
            return credits <= 0 ? true : false
        },
        screenshot: {
            get: function() {
                return this.$store.getters.get(`screenshot`) ? true : false
            },
            set: function(value) {
                this.$store.commit('change', {
                    screenshot: value
                })
            },
        },
        currentCategory() {
            if (this.chartReady && this.categories && this.currentIndex >= 0) {
                let c = this.categories[this.currentIndex]
                let z = c.split(' (')[0].trim()
                let group = c.split(' (').length > 1 ? c.split(' (')[1].replace(/\)/, '').trim() : this.user.username
                let sample = this.sampleOptions.find(s => s.originalGroup === group) ? this.sampleOptions.find(s => s.originalGroup === group).samples.find(s => s.sample === z) : false
                if (sample && sample.alias) {
                    let currentCategory = c.replace(sample.originalGroup, sample.alias).replace(/_/g, ' ').replace(/-raw/, '')
                    return currentCategory
                } else {
                    return c.replace(/_/g, ' ').replace(/-raw/, '')
                }
            } else {
                return
            }
        },
        rswitches: {
            get: function() {
                return this.$store.getters.get('rswitches');
            },
            set: function(value) {
                this.$store.commit('change', {
                    rswitches: value
                })
            },
        },
        rawArray: {
            get: function() {
                return Object.freeze(this.rawArrayLocal)
            },
            set: function(value) {
                this.rawArrayLocal = value;
            },
        },
        user: {
            get: function() {
                let user = this.$store.getters.get(`user`)
                //if (user && user.username && !this.initiated) this.init()
                return user
            },
            set: function(value) {
                this.$store.commit('change', {
                    user: value
                })
            },
        },
        filteredOptions: {
            get() {
                if (this.filteredSamples.length == 1 && this.filteredSamples[0].empty) {
                    return []
                } else if (this.filteredSamples.length == 0) {
                    return this.sampleOptions.slice(0, 1000)
                }
                return this.filteredSamples.slice(0, 1000)
            },
            set(value) {
                this.filteredSamples = value;
            }
        },
        filteredGroupOptions() {
            return this.filteredGroupSamples.length == 0 ? this.groupOptions.slice(0, 500) : this.filteredGroupSamples.slice(0, 500)
        },
        resources() {
            let maxrawSamples = this.G25calc ? 100 : 100;
            return {
                samples: [2, 10, 1000],
                groups: [5, 20, 1000],
                rawsamples: [4, 50, maxrawSamples],
                checkfit: [20, 50, 100],
                batches: [200, 500, 1000],
                cycles: [200, 500, 1000],
                optimaFit: [false, false, true],
                indiviudals: [false, true, true]
            }
        },
        frameClass() {
            return this.src && (this.src.includes('discussions.genoplot') || this.src.includes('devdiscuss.genoplot')) ? 'embedded' : 'normal'
        },
        coverage() {
            if (this.chartJSON && this.chartJSON[this.currentIndex] && this.chartJSON[this.currentIndex].stats) {
                let stats = this.chartJSON[this.currentIndex].stats
                let matches = stats.matches
                let total = stats.snps
                let percentage = (matches / total * 100).toFixed(2) + '%'
                return `${matches} SNPs (${percentage})`
            } else {
                return false
            }
        },
        groupedSamples: {
            get: function() {
                return this.$store.getters.get(`groupedSamples`)
            },
            set: function(value) {
                this.$store.commit('change', {
                    groupedSamples: value
                })
            },
        },
        getGroupOrOptions() {
            let w = this;
            const groups = []
            const groupOptions = [];

            function getGroup(key, value) {
                return w.sampleOptions.find((option) =>
                    option.samples.some((sample) => sample[key] === value)
                );
            }
            const grouped = {}
            this.rawArrayLocal.forEach((option) => {
                const grouplabel = option.customgroup ? option.customgroup : option.group
                let group;
                if (grouped[grouplabel]) {
                    group = grouped[grouplabel]
                } else {
                    group = option.customgroup ? getGroup("customgroup", option.customgroup) : getGroup("group", option.group);
                }
                if (group) group.group = option.customgroup ? option.customgroup : group.group
                grouped[grouplabel] = group
                let custom = option.customgroup ? true : false
                if (group && !groups.includes(grouplabel) && this.isAllOptionsSelectedInGroup(group, custom)) {
                    if (!groups.includes(grouplabel)) {
                        groups.push(grouplabel);
                        let label = option.customgroup ? grouplabel.replace(/_/g, ' ') + ' [ ' + option.group + ' ]' : grouplabel.replace(/_/g, ' ')
                        label = label + ` (${group.samples.length})`
                        groupOptions.push({
                            label: label,
                            custom: custom,
                            option: group,
                            group: true
                        });
                    }
                } else {
                    if (group && group.group && !groups.includes(grouplabel)) {
                        groupOptions.push({
                            label: this.customSample(option),
                            option,
                            group: false
                        });
                    }
                }
            });
            return groupOptions;
        },
        getGroupOrOptions2() {
            const groups = [];
            const groupOptions = [];
            this.rawArrayLocal.forEach((option) => {
                const group = option.customgroup ? this.getGroup("customgroup", option.customgroup) : this.getGroup("group", option.group);
                if (group && this.isAllOptionsSelectedInGroup(group)) {
                    if (!groups.includes(group.group)) {
                        groups.push(group.group);
                        let label = group.group + ' (Group)'
                        groupOptions.push({
                            label: label,
                            option: group,
                            group: true
                        });
                    }
                } else {
                    groupOptions.push({
                        label: this.customSample(option),
                        option,
                        group: false
                    });
                }
            });
            return groupOptions;
        },
        isMobile: function() {
            return this.$isMobile ? true : false;
        },
        rawSamplesCount: function() {
            let samples;
            if (this.G25calc) {
                samples = this.sampleJSON.filter(x => x.samples.filter(y => y.type === 'G25' || !y.type).length > 0)
            } else {
                samples = this.sampleJSON.filter(x => x.samples.filter(y => y.mode === this.mode || y.type === this.mode).length > 0)
            }
            return samples;
        },
        isPhone: function() {
            let ios = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
            let mobile = navigator.userAgentData && navigator.userAgentData.mobile ? true : false
            return (ios || mobile) ? true : false
        },
        env() {
            let env = window.location.hostname.split('.')[0] === "staging" ? 'staging' : window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '0.0.0.0' ? 'development' : 'production'
            console.log('env', this.$store.getters.get('env'), env);
            return env
        },
        openDrawer: {
            get: function() {
                return this.drawer && this.chartReady ? true : false
            },
            set: function(value) {
                this.drawer = value;
            }
        },
        aggregatedCalc() {
            let w = this;
            let calc = w.calcArray && w.calcArray[0] && w.calcArray[0].aggregated && w.calcArray[0].calculator ? w.calcArray[0].aggregated : false
            return calc
        },
        returnFit: function(event) {
            var message, klass, distance = this.chartJSON[this.currentIndex].distance;
            if (distance <= 2) {

                message = 'This is a great result!<br>' + (this.newseries.length > 6 ? ' try to reduce the number of target groups to <b>6</b> or less while keeping the distance below <b>2</b>...' : '')
                klass = 'good'
            } else if (distance <= 3) {
                message = 'This is a decent result, but we can do better!<br> Try to select alternate target groups with geographic and historic relevance for your ancestry<br>aim to get the distance below <b>2</b>.'
                klass = 'fair'
            } else {
                message = 'This is not a great result, but no worries, we can improve on it!<br> Try to select alternate target groups with geographic and historic relevance for your ancestry<br>we should try to get the distance to <b>2</b> or less...'
                klass = 'poor'
            }
            message = "<div class='tip-fit-header-" + klass + "' >Fit: " + distance + "</div><div class='tip-fit-content'>" + message + "<br><br>Click to get the <b>Oracles</b> from the source populations</div>"

            return message
        },
        profileColor: function() {
            let color = this.chartJSON[this.currentChartIndex] && this.chartJSON[this.currentChartIndex].distance >= 0 && this.chartJSON[this.currentChartIndex].distance <= 2 ? '#73af25cc' : this.chartJSON[this.currentChartIndex] && this.chartJSON[this.currentChartIndex].distance && this.chartJSON[this.currentChartIndex].distance <= 3 ? '#efa90be8' : this.chartJSON[this.currentChartIndex] && this.chartJSON[this.currentChartIndex].distance && this.chartJSON[this.currentChartIndex].distance <= 5 ? '#de3705cc' : '#3e3e3ecc'
            return color;
        },
        G25calc: {
            get: function() {
                let calc = this.$store.getters.get('G25calc')
                return calc
            },
            set: function(value) {
                let name = this.user.username + ':' + 'G25calc'
                if (value) {
                    //localStorage.setItem(name, 'true')
                    localStorage.removeItem(name)
                } else {
                    localStorage.removeItem(name)
                }
                this.$store.commit('change', {
                    G25calc: value
                })
            },
        },
        src: {
            get: function() {
                let src = this.$store.getters.get(`sharedurl`) ? this.$store.getters.get(`sharedurl`).split('||')[0] : ''
                let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
                let genoTheme = this.getInitialColorMode(value)
                if (this.$store.getters.get(`sharedurl`) && this.$store.getters.get(`sharedurl`).split('||').length > 1 && src) src = src.replace(/\#.*/, '') + (genoTheme == 'dark' ? '#2' : '#1')
                return src ? src : false
            },
            set: function(value) {
                this.$store.commit('change', {
                    sharedurl: value
                })
            },
        },
        calcArray2: {
            get: function() {
                let calcs = this.$store.getters.get(`calcArray`)
                console.log(calcs)
                return calcs
            },
            set: function(value) {
                this.$store.commit('change', {
                    calcArray: value
                })
            },
        },
        series: {
            get: function() {
                return this.$store.getters.get(`rawchartSeries`)
            },
            set: function(value) {
                this.$store.commit('change', {
                    rawchartSeries: value
                })
            },
        },
        showshare: {
            set: function(value) {
                this.$store.commit('change', {
                    showshare: value
                })
            },
            get: function() {
                let showshare = this.$store.getters.get('showshare')
                this.shareTitle = false
                this.frameDisplay = 'none'
                let user = this.user && this.user.username ? this.user.username : ''
                let src = this.$store.getters.get(`sharedurl`) ? this.$store.getters.get(`sharedurl`).split('||')[0] : ''
                if (this.$store.getters.get(`sharedurl`) && this.$store.getters.get(`sharedurl`).split('||').length > 1) this.shareTitle = this.$store.getters.get(`sharedurl`).split('||')[1]
                if (showshare) {
                    setTimeout(() => {
                        let evt = 'rightpanel';
                        this.$root.$emit(evt, 'close');
                    }, 0)
                }
                return this.$store.getters.get('showshare') ? this.$store.getters.get('showshare') : false
            },
        },
        colors: {
            set: function(value) {
                this.$store.commit('change', {
                    rawchartColors: value
                })
            },
            get: function() {
                let w = this;
                let colors = [...w.$store.getters.get('rawchartColors')]
                return colors;
            },
        },
        markup: {
            set: function(value) {
                this.$store.commit('change', {
                    markup: value
                })
            },
            get: function() {
                return this.$store.getters.get('markup')
            },
        },
        editedImageUrl: {
            set: function(value) {
                this.$store.commit('change', {
                    editedImageUrl: value
                })
            },
            get: function() {
                return this.$store.getters.get('editedImageUrl')
            },
        },
        editedImageUrl2: {
            set: function(value) {
                this.$store.commit('change', {
                    editedImageUrl2: value
                })
            },
            get: function() {
                return this.$store.getters.get('editedImageUrl2')
            },
        },
        editingImage: {
            set: function(value) {
                this.$store.commit('change', {
                    editingImage: value
                })
            },
            get: function() {
                return this.$store.getters.get('editingImage')
            },
        },
        swiper() {
            return this.$refs.authors.$swiper
        },
        maxVals: {
            set: function(value) {
                this.$store.commit('change', {
                    maxRawVals: value
                })
            },
            get: function(value) {
                return this.$store.getters.get('maxRawVals')
            }
        },
        maxRefVals: {
            set: function(value) {
                this.$store.commit('change', {
                    maxRefVals: value
                })
            },
            get: function(value) {
                return this.$store.getters.get('maxRefVals')
            }
        },
        activeItemIndex: {
            set: function(value) {
                if (value || value === 0) {
                    this.calcArray = [this.scrollCalcs[value]]
                } else {
                    this.calcArray = []
                }
                this.syncStore('calcArray');
            },
            get: function() {
                return this.calcArray && this.calcArray[0] ? this.scrollCalcs.findIndex(x => x.calculator === this.calcArray[0].calculator) : undefined
            }
        },
        drawer2: {
            set: function(value) {
                this.chartReady = value
            },
            get: function(value) {
                return this.chartReady
            }
        },
        mode: {
            set: function(value) {},
            get: function(value) {
                return this.G25calc == true ? 'G25' : 'RAW'
            }
        },
        rawArrayLocal2: {
            set: function(value) {
                this.$store.commit('change', {
                    rawArrayLocal: value
                })
            },
            get: function() {
                return this.$store.getters.get('rawArrayLocal')
            }
        },
        selectWidth() {
            let modes = this.modes
            modes = [...modes];
            let maxWidth = modes.sort((a, b) => a.value.length > b.value.length ? -1 : a.value.length < b.value.length ? 1 : 0)[0].value.length
            return `${maxWidth * 16}px`
        },
        padding: function() {},
        userSamples: {
            set: function(value) {
                this.$store.commit('change', {
                    'userSamples': value
                })
            },
            get: function(value) {
                let mode = this.G25calc ? 'G25' : this.mode
                return this.$store.getters.get('userSamples') && this.$store.getters.get('userSamples')[0] ? [{
                    group: this.alias ? this.alias : this.$store.getters.get('userSamples')[0].group,
                    alias: this.$store.getters.get('userSamples')[0].alias,
                    originalGroup: this.$store.getters.get('userSamples')[0].originalGroup,
                    samples: this.$store.getters.get('userSamples').filter(x => x.type === mode)
                }] : []
            }
        },
        rawFiles: function() {
            return this.G25calc && this.userSamples && this.userSamples[0] && this.userSamples[0].samples ? this.userSamples[0].samples.filter(x => x.type === 'G25' || !x.type) : this.userSamples && this.userSamples[0] && this.userSamples[0].samples ? this.userSamples[0].samples.filter(x => x.type === 'RAW') : []
        },
        selectSamples() {
            return "<div style=padding:10px>Select individual samples instead of the whole group<br/>Multiple samples from the same group will form their own virtual group<br/>Selections can be mixed-and-matched from groups and individual samples, but groups will take precedence</div></div>"
        },
        updated() {},
        subType() {
            return this.subs && this.subs.subType && this.subs.subType.indexOf('gold') >= 0 ? 2 : this.subs && this.subs.subType && this.subs.subType.indexOf('silver') >= 0 ? 1 : 0
        },
        optimaFit() {
            return "<div style=padding:10px><b>Experimental Feature</b><br/><div style='padding:5px 0;'>Select as many populations as you like<br>(up to a maximum of 20)<br/>The optimaFit process will iterate over all possible combinations and calculate the 4 populations that provide optimal results<br/>Please note that the selected populations should all belong to the same time period<br/>Care should also be taken to select populations that, at minimum, hold a possibility of being relevant to your ancestry<br/>Alternatively, you may choose to run with no groups selected<br/>In this case, optimaFit will automatically find the groups that provide the best fit (moderns only)<br></div><b style='color:brown;padding-bottom: 5px;'>Warning</b><br/><div style='padding-top: 5px'>Enabling this mode can use over 50 credits for a single run<br/><div style='padding-top: 10px; padding-bottom: 0px'><b style='color:brown;padding-bottom: 5px;'>Requires PRO subscription</b></div></div></div>"
        },
        queryTimeStamp: {
            get: function() {
                return this.$store.getters.get('queryTimeStamp');
            },
            set: function(value) {
                this.$store.commit('change', {
                    queryTimeStamp: value
                })
            }
        },
        globaltheme: {
            get: function() {
                return this.$store.getters.get('theme');
            },
            set: function(value) {
                this.$store.commit('change', {
                    theme: value
                })
            }
        },
        primaryTabs: {
            get: function() {
                return this.primaryT
            },
            set: function(value) {
                this.$store.commit('change', {
                    primaryTabs: value
                })
            }
        },
        spinner: {
            get: function() {
                return this.$store.getters.get('spinner')
            },
            set: function(value) {
                this.$store.commit('change', {
                    spinner: value
                })
            }
        },
        progress: {
            get: function() {
                return this.$store.getters.get('progress')
            },
            set: function(value) {
                this.$store.commit('change', {
                    progress: value
                })
            }
        },
        calcOwners: function() {
            let owners = {}
            this.publicCalcs.map(x => owners[x.owner] = true)
            let keys = Object.keys(owners)
            keys.push("")
            return keys;
        },
        sampleOptions: function() {
            let w = this;
            if (this.G25 || this.G25calc) {
                if ((this.G25calc || this.G25) && this.userSamples && this.userSamples[0] && this.userSamples[0].samples) {
                    let publicSamples = this.publicSamplesG25.filter(x => x.group !== this.userSamples[0].group)
                    let userSamples = JSON.parse(JSON.stringify(this.userSamples[0]))
                    userSamples.samples = userSamples.samples.filter(x => x.sample.indexOf('Average') < 0 && x.sample.indexOf('Median') < 0 && !x.customgroup)
                    let customgroups = userSamples.samples.length > 0 ? [userSamples] : []
                    this.userSamples[0].samples.map(sample => {
                        if (sample.customgroup) {
                            let customIndex = customgroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customgroups[customIndex].samples.push(sample)
                            } else {
                                customgroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    customgroup: sample.customgroup,
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    let options = customgroups.concat(publicSamples)
                    this.filteredSamples = options
                    console.log('returning sampleOptions', this.G25calc, this.G25, options[0]);
                    return options;
                } else {
                    let options = this.publicSamplesG25
                    this.filteredSamples = options
                    return options
                }
            } else if (this.rswitches.ancient) {
                let options = this.publicRawAncientGroups
                this.filteredSamples = options
                return options
            } else {
                w.addSample = function() {
                    w.editSamples('add');
                }
                let samples = this.sampleJSON.filter(x => x.samples.filter(y => y.mode === this.mode || y.type === this.mode).length > 0)
                let allsamples = samples.concat(this.publicRawGroups)
                if (this.initiateda && !this.addrawfile && samples.length == 0) {
                    this.addrawfile = this.$toasted.show('Click here to add Raw DNA files', {
                        position: 'top-left',
                        duration: null,
                        containerClass: 'addrawfile',
                        className: 'infoToast',
                        theme: 'bubble',
                    })
                    this.addrawfile.el.addEventListener('click', w.addSample)
                } else if (w.addrawfile && samples.length > 0) {
                    w.addrawfile.el.removeEventListener('click', w.addSample)
                    w.addrawfile.goAway()
                    delete w.addrawfile;
                }
                let options = allsamples
                this.filteredSamples = options
                return options
            }
        },
        groupOptions: function() {
            if (this.calculator) {
                return this.groupCalcs;
            } else {
                return []
            }
        },
        showNonRawUploadIcons: function() {
            return false;
        },
        secondaryTabs: {
            get: function() {
                return this.secondaryT
            },
            set: function(value) {
                this.$store.commit('change', {
                    secondaryTabs: value
                })
            }
        },
        batchEnabled() {
            return this.subType > 0 ? true : false
        },
        optimaEnabled() {
            return this.subType > 1 ? true : false
        },
        fitsEnabled() {
            return this.subType > 0 ? true : false
        },
        cyclesEnabled() {
            return this.subType > 0 ? true : false
        },
        sampleMax() {
            return this.resources.rawsamples[this.subType]
        },
        groupMax() {
            return this.resources.groups[this.subType]
        },
        groupSelect() {
            return this.subType > 1 ? true : false
        },
        groupCalcs: function() {
            return this.publicCalcs;
        },
        groupJSON: function() {
            if (this.userSamples[0]) {
                if (this.G25calc) {
                    let customgroups = []
                    this.userSamples[0].samples.filter(x => x.type === 'G25' || !x.type).map(sample => {
                        if (sample.customgroup) {
                            let customIndex = customgroups.findIndex(x => x.label == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customgroups[customIndex].samples = customgroups[customIndex].samples + 1
                            } else {
                                customgroups.push({
                                    class: 'default user',
                                    type: sample.type,
                                    age: sample.age,
                                    customgroup: sample.customgroup,
                                    ethnicity: sample.customgroup + ' [' + sample.group + ']',
                                    label: sample.customgroup + ' [' + sample.group + ']',
                                    samples: 1
                                })
                            }
                        }
                    })
                    return this.publicGroups.concat(customgroups)
                } else {
                    let usersamples = this.userSamples[0].samples.map(sample => {
                        return {
                            class: 'default user',
                            type: 'user',
                            age: sample.age,
                            ethnicity: sample.index,
                            label: sample.index,
                            samples: 1
                        }
                    })
                    return this.publicGroups.concat(usersamples)
                }
            } else {
                return this.publicGroups
            }
        },
        sampleJSON: function() {
            if (this.userSamples[0]) {
                if (this.G25calc) {
                    let publicSamples = this.publicSamples.filter(x => x.group !== this.userSamples[0].group)
                    let userSamples = JSON.parse(JSON.stringify(this.userSamples[0]))
                    userSamples.samples = userSamples.samples.filter(x => x.sample.indexOf('Average') < 0 && x.sample.indexOf('Median') < 0 && !x.customgroup)
                    let customgroups = userSamples.samples.length > 0 ? [userSamples] : []
                    this.userSamples[0].samples.map(sample => {
                        if (sample.customgroup) {
                            let customIndex = customgroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customgroups[customIndex].samples.push(sample)
                            } else {
                                customgroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    customgroup: sample.customgroup,
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    return customgroups.concat(publicSamples)
                } else {
                    let publicSamples = this.publicSamples.filter(x => x.group !== this.userSamples[0].group)
                    return this.userSamples.concat(publicSamples)
                }
            } else {
                return this.publicRawSamples ? this.publicRawSamples : []
            }
        },
        mapseries: function() {
            return;
            this.userSeries = [];
            let index = this.currentIndex ? this.currentIndex : 0;
            let series = []
            let features = []
            let chartseries = this.calculator ? this.calcSeries : this.series
            chartseries.forEach(item => {
                series.push(item.data[index])
            })
            //var series = [{'name':name, 'value':value, 'color':color, latitude: 52.333333, longitude: 61.016667}]
            series.forEach(function(itemOpt) {
                if (itemOpt > mapMax) {
                    mapMax = itemOpt
                }
                if (itemOpt < mapMin) {
                    mapMin = itemOpt;
                }
            });

            function getRandomInRange(from, to, fixed) {
                return (Math.random() * (to - from) + from).toFixed(fixed) * 1;
                // .toFixed() returns string, so ' * 1' is a trick to convert to number
            }
            var w = this
            let components = w.calculator ? w.calcComponents : w.components
            let colorComp = w.components;
            let compObj = {}
            series = series.map(function(itemOpt, index) {
                var parent = components[index] ? components[index].split(':')[0] : 'unknown'
                var comp = components[index] && components[index].split(':')[1] ? components[index].split(':')[1] : components[index] ? components[index] : 'unknown'
                comp = comp.replace(' (AVG)', '').replace(' (MED)', '')
                var meta = w.geo[comp] ? {
                    age: w.geo[comp].a,
                    origin: w.geo[comp].origin
                } : undefined
                var colorIndex = colorComp.findIndex(x => x === unescape(parent))
                compObj[parent] = compObj[parent] ? compObj[parent] + itemOpt : itemOpt
                if (w.chartJSON[w.currentIndex].meta) {
                    meta = meta ? {
                        ...{
                            meta: w.chartJSON[w.currentIndex].meta
                        },
                        ...meta
                    } : w.chartJSON[w.currentIndex].meta
                    let userSeries = []
                    userSeries.push({
                        type: 'custom',
                        visualMap: false,
                        symbol: 'pin',
                        symbolSize: 25,
                        animation: false,
                        itemStyle: {
                            normal: {
                                color: 'white'
                            }
                        },
                        name: w.categories[w.currentIndex],
                        locality: meta.meta,
                        value: [meta.meta.longitude, meta.meta.latitude, 100, 0]
                    })
                    w.map.series[1].data = userSeries
                } else if (w.geo[comp] && itemOpt > 0) {
                    features.push(turf.point([w.geo[comp].latitude, w.geo[comp].longitude], {
                        value: itemOpt
                    }))
                }
                return {
                    name: comp,
                    parent: parent,
                    meta: meta,
                    value: [
                        w.geo[comp] && itemOpt > 0 ? w.geo[comp].longitude : undefined,
                        w.geo[comp] && itemOpt > 0 ? w.geo[comp].latitude : undefined,
                        itemOpt
                    ],
                    label: {
                        emphasis: {
                            position: 'right',
                            show: false
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: w.colors[colorIndex % w.colors.length]
                        }
                    }
                };
            })
            let aggValues = Object.keys(compObj).map(x => {
                return {
                    component: x,
                    value: compObj[x]
                }
            })
            aggValues.sort((a, b) => a.value === b.value ? 0 : a.value < b.value ? 1 : -1)
            series.sort((a, b) => a.value[2] === b.value[2] ? 0 : a.value[2] < b.value[2] ? 1 : -1)
            let newseries = []
            aggValues.map(x => {
                newseries = newseries.concat(series.filter(y => y && y.parent == x.component))
            })
            let geoOptions = {
                weight: "value"
            }
            if (features.length > 0) {
                features = turf.featureCollection(features);
                let userSeries = []
                let mean = centerMean(features, geoOptions);
                userSeries.push({
                    type: 'custom',
                    visualMap: false,
                    symbol: 'pin',
                    symbolSize: 20,
                    animation: false,
                    itemStyle: {
                        normal: {
                            color: 'white'
                        }
                    },
                    name: w.categories[w.currentIndex],
                    value: [mean.geometry.coordinates[1], mean.geometry.coordinates[0], 100, 0]
                })
                w.map.series[1].data = userSeries
            }
            return newseries
        },
        showSelections: function() {
            if ((this.rawArrayLocal && this.rawArrayLocal.length >= 1 && this.calcArray && ((this.calculator && this.calcArray.length >= 1) || this.calcArray.length >= 2)) || this.chartReady === true) {
                return -1
            } else {
                return 0
            }
        },
        pieSeries: function() {
            let w = this;
            let pieseries = w.series
            let series = []
            let index = w.currentIndex;
            pieseries.map(x => {
                if (x.data[index] && x.data[index] > 0) {
                    series.push({
                        value: x.data[index],
                        name: x.name.replace(/_/g, ' ')
                    })
                }
            })
            console.log('series', series)
            return series;
        },
        sunburstSeries: function() {
            return;
            let index = this.currentIndex ? this.currentIndex : 0;
            let series = []
            let chartseries = this.series
            chartseries.forEach(item => {
                series.push(item.data[index])
            })
            var w = this
            //let components = w.calculator ? w.calcComponents : w.components
            let components = w.components
            let colorComp = w.components;
            let compObj = {}
            series = series.map(function(itemOpt, index) {
                var parent = components[index] ? components[index].split(':')[0] : 'unknown'
                var comp = components[index] && components[index].split(':')[1] ? components[index].split(':')[1] : components[index] ? components[index] : 'unknown'
                comp = comp.replace(' (AVG)', '').replace(' (MED)', '')
                var colorIndex = colorComp.findIndex(x => x === parent)
                let color = w.colors[colorIndex % w.colors.length]
                let children = w.mapseries.filter(x => unescape(x.parent) === parent)
                children = children.map((x, i) => {
                    let grandchildren = w.calcSampleSeries.filter(y => y.parent === x.name)
                    grandchildren = grandchildren.map((x, i) => {
                        return {
                            name: unescape(x.parent).replace(/_/g, ' ') + ' ► ' + x.name.replace(/_/g, ' '),
                            value: x.data[w.currentIndex],
                            itemStyle: {
                                color: w.newColor(color)
                            }
                        }
                    })
                    return {
                        name: unescape(x.name).replace(/_/g, ' '),
                        value: parseFloat(x.value[2].toFixed(2)),
                        itemStyle: {
                            color: w.newColor(color, 0, 0, -8)
                        },
                        children: grandchildren
                    }
                })
                return {
                    name: unescape(comp).replace(/_/g, ' '),
                    children: children,
                    itemStyle: {
                        color: w.newColor(color, 0, 0, -15)
                    },
                    //value: parseFloat(itemOpt.toFixed(2))
                    value: itemOpt
                };
            })
            return series
        },
        returnNearest: function(event) {
            if (this.secondaryTabs == 'table' && this.gridApi && this.gridApi.getSelectedRows && this.gridApi.getSelectedRows() && this.gridApi.getSelectedRows().length) {
                let selectedRows = this.gridApi.getSelectedRows();
                let chartindex = 0;
                chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '').replace(/_/g, ' ')} (${x.alias.split(':')[0]})`.trim() == selectedRows[0].originalsample.replace(/_/g, ' ').trim())
                this.currentChartIndex = chartindex;
            } else {
                let profile = this.categories[this.currentIndex]
                let chartindex = 0;
                chartindex = this.chartJSON && this.chartJSON.length ? this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '')} (${x.alias.split(':')[0]})`.replace(/_/g, ' ').trim() == this.categories[this.currentIndex].replace(/-raw/, '').replace(/_/g, ' ').trim() || (x.alias.split(':')[0].replace(/_/g, ' ').includes(profile.split(' (')[1].replace(/_/g, ' ').replace(')', '')) && x.alias.split(':')[1].replace(/_/g, ' ').trim().includes(profile.split(' (')[0].replace(/_/g, ' ').trim()))) : 0;
                this.currentChartIndex = chartindex;
            }
            this.currentChartIndex = this.currentChartIndex >= 0 ? this.currentChartIndex : 0;
            if (this.calcArray[0] && this.chartJSON && this.chartJSON[this.currentChartIndex] && this.chartJSON[this.currentChartIndex].nearest && this.chartJSON[this.currentChartIndex].nearest[0]) {
                var message, klass, distance = this.chartJSON[this.currentChartIndex].nearest[0] ? this.chartJSON[this.currentChartIndex].nearest[0].distance : 99,
                    nearest = this.optimaEnabled ? this.chartJSON[this.currentChartIndex].nearest.slice(0, 5) : this.chartJSON[this.currentChartIndex].nearest.slice(0, 5);
                message = "<div class=tip-content><table class='nearestSamples'><thead><tr><th class='samples'>" + "Sample" + "</th><th>Distance</th></tr></thead><tbody>"
                if (distance <= 2) {
                    klass = 'good'
                } else if (distance <= 3) {
                    klass = 'fair'
                } else {
                    klass = 'poor'
                }
                nearest.forEach(sample => {
                    sample.sample = sample.sample ? sample.sample : sample._row;
                    message = message + `<tr><td>${sample.sample.replace(/_/g,' ').replace(':','  ')}</td><td>${sample.distance.toFixed(2)}</td></tr>`
                })
                message = message + "</tbody></table></div>"
                message = "<div class='tip-fit-header-" + klass + "' >Nearest " + "Samples" + "</div>" + message;
                message = this.calcArray[0] && this.calcArray[0].oracle ? message + 'Click for Oracles<br><br>' : message
                return message
            } else {
                message = this.calcArray[0] && this.calcArray[0].oracle ? 'Click for Oracles' : undefined
                return message
            }
        },
        newseries: function() {
            var index = this.currentIndex ? this.currentIndex : 0;
            var series = []
            this.series.forEach(item => {
                if (item.data[index] > 0) series.push(item.data[index])
            })
            return series
        },
        newcomponents: function() {
            var index = this.currentIndex ? this.currentIndex : 0;
            var components = []
            this.series.forEach(item => {
                if (item.data[index] > 0) components.push(item.name)
            })
            return components
        },
        newcolors: function() {
            let w = this;
            var index = this.currentIndex ? this.currentIndex : 0;
            var colors = []
            this.series.forEach(item => {
                if (item.data[index] > 0) colors.push(this.colors[this.components.findIndex(x => x === item.name) % this.colors.length])
            })
            return colors
        },
        newColors: function() {
            let w = this;
            let colors = []
            w.components.map((x, i) => {
                if (w.chartJSON[w.currentIndex] && w.chartJSON[w.currentIndex].result && w.chartJSON[w.currentIndex].result[x]) {
                    colors.push(w.colors[i % w.colors.length])
                }
            })
            return colors;
        },
        saveReady: function() {
            if (this.series && this.series.length > 0) {
                return true
            } else {
                return false
            }
        },
        switchOutliers: function() {
            return true
        },
        switchAverages: function() {
            return true
        },
        samplesReady: function(evt) {
            if (this.rawArrayLocal && this.rawArrayLocal.length > 1) {
                return true
            } else {
                return false
            }
        },
        groupsReady: function() {
            if (this.calcArray && this.groupAprray.length > 2) {
                return 'ready'
            } else {
                return 'disabled'
            }
        },
        empty: function() {
            if ((!this.rawArrayLocal || (this.rawArrayLocal && this.rawArrayLocal.length < 1)) || (!this.calcArray[0]) || (!this.calcArray || this.calculator && this.calcArray.length < 1)) {
                this.chartReady = false;
                return true
            } else {
                return false
            }
        },
        columnDefs: function() {
            let w = this;
            if (this.components) {
                if (this.components.length > 6) {
                    let maxLength = this.components.reduce((a, b) => {
                        return a && a.length > b.length ? a : b
                    }).length
                    this.gridOptions.headerHeight = maxLength * 5;
                    //this.gridOptions.skipHeaderOnAutoSize = true;
                } else {
                    //this.gridOptions.skipHeaderOnAutoSize = false;
                    this.gridOptions.headerHeight = undefined;
                }
                var columns = [{
                    headerName: 'Sample',
                    field: 'sample',
                    pinned: 'left',
                    sortable: true,
                    resizable: false,
                    rowDrag: false,
                    suppressSizeToFit: true,
                    headerClass: 'header-sample',
                    cellClass: 'cell-sample',
                    filter: true,
                    tooltipField: 'sample',
                    comparator: w.keySort('sample'),
                    cellStyle: {
                        //backgroundColor: '#2e668c',
                        //color: 'white',
                        textTransform: 'uppercase',
                        borderBottom: 'none',
                        textAlign: 'right',
                        paddingRight: '22px',
                        fontSize: '10px'
                    },
                    minWidth: 150,
                    maxWidth: 320
                }]
                let fit = {
                    headerName: 'Fit',
                    field: 'distance',
                    sortable: true,
                    rowDrag: false,
                    pinned: 'left',
                    resizable: false,
                    headerClass: 'header-fit',
                    cellStyle: {
                        //backgroundColor: 'white',
                        //color: 'gray',
                        fontWeight: 700,
                    },
                    suppressSizeToFit: true,
                    width: 70,
                    cellClass: function(params) {
                        return (params.value <= 2 ? 'cell-fit distance-good' : params.value <= 3 ? 'cell-fit distance-fair' : params.value <= 5 ? 'cell-fit distance-poor' : 'cell-fit distance-bad')
                    }
                }
                if (w.G25calc) columns.push(fit);
                w.categories.map(x => {
                    columns[0].width = x.length * 8 >= 300 ? 300 : x.length * 8 > columns[0].width ? 8 * x.length : columns[0].width
                });
                var comp = this.components;

                function getLog(y) {
                    return Math.log(y) / Math.log(10);
                }
                comp.forEach(function(c) {
                    var obj = {};
                    obj.minWidth = comp.length > 6 ? 56 : c.length > 6 ? 80 : c.length > 3 ? c.length * 13 : 56;
                    //obj.maxWidth = comp.length > 6 ? 50 : undefined,
                    obj.sortable = true;
                    obj.resizable = false;
                    obj.suppressSizeToFit = false;
                    obj.headerName = c.replace(/_/g, ' ');
                    obj.headerClass = comp.length > 6 ? 'header-rotated-component' : 'header-component'
                    obj.field = c;
                    var index = w.components.indexOf(c);
                    var color = w.colors[index % w.colors.length];
                    obj.cellClass = 'cell-sheet';
                    obj.cellStyle = function(params) {
                        let background;
                        let comp = c.split(' ')[0]
                        let max = w.maxVals && w.maxVals[c] ? w.maxVals[c] / 100 : 1
                        background = !isNaN(params.value) && params.value >= 0 ? w.colors[0] + Math.floor(parseFloat(((0.3 + (params.value / 100)) / (0.3 + max)).toFixed(2)) * 255).toString(16) : null;
                        background = !isNaN(params.value) && params.value >= 0 ? w.colors[0] + Math.floor(parseFloat((getLog(params.value + 7) / getLog(107)).toFixed(2)) * 255).toString(16) : null;
                        let color = !isNaN(params.value) && params.value >= 0 ? 'white' : 'gray';
                        return {
                            backgroundColor: background,
                            //backgroundColor: '#7372721d',
                            color: color,
                            fontWeight: 700,
                            textAlign: 'center'
                        }
                    };
                    columns.push(obj);
                })
                return columns;
            } else {
                var columns = null;
                return columns;
            }
        },
        rowData: function() {
            var w = this;
            if (this.chartJSON && Array.isArray(this.chartJSON)) {
                var json = [...this.chartJSON];
                var rows = [];
                let sort = json.find( x => x.chromosome) ? true : false
                if ( sort ) {
                json.sort(function(a, b) {
                    let sortkey = 'chromosome'
                    var x = parseInt(a[sortkey]) ? parseInt(a[sortkey]) : 0;
                    var y = parseInt(b[sortkey]) ? parseInt(b[sortkey]) : 0;
                    return (x < y ? -1 : x > y ? 1 : 0)
                })
                }
                json.forEach(function(p) {
                    var obj = {};
                    //obj.sample = p.profile.replace(/:/g, " ► ").replace(/_/g, ' ').replace(/-raw/, '')
                    let profileIndex = w.rawArrayLocal.findIndex(x => x.index === p.profile)
                    let profile = profileIndex >= 0 ? (w.rawArrayLocal[profileIndex].alias ? w.rawArrayLocal[profileIndex].alias + ':' + w.rawArrayLocal[profileIndex].sample : w.rawArrayLocal[profileIndex].group + ':' + w.rawArrayLocal[profileIndex].sample) : p.profile
                    let originalprofile = profileIndex >= 0 ? w.rawArrayLocal[profileIndex].group + ':' + w.rawArrayLocal[profileIndex].sample : p.profile
                    obj.sample = profile.split(':').length > 1 ? `${profile.split(':')[1]} (${profile.split(':')[0]})`.replace(/-raw/, '').replace(/_/g, ' ') : profile.replace(/-raw/, '').replace(/_/g, ' ')
                    obj.originalsample = originalprofile.split(':').length > 1 ? `${originalprofile.split(':')[1]} (${originalprofile.split(':')[0]})`.replace(/-raw/, '').replace(/_/g, ' ') : originalprofile.replace(/-raw/, '').replace(/_/g, ' ')
                    if (w.G25calc) obj.distance = p.distance ? p.distance.toFixed(2) : undefined
                    var comp = w.components;
                    comp.forEach(function(n) {
                        obj[n] = p.result[n] ? p.result[n] : 0
                    })
                    rows.push(obj)
                })
                return rows;
            } else {
                return []
            }
        },
        refsColumnDefs: function() {
            if (this.chartRefs && this.chartRefs.components) {
                if (this.chartRefs.components.length > 6) {
                    let maxLength = this.chartRefs.components.reduce((a, b) => {
                        return a && a.length > b.length ? a : b
                    }).length
                    this.refsGridOptions.headerHeight = maxLength * 9;
                    //this.gridOptions.skipHeaderOnAutoSize = true;
                } else {
                    //this.gridOptions.skipHeaderOnAutoSize = false;
                    this.refsGridOptions.headerHeight = undefined;
                }
                var columns = [{
                    headerName: 'Sample',
                    field: 'sample',
                    pinned: 'left',
                    sortable: true,
                    resizable: false,
                    rowDrag: false,
                    suppressSizeToFit: true,
                    headerClass: 'header-sample',
                    cellClass: 'cell-sample',
                    filter: true,
                    tooltipField: 'sample',
                    cellStyle: {
                        //backgroundColor: '#2e668c',
                        //color: 'white',
                        fontWeight: 700,
                        opacity: 0.7,
                        textTransform: 'uppercase',
                        borderBottom: 'none',
                        textAlign: 'left',
                        paddingRight: '22px',
                        fontSize: '10px'
                    },
                    minWidth: 150,
                    maxWidth: 320
                }]
                let fit = {
                    headerName: 'Fit',
                    field: 'distance',
                    sortable: true,
                    rowDrag: false,
                    resizable: false,
                    headerClass: 'header-fit',
                    cellStyle: {
                        //backgroundColor: 'white',
                        //color: 'gray',
                        fontWeight: 700,
                    },
                    suppressSizeToFit: true,
                    width: 70,
                    cellClass: function(params) {
                        return (params.value <= 2 ? 'cell-fit distance-good' : params.value <= 3 ? 'cell-fit distance-fair' : params.value <= 5 ? 'cell-fit distance-poor' : 'cell-fit distance-bad')
                    }
                }
                var w = this;
                var comp = this.chartRefs.components;

                function getLog(y) {
                    return Math.log(y) / Math.log(10);
                }
                comp.forEach(function(c) {
                    var obj = {};
                    obj.minWidth = comp.length > 6 ? 60 : c.length > 6 ? 80 : c.length > 3 ? c.length * 13 : 60;
                    //obj.maxWidth = comp.length > 6 ? 50 : undefined,
                    obj.sortable = true;
                    obj.resizable = false;
                    obj.suppressSizeToFit = false;
                    obj.headerName = c.replace(/_/g, ' ');
                    obj.headerClass = comp.length > 6 ? 'header-rotated-component' : 'header-component'
                    obj.field = c;
                    var index = w.components.indexOf(c);
                    var color = w.colors[index % w.colors.length];
                    obj.cellClass = 'cell-sheet';
                    obj.cellStyle = function(params) {
                        let background;
                        let comp = c.split(' ')[0]
                        let max = w.maxRefVals && w.maxRefVals[c] ? w.maxRefVals[c] / 100 : 1
                        background = !isNaN(params.value) && params.value >= 0 ? w.colors[0] + Math.floor(parseFloat(((0.3 + (params.value / 100)) / (0.3 + max)).toFixed(2)) * 255).toString(16) : null;
                        background = !isNaN(params.value) && params.value >= 0 ? w.colors[0] + Math.floor(parseFloat((getLog(params.value + 7) / getLog(107)).toFixed(2)) * 255).toString(16) : null;
                        let color = !isNaN(params.value) && params.value >= 0 ? 'white' : 'gray';
                        return {
                            backgroundColor: background,
                            //backgroundColor: '#7372721d',
                            color: color,
                            fontWeight: 700,
                            textAlign: 'center'
                        }
                    };
                    columns.push(obj);
                })
                return columns;
            } else {
                var columns = null;
                return columns;
            }
        },
        refsData: function() {
            var w = this;
            if (w.chartRefs && w.chartRefs.components && w.chartRefs.samples && Array.isArray(w.chartRefs.samples)) {
                var json = w.chartRefs.samples
                let len = w.chartRefs.samples.length
                let rows = new Array(len - 1);
                for (let i = 0; i < len; i++) {
                    let p = w.chartRefs.samples[i]
                    var obj = {};
                    let profile = p[0]
                    obj.sample = profile.split(':').length > 1 ? `${profile.split(':')[1]} ( ${profile.split(':')[0]} )`.replace(/-raw/, '').replace(/_/g, ' ') : profile.replace(/-raw/, '').replace(/_/g, ' ')
                    //obj.distance = p.distance ? p.distance.toFixed(2) : undefined
                    let comp = w.chartRefs.components;
                    comp.forEach(function(n, i) {
                        obj[n] = p[i + 1] ? parseFloat(parseFloat(p[i + 1]).toFixed(2)) : 0
                    })
                    rows[i] = obj
                }
                return rows;
            } else {
                return []
            }
        },
        sheet: function() {
            var w = this;
            if (this.chartJSON) {
                var json = this.chartJSON;
                var rows = [];
                var calculator = w.calcArray[0].calculator
                let components = w.publicCalcs.find(x => x.calculator === calculator).components
                var columns = ['sample'].concat(components)
                rows.push(columns);
                json.forEach(function(p) {
                    var result = []
                    result.push(p.profile);
                    //result.push(p.distance);
                    components.map(n => {
                        var pct = p.result[n] ? p.result[n] : 0
                        result.push(pct)
                    })
                    rows.push(result)
                })
                return rows;
            } else {
                return null;
            }
        },
        pieOptions: function() {
            let w = this;
            if (w.calcArray && w.calcArray[0] && w.calcArray[0].label) {
                return {
                    title: {
                        text: w.calcArray[0].label,
                        textStyle: {
                            color: w.theme ? 'white' : 'black'
                        },
                        subtext: w.calcArray && w.calcArray[0] && w.calcArray[0].owner ? 'by ' + w.calcArray[0].owner : '',
                        left: 'center',
                    },
                    label: {
                        position: 'outer',
                        fontSize: 13,
                        color: w.theme ? 'silver' : 'gray',
                        fontWeight: 700,
                        formatter: params => params.value < 2 ? params.name.replace(/_/, ' ').replace(/-/, ' ') : params.value + ' %  ' + params.name.replace(/_/, ' ').replace(/-/, ' '),
                    },
                    color: w.newcolors,
                    tooltip: {
                        trigger: 'item',
                        formatter: params => `&nbsp;&nbsp;${params.value}&nbsp;%&nbsp;&nbsp;${params.name.replace(/_/, ' ').replace(/-/,' ')}&nbsp;&nbsp;&nbsp`,
                    },
                    toolbox: {
                        show: false,
                        feature: {
                            mark: {
                                show: false
                            },
                            dataView: {
                                show: true,
                                readOnly: false
                            },
                            magicType: {
                                show: false,
                                type: ['funnel']
                            },
                            restore: {
                                show: true
                            },
                            saveAsImage: {
                                show: true
                            }
                        }
                    },
                    series: [{
                        name: '',
                        type: 'pie',
                        height: 500,
                        radius: w.$isMobile ? [45, 90] : [50, 200],
                        top: 30,
                        bottom: 40,
                        center: ['50%', '50%'],
                        stillShowZeroSum: false,
                        selectedOffset: 0,
                        startAngle: 45,
                        roseType: 'radial',
                        label: {
                            show: true,
                            alignTo: 'none',
                            //alignTo: 'edge',
                        },
                        emphasis: {
                            label: {
                                show: true,
                                position: 'center'
                            }
                        },
                        data: w.pieSeries
                    }]
                }
            } else {
                return {}
            }

        },

    },
    watch: {
        datasearch: {
            handler() {
                this.searchCalcs()
            }
        }
    },
    data() {
        let w = this;
        return {
            configs: ["rawcalcfunction"],
            admixmounted: false,
            intro: null,
            chromo: false,
            selectedCalc: undefined,
            currentChartIndex: 0,
            searchQuery: '',
            calclength: 0,
            g25length: 0,
            calcCount: 0,
            rawArrayLocal: [],
            calcArray: [],
            rawcalcfunction: 'modal',
            resetfilter: 0,
            ldjson: {},
            G25: false,
            bodyReady: false,
            frameDisplay: 'none',
            embed: false,
            spacerHeight: 80,
            topics: {},
            initiated: false,
            debouncedSearchSamples: function() {
                return []
            },
            debouncedSearchGroups: false,
            filteredSamples: [],
            filteredGroupSamples: [],
            filterizr: undefined,
            calcCount: 0,
            datasearch: '',
            sortOrder: undefined,
            calcShuffle: false,
            activeIndex: 0,
            exporting: false,
            sortModel: 'rating',
            recalc: false,
            refs: false,
            calcReady: false,
            direction: 'rtl',
            refs: {
                samples: [],
                components: []
            },
            steps: [{
                    element: '#selectSamples',
                    intro: '<p class=introHeader>Click above to select a sample for running</p><p>Start typing to search for a specific sample',
                    sound: {
                        delay: 750,
                        media: ['https://static.genoplot.com/media/runcalc.step1.mp3']
                    },
                    tooltipClass: 'selectSamples',
                    action: 'activate'
                },
                {
                    element: '#calc-0',
                    intro: '<p class=introHeader>Select a Calculator</p><p>Example: 23andMe</p>',
                    sound: {
                        media: ['https://static.genoplot.com/media/runcalc.step2.mp3']
                    },
                    validate: function() {
                        if (!w.rawArray[0]) {
                            w.$stepAudio.play('https://static.genoplot.com/media/runcalc.error.v2.mp3', 50);
                            return {
                                status: false,
                                activate: 'leftSelectinput'
                            }
                        } else {
                            return {
                                status: true
                            }
                        }
                    }
                },
                {
                    element: '#runButton',
                    intro: '<p class=introHeader>Lets run the calculator</p><p>Click the Run button!</p>',
                    sound: {
                        media: ['https://static.genoplot.com/media/runcalc.step3.mp3']
                    },
                    tooltipClass: 'modal-input editModal-tooltip',
                    validate: function() {
                        if (!w.calcArray[0]) {
                            w.$stepAudio.play('https://static.genoplot.com/media/runstep.error.v2.mp3', 50);
                            return {
                                status: false
                            }
                        } else {
                            return {
                                status: true
                            }
                        }
                    }
                },
            ],
            introOptions: {
                "nextLabel": "Next &rarr;",
                "prevLabel": "&larr; Back",
                "skipLabel": "Cancel",
                "doneLabel": "Done",
                "hidePrev": false,
                "hideNext": false,
                "tooltipPosition": "bottom",
                "tooltipClass": "",
                "highlightClass": "",
                "exitOnEsc": true,
                "exitOnOverlayClick": false,
                "showStepNumbers": true,
                "keyboardNavigation": false,
                "showButtons": true,
                "showBullets": true,
                "showProgress": false,
                "scrollToElement": false,
                "scrollTo": "tooltip",
                "scrollPadding": 30,
                "overlayOpacity": 0.5,
                "positionPrecedence": [
                    "bottom",
                    "top",
                    "right",
                    "left"
                ],
                "disableInteraction": false,
                "helperElementPadding": 10,
                "hintPosition": "top-middle",
                "hintButtonLabel": "Got it",
                "hintAnimation": true,
                "buttonClass": "introjs-button"
            },
            ancient: 'false',
            publicSamplesG25: [],
            unchanged: false,
            calculator: true,
            userSeries: [],
            debug: false,
            lastShared: false,
            shareUrl: {},
            theme: false,
            component: 'admix',
            tipDisabled: false,
            mapReady: false,
            sunburstReady: false,
            drawer: false,
            //userSamples: [],
            map,
            collapsed: false,
            modes: [{
                    label: 'Global 25 (G25)',
                    value: 'G25'
                },
                {
                    label: 'Dodecad K12b',
                    value: 'K12b'
                },
                {
                    label: 'Dodecad Global 13',
                    value: 'globe13'
                },
                {
                    label: 'Dodecad Africa 9',
                    value: 'Africa9'
                },
                {
                    label: 'Eurogenes EU K13',
                    value: 'EUtest13'
                },
                {
                    label: 'Eurogenes Jewish K14',
                    value: 'Jtest14'
                },
                {
                    label: 'Eurogenes Global K36',
                    value: 'K36'
                },
                {
                    label: 'Harappa World',
                    value: 'HarappaWorld'
                },
                {
                    label: 'Lukas M K47',
                    value: 'K47'
                },
                {
                    label: 'MDLP K27',
                    value: 'MDLPK27'
                },
                {
                    label: 'Michal World K25',
                    value: 'MichalK25'
                },
                {
                    label: 'Tolan K18',
                    value: 'K18M4'
                }
            ],
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 10,
                freeMode: true,
            },
            sunOptions: {
                tooltip: {
                    trigger: 'item',
                    //formatter: '{b}: {c}%'
                    formatter: '&nbsp;{b}&nbsp;<br>&nbsp;<b>{c} %</b>'
                },
                itemStyle: {
                    emphasis: {
                        color: 'brown'
                    },
                    highlight: {
                        color: 'brown'
                    },
                    downplay: {
                        color: 'gray'
                    }
                },
                label: {
                    formatter: function(data) {
                        return data.data.value >= 1 ? `${data.data.name} ${data.data.value} % ` : ''
                    }
                },
                series: {
                    type: 'sunburst',
                    data: w.sunburstSeries,
                    highlightPolicy: 'self',
                    radius: [0, '90%'],
                    levels: [{}, {
                        r0: '20%',
                        r: '55%',
                        highlightPolicy: 'descendant',
                        itemStyle: {
                            borderWidth: 2,
                            opacity: 1,
                        },
                        label: {
                            show: true,
                            minAngle: 10,
                            fontSize: 15,
                            borderRadius: 9,
                            textShadowColor: '#333333',
                            textShadowBlur: 3,
                            textShadowOffsetX: 2,
                            textShadowOffsetY: 1,
                            padding: [7, 9],
                            rotate: 0,
                            color: 'white'
                        }
                    }, {
                        r0: '55%',
                        r: '72%',
                        label: {
                            position: 'outside',
                            minAngle: 5,
                            padding: 10,
                            borderRadius: 5,
                            fontSize: 13,
                            silent: true,
                            itemStyle: {
                                borderWidth: 2,
                            },
                            color: '#444',
                            rotate: 0,
                            distance: 30
                        }
                    }, {
                        r0: '72%',
                        r: '80%',
                        label: {
                            position: 'outside',
                            show: false,
                            minAngle: 5,
                            silent: false,
                            itemStyle: {
                                borderWidth: 2,
                            }
                        }
                    }]
                }
            },
            lswitches: {
                defaultOn: true,
                defaultOff: false,
                scaled: true,
                paidPlan: true,
                calculator: false,
                basePlan: false,
                custom: true,
                editPCA: false,
                ancient: false,
                removeOutliers: false,
                penalty: true,
                groupAveraged: false,
                groupMedian: false,
                optimaFit: false,
                groupSamples: false,
                lite: false,
            },
            initOptions: {
                renderer: 'canvas',
            },
            currentIndex: this.$store.getters.get('currentIndex'),
            gridKey: 0,
            progressStatus: "success",
            reqnum: 0,
            subResults: [],
            value: 45,
            max: 100,
            series2: [],
            filterResults: {},
            rowsSelected: false,
            barType: 'radialBar',
            chartHeight: 480,
            barHeight: 25,
            chartColors: [
                ["#1f78b4", "#a6cee3", "#33a02c", "#b2df8a", "#e31a1c", "#fb9a99", "#ff7f00", "#fdbf6f", "#6a3d9a", "#cab2d6", "#b15928", "#ffff99"],
                ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#676767"],
                ["#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#abdda4", "#66c2a5", "#3288bd"],
                ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
                ['#3b5998', '#F44336', '#828483', '#2e294e', '#1b998b', '#921236', '#e2c044', '#d7263d'],
                ['#a6611a', '#dfc27d', '#80cdc1', '#018571', '#d7191c', '#fdae61', '#a6d96a', '#1a9641']
            ],
            chartReady: false,
            saveLabel: this.loading === true ? '' : '',
            components: this.$store.getters.get('rawchartComponents') ? this.$store.getters.get('rawchartComponents') : [],
            size: 8,
            margin: 12,
            color: "white",
            cacheVersion: 0,
            maxSelects: 4,
            publicSamples: [],
            publicGroups: [],
            publicCalcsAdmix: [],
            publicCalcsG25: [],
            publicCalcs: [],
            scrollCalcs: [],
            scroller: 0,
            publicRawGroups: [],
            publicRawAncientGroups: [],
            userCalcs: [],
            schemaModelFields: {
                label: {
                    editable: false
                }
            },
            maxGroupExceeded: "",
            maxExceededMessage: "",
            multiselectValue: "",
            autocompleteValue: "",
            sampledata: this.$store.getters.get('rawchartSeries') ? this.$store.getters.get('rawchartSeries') : [],
            chartOptions: {
                plotOptions: {
                    radialBar: {
                        startAngle: 0,
                        endAngle: 270,
                        track: {
                            show: true,
                            background: '#a6a6a6',
                            opacity: 0.1
                        },
                        hollow: {
                            margin: 5,
                            size: '20%',
                            background: 'transparent',
                            image: undefined,
                        },
                        dataLabels: {
                            name: {
                                show: false,

                            },
                            value: {
                                show: false,
                            }
                        }
                    }
                },
                updated: Date.now(),
                colors: ['#1ab7ea', '#0084ff', '#39539E', '#0077B5'],
                labels: [1, 2, 3, 4],
                legend: {
                    show: true,
                    floating: true,
                    position: 'left',
                    labels: {
                        useSeriesColors: false,
                    },
                    markers: {
                        size: 2
                    },
                    format: function(seriesName, opts) {
                        if (seriesName.toString().substring(0, 4) === '<div') {
                            return opts.w.globals.series[opts.seriesIndex] ? ("<div class='result-tip'>" + opts.w.config.comps[opts.seriesIndex].replace(/_/g, " ") + "</div><b><div class='result-tip-value'>" + opts.w.globals.series[opts.seriesIndex].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>") : ("<div class='result-tip faded'>" + opts.w.config.comps[opts.seriesIndex].replace(/_/g, " ") + "</div><b><div class='result-tip-value faded'>" + opts.w.globals.series[opts.seriesIndex].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>")
                        } else {
                            return opts.w.globals.series[opts.seriesIndex] ? ("<div class='result-tip'>" + seriesName.replace(/_/g, " ") + "</div><b><div class='result-tip-value'>" + opts.w.globals.series[opts.seriesIndex].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>") : ("<div class='result-tip faded'>" + seriesName.replace(/_/g, " ") + "</div><b><div class='result-tip-value faded'>" + opts.w.globals.series[opts.seriesIndex].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>")
                        }
                    },
                    itemMargin: {
                        horizontal: 1,
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            height: 320
                        }
                    }
                }]
            },
            largeCalcs: [
                "TOLAND_RECENT_ANCESTORS_JEWS_V2",
                "TOLAN_RECENT_ANCESTORS_V2",
                "K35",
                "EUROGENESK36ANCIENT",
                "K36",
                "TOLAN_K54_V2",
                "TOLAN_K71_V2"
            ]
        }
    },
    beforeMount() {
        this.$toasted.clear()
        let w = this;
        w.rswitches = w.rswitches ? w.rswitches : {
            ...w.switches
        }
        this.gridOptions = {
            scrollbarWidth: 20,
            rowHeight: 30,
            suppressHorizontalScroll: false,
            enableBrowserTooltips: false,
            animateRows: false,
            pagination: this.rswitches.paginateResults ? true : false,
            paginationPageSize: 20,
            floatingFilter: this.rswitches.filterResults ? true : false,
            sortingOrder: ['desc', 'asc'],
            onFirstDataRendered: function(params) {},
            onModelUpdated: function(params) {
                setTimeout(function() {
                    params.api.sizeColumnsToFit();
                }, 100)
            },
            onGridReady: function(params) {
                window.addEventListener('resize', function() {
                    setTimeout(function() {
                        params.api.sizeColumnsToFit();
                    }, 500)
                })
            }
        }
        this.gridOptions2 = {
            animateRows: false,
            sortingOrder: ['desc', 'asc'],
            onFirstDataRendered: function(params) {},
            onModelUpdated: function(params) {
                setTimeout(function() {
                    params.api.sizeColumnsToFit();
                }, 100)
            },
            onGridReady: function(params) {
                window.addEventListener('resize', function() {
                    setTimeout(function() {
                        params.api.sizeColumnsToFit();
                    }, 500)
                    //w.debounce(params.api.sizeColumnsToFit(), 250)
                })
            }
        }
        this.refsGridOptions = {
            animateRows: false,
            sortingOrder: ['desc', 'asc'],
            onFirstDataRendered: function(params) {},
            onModelUpdated: function(params) {
                setTimeout(function() {
                    params.api.sizeColumnsToFit();
                }, 100)
            },
            onGridReady: function(params) {
                window.addEventListener('resize', function() {
                    setTimeout(function() {
                        params.api.sizeColumnsToFit();
                    }, 500)
                    //w.debounce(params.api.sizeColumnsToFit(), 250)
                })
            }
        }
    },
    beforeCreate() {},
    beforeDestroy() {
        if (typeof(admixworker) != 'undefined') {
            console.log('Terminating Admix worker')
            admixworker.terminate()
        }
        this.$store.commit('change', {
            topClass: false
        })
        let w = this;
        w.destroyIntro();
        this.$eventBus.$off('appEvents', this.appEvents)
        window.removeEventListener("resize", this.resizeEChart);
        if (this.scrollContainer && this.scrollContainer.id == 'app') {
            this.scrollContainer.removeEventListener('scroll', w.handleScroll);
        } else {
            window.removeEventListener('scroll', w.handleScroll);
        }
        if (w.addrawfile) {
            w.addrawfile.el.removeEventListener('click', w.addSample)
            w.addrawfile.goAway()
            delete w.addrawfile;
        }
        window.removeEventListener('message', this.handleFrameMessage)
        window.onpopstate = () => {}
    },
    created: async function() {
        let w = this;
        w.debouncedSearchSamples = debounce(w.searchSamples, 250)
        w.debouncedSearchGroups = debounce(w.searchGroups, 250)
        let sharedmode;
        if (window.location.search && window.location.search.substr(0, 11) == '?calculator') {
            let shared = decodeURI(window.location.search.replace(/\?calculator=/, ''))
            if (shared.split('&mode=').length > 1) {
                let calculator = shared.split('&mode=')[0]
                sharedmode = shared.split('&mode=')[1]
                w.sharedcalc = calculator
            }
        }
        let name = w.user ? w.user.username + ':' + 'G25calc' : false
        let G25calc = sharedmode && sharedmode == 'g25' ? true : name ? localStorage.getItem(name) : false
        if (G25calc) {
            w.G25calc = true;
            w.G25 = true;
            if (w.rawArrayLocal && w.rawArrayLocal[0] && (w.rawArrayLocal[0].type != 'G25' || !w.rawArrayLocal[0].type)) w.resetSamples()
        } else {
            w.G25calc = false;
            w.G25 = false;
            if (w.rawArrayLocal && w.rawArrayLocal[0] && (w.rawArrayLocal[0].type != 'RAW')) w.resetSamples()
        }
        this.filteredOptions = []
        this.userSamples = [];
        w.calcCount = 0;
        w.selectedCalc = undefined;
        w.calclength = 0;
        w.spinner = true;
        if (w.user && w.user.username) w.init(true);
        w.saveReady2 = false;
        w.initiated = false;
        var collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base'
        });
        w.$store.commit('change', {
            admixLoaded: true
        })
        w.progress = 0;
        w.recalc = false;
        w.simrun = false;
        w.activePath = false;
        w.mapReady = false;
        let theme = localStorage.getItem('genoTheme');
        window.__GenoStart = Date.now()
    },
    mounted: async function() {
        let w = this;
        console.log(`Admix Mount started ${Date.now() - routeStart} ms`)
        w.switches.scaled = true;
        w.syncStore('switches.scaled')
        console.log('adding scroller')
        w.$nextTick(() => {
            this.scroller = 0;
            this.scrollContainer = detectScrollContainer(document.getElementById('calcHolder'));
            if (this.scrollContainer && this.scrollContainer.id == 'app') {
                this.scrollContainer.addEventListener('scroll', w.handleScroll);
            } else {
                this.scrollContainer = document.querySelector('html')
                window.addEventListener('scroll', w.handleScroll);
            }
        })
        requestIdleCallback(async () => {
            let currentDT = Math.floor(Date.now() / 1000)
            let cache = typeof(cache) !== 'undefined' ? cache : localStorage.getItem('cacheVer') ? JSON.parse(localStorage.getItem('cacheVer')) : {
                groups: {
                    g25: currentDT
                },
                samples: currentDT,
                tos: 0,
                calcVersion: currentDT
            }
            var UTF8to16 = function(convertMe) {
                var out = "";
                for (var i = 0; i < convertMe.length; i += 2) {
                    var charCode = convertMe.charCodeAt(i) * 256;
                    charCode += convertMe.charCodeAt(i + 1);
                    out += String.fromCharCode(charCode);
                }
                return out;
            }
            var queryParam = '?v=0.'
            setTimeout(() => {
                w.spinner = false;
            }, 3000)
            w.toggleTheme()
            w.$store.commit('change', {
                topClass: false
            })
            window.onpopstate = () => w.popState()
            w.recalc = false;
            w.chartReady = false;
            w.$eventBus.$on('appEvents', w.appEvents)
            w.embed = false
            console.log('version:', w.$genoVer);
            window.addEventListener('message', w.handleFrameMessage)
            w.$store.commit('change', {
                admixLoaded: true
            })
            w.progress = 0;
            w.recalc = false;
            w.simrun = false;
            w.activePath = false;
            w.lastMarkerState = false;
            w.exporting = false;
            w.activeName = false;
            w.activeContent = false;
            w.sortOrder = w.sortOrder ? w.sortOrder : 'desc'
            w.mapReady = false;
            w.mode = 'RAW'
            let theme = localStorage.getItem('genoTheme');
            let sunOptions = w.sunOptions;
            let levels = sunOptions.series.levels;
            if (theme && theme == 'dark') {
                w.theme = true;
                levels[2].label.color = '#f2f2f2'
            } else {
                levels[2].label.color = '#444'
            }
            w.sunOptions = sunOptions;
            window.addEventListener("resize", w.resizeEChart);
            var key = w.$store.getters.get('rawchartKey')
            var json = w.$store.getters.get('rawchartJSON')
            if (key && json && json.length > 0 && w.calcArray[0]) {
                //w.processJSON(key)
            } else {
                w.$store.commit('change', {
                    spinner: false
                })
            }
            if (w.G25calc) {
                //w.setCalcSettings();
            }
            var stage = w.$store.getters.get('env') === 'production' ? '' : 'staging/';
            w.publicRawGroups = window.g25cache && window.g25cache.getRawGroups ? window.g25cache.getRawGroups : await this.$dbCache.getRawGroups(cache, 'calculators', stage)
            w.publicRawAncientGroups = window.g25cache && window.g25cache.getRawAncientgroups ? window.g25cache.getRawAncientgroups : await this.$dbCache.getRawAncientgroups(cache, 'calculators', stage)
            let publicCalcsG25 = window.g25cache && window.g25cache.getCalculators ? window.g25cache.getCalculators : await this.$dbCache.getCalculators(cache, 'calculators', stage)
            publicCalcsG25 = publicCalcsG25.filter(x => x.type == 'G25' || !x.type)
            w.calcCountG25 = publicCalcsG25.length;
            publicCalcsG25 = publicCalcsG25.slice(0, 40)
            w.publicCalcsG25 = JSON.parse(JSON.stringify(publicCalcsG25))
            //w.publicCalcsG25 = Object.freeze(publicCalcsG25.map ( x => { return {owner: x.owner, calculator: x.calculator, image: x.image }}))
            console.log('calcs', w.publicCalcsG25.length);

            let publicCalcsAdmix = window.g25cache && window.g25cache.getAdmixCalculators ? window.g25cache.getAdmixCalculators : await this.$dbCache.getAdmixCalculators(cache, 'calculators', stage)
            w.calcCountAdmix = publicCalcsAdmix.length;
            publicCalcsAdmix = publicCalcsAdmix.slice(0, 40)
            w.publicCalcsAdmix = JSON.parse(JSON.stringify(publicCalcsAdmix));
            console.log('Starting to run', Date.now() - window.__GenoStart)
            if (w.sharedcalc) {
                w.datasearch = `"${w.sharedcalc}"`
                w.setCalcType()
            } else {
                if (!w.calcReady) w.setCalcType(true)
            }
            w.publicGroupsG25 = window.g25cache && window.g25cache.getG25Groups ? window.g25cache.getG25Groups : await this.$dbCache.getG25Groups(cache, 'calculators', stage).then(str => {
                w.publicGroupsG25 = str
            })
            console.log('getting cache', cache)
            let cstart = Date.now()
            w.publicSamplesG25 = window.g25cache && window.g25cache.getSampleGroups ? window.g25cache.getSampleGroups : await this.$dbCache.getSampleGroups(cache, 'calculators', stage)
            let customGroups = []
            w.publicSamplesG25.forEach(x => {
                let indexes = []
                x.samples.map((sample, i) => {
                    if (sample.customgroup) {
                        indexes.push(i)
                        let customIndex = customGroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                        if (customIndex >= 0) {
                            customGroups[customIndex].samples.push(sample)
                        } else {
                            customGroups.push({
                                group: sample.customgroup + ' [' + sample.group + ']',
                                label: sample.customgroup + ' [' + sample.group + ']',
                                customgroup: sample.customgroup,
                                type: sample.mode,
                                samples: [sample]
                            })
                        }
                    }
                })
                if (indexes.length > 0) {
                    x.samples = x.samples.filter((value, index) => indexes.indexOf(index) == -1)
                }
            })
            w.customGroupsG25 = customGroups
            console.log('got cache', `${Date.now() - cstart} ms`)
            w.publicRawGroupsG25 = window.g25cache && window.g25cache.getRawGroupsCache ? window.g25cache.getRawGroupsCache : await this.$dbCache.getRawGroupsCache(cache, 'calculators', stage)
            w.publicRawSamplesG25 = window.g25cache && window.g25cache.getRawGroupedSamplesCache ? window.g25cache.getRawGroupedSamplesCache : await this.$dbCache.getRawGroupedSamplesCache(cache, 'calculators', stage)
            if (typeof(admixworker) != 'undefined') {
                admixworker.status()
            }
            window.__GenoStart = Date.now()
            w.resetSamples()
            console.log(`Admix Mount finished ${Date.now() - routeStart} ms`)
            w.admixmounted = true;
            if (w.newUser) {
                w.startTour()
            }
            //w.getCalcs()
        })
    },
    components: {
        [Button.name]: Button,
        [Checkbox.name]: Checkbox,
        TransitionExpand,
        SamplesModal,
        CalcSamplesModal,
        CheckFitsModal,
        OraclesModal,
        GetKeyModal,
        EditSamplesModal,
        AgGridVue,
        rightpanel,
        //'slideout-panel':VueSlideoutPanel,
        CollapseItem,
        Collapse,
        Tabs,
        TabPane,
        [Switch.name]: Switch,
        VueSlider,
        Social
    },
    directives: {
        'dragscroll': dragscroll
    },
    methods: {
        setChromo(evt) {
            console.log('chromo', evt)
        },
        forceWarmup(url) {
            let w = this;
            if (w.splayer) {
                w.splayer.pause()
                w.splayer.currentTime = 0;
                delete w.splayer;
            }
            const a = new Audio();
            a.src = url;
            a.muted = true;
            a.play().then(() => {
                console.log('playing')
            }).catch((err) => {
                console.log('audio', err)
            }); // ignore autoplay block
        },
        destroyIntro() {
            let w = this;
            if (w.$intro) {
                w.$intro.onchange(() => {});
                w.$intro.onbeforechange(() => {});
                w.$intro.oncomplete(() => {});
                w.$intro.onexit(() => {});
                w.$intro.exit();
                w.$intro._options = w.introOptions;
                w.$intro._currentStep = undefined;
            }
        },
        startTour() {
            let w = this;
            let buttons = [{
                    title: 'Yes',
                    default: true,
                    handler: async () => {
                        w.$stepAudio.unlockAudioContext()
                        w.$stepAudio.play('https://static.genoplot.com/media/runcalc.step1.mp3', 11);
                        let g25 = w.G25
                        if (g25) w.spinner = true
                        w.G25 = false;
                        w.changeCalcType(true);
                        setTimeout(() => {
                            w.$nextTick(() => {
                                w.editSamples('addhelp')
                                w.$modal.hide('dialog');
                            })
                            w.spinner = false;
                        }, g25 ? 500 : 50)
                    } // Button click handler
                },
                {
                    title: 'No',
                    handler: () => {
                        w.$modal.hide('dialog');
                    } // Button click handler
                }
            ]
            this.$modal.show('dialog', {
                title: ' ',
                text: '<p style="font-size: 1.3em;font-weight:700;">Would you like to upload your DNA file?</p>',
                class: 'alert green',
                buttons: buttons
            })
        },
        welcomeTour(intro) {
            this.$stepAudio.unlockAudioContext()
            this.$stepAudio.play('https://static.genoplot.com/media/runcalc.step1.mp3', 11);
            let w = this;
            let evt = 'collapse-select';
            this.$root.$emit(evt, 'activate');
            w.$intro.setOptions({
                scrollToElement: false,
                doneLabel: 'Close',
                showBullets: false,
                steps: w.steps
            })
            setTimeout(() => {
                w.$intro.onafterchange(function(targetElement) {
                    let step = targetElement.dataset.step
                    if (w.splayer) {
                        w.splayer.stop();
                    }
                });
                w.$intro.onbeforechange(function(targetElement) {
                    if (w.splayer) {
                        w.splayer.stop();
                    }
                    let el = targetElement.id;
                    let stepindex = w.steps.findIndex(x => x.element == `#${el}`)
                    let step = w.steps[stepindex]
                    if (step && step.validate) {
                        let response = step.validate()
                        if (response && response.activate) {
                            setTimeout(() => {
                                w.$refs[response.activate].activate()
                            }, 50)
                        }
                        return response && response.status ? undefined : false
                    }
                });
                w.$intro.onexit(function(targetElement) {
                    if (w.splayer) {
                        w.splayer.stop()
                        w.splayer.currentTime = 0;
                        delete w.splayer;
                    }
                })
                w.$intro.onchange(function(targetElement) {
                    let el = targetElement.id;
                    let stepindex = w.steps.findIndex(x => x.element == `#${el}`)
                    let step = w.steps[stepindex]
                    if (step && step.sound) {
                        w.splayer = w.$stepAudio;
                        let delay = step.sound.delay ? step.sound.delay : 500;
                        w.$stepAudio.play(step.sound.media, delay);
                    }
                    if (step && step.function) {
                        step.function()
                    }
                    if (step && step.action) {
                        if (step.action == 'activate') {
                            setTimeout(() => {
                                w.$refs.leftSelectinput.activate()
                            }, 50)
                        }
                    }
                })
                w.$nextTick(() => {
                    w.$intro.start();
                })
            }, 50)
        },
        async runAnalyzeResults() {
            this.recordEvent('analyzeButton', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            if (this.gridApi && this.gridApi.getSelectedRows && this.gridApi.getSelectedRows() && this.gridApi.getSelectedRows().length) {
                let selectedRows = this.gridApi.getSelectedRows();
                let chartindex = 0;
                chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '').replace(/_/g, ' ')} (${x.alias.split(':')[0]})`.trim() == selectedRows[0].originalsample.replace(/_/g, ' ').trim())
                this.currentChartIndex = chartindex;
            } else {
                let profile = this.categories[this.currentIndex]
                let chartindex = 0;
                chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '')} (${x.alias.split(':')[0]})`.trim() == this.categories[this.currentIndex].replace(/-raw/, '').trim())
                this.currentChartIndex = chartindex;
            }
            this.currentChartIndex = this.currentChartIndex >= 0 ? this.currentChartIndex : 0;
            await analyzeResults(this, invokeAnalyzeResults, 'admix')
        },
        onAllTransitionsFinished() {
            this.spinner = false;
        },
        setCalcFilter(owner, index) {
            this.setActive(index);
            if (this.datasearch && this.datasearch.length >= 4) {
                this.scrollCalcs = owner == 'ALL' ? this.updateCount() : this.lastSearch && this.lastSearch.datasearch == this.datasearch && this.lastSearch.results && this.lastSearch.results.length ? this.lastSearch.results.filter(x => x.owner == owner) : this.scrollCalcs.filter(x => x.owner == owner)
                this.calcCount = this.scrollCalcs.length
            } else {
                if (owner == 'ALL') {
                    this.scroller = 0;
                    this.getCalcs()
                    this.calcCount = this.G25 ? this.calcCountG25 : this.calcCountAdmix;
                } else {
                    this.scroller = 0;
                    this.calcSearch(owner)
                }
            }
        },
        async updateCount(active) {
            let retvalue = await new Promise((resolve, reject) => {
                window.debounceTimeout = this.G25 ? 2000 : 1000
                this.debounced(this.datasearch, resolve, reject, active)
            });
        },
        calcSearch: async function(owner) {
            let w = this
            w.lastSearch = {}
            let value = w.datasearch;
            if (!owner && (!value || value.length < 4 && w.lastSortOrder != w.sortOrder && w.lastSortModel != w.sortModel)) {
                w.sortCalcs()
            } else {
                if (value && value.length) {
                    this.activeIndex = 0;
                }
                if (value && value.length >= 4 || owner) {
                    let sortModel = w.sortModel == 'name' ? 'calculator' : w.sortModel
                    let results = await this.$worker.postMessage({
                        action: 'searchCalcs',
                        data: {
                            input: this.datasearch.replace(/%2F/g, '/').replace(/ /g, '').trim(),
                            owner: owner,
                            sortOrder: w.sortOrder,
                            sortModel: sortModel,
                            dataset: w.G25 ? 'getCalculators' : 'getAdmixCalculators'
                        }
                    })
                    console.log('searching!!!!', owner, value, results)
                    w.activeItemIndex = false;
                    w.scrollCalcs = results && results.result ? results.result : []
                    if (w.activeIndex === 0) w.lastSearch = {
                        datasearch: w.datasearch,
                        results: results.result || []
                    }
                    w.calcCount = w.scrollCalcs.length;
                } else if (w.lastSortOrder != w.sortOrder && w.lastSortModel != w.sortModel) {
                    w.sortCalcs()
                }
            }
        },
        searchCalcs: debounce(async function(owner) {
            this.calcSearch(owner)
        }, 500),
        debounced: throttle(function(value, resolve, reject, active) {
            let w = this;
            if (!value || value && value.length < 4 && w.lastSortOrder != w.sortOrder && w.lastSortModel != w.sortModel) {
                w.aliasError = 'name needs to be at least 4 characters long with no spaces'
                w.sortCalcs()
                resolve(false)
            } else {
                let string = value.toLowerCase().trim()
                let calcs = w.publicCalcs.filter(x => x.label.toLowerCase().trim() == string || x.refs && x.refs.toLowerCase().includes(string))
                w.activeItemIndex = false;
                w.scrollCalcs = calcs;
                if (active && w.scrollCalcs.length) this.activeItemIndex = 0;
                w.calcCount = calcs.length;
                resolve(calcs.length)
            }
        }, window.debounceTimeout || 1000),
        async getCalcs(owner) {
            let w = this;
            let index = this.scroller;
            if (index == 0) {
                this.scrollCalcs = []
                this.calcReady = false;
                if (w.datasearch && w.datasearch.length > 3) {
                    this.updateCount()
                    return;
                }
            }
            index = owner ? 0 : index;
            if (!w.calclength || w.scroller < w.calclength) {
                try {
                    let sortModel = w.sortModel == 'name' ? 'calculator' : w.sortModel
                    let results = await this.$worker.postMessage({
                        action: 'addCalcs',
                        data: {
                            index: index,
                            length: 40,
                            sortOrder: w.sortOrder,
                            sortModel: sortModel,
                            owner: owner,
                            dataset: w.G25 ? 'getCalculators' : 'getAdmixCalculators'
                        }
                    })
                    if (results && results.result) {
                        let calcs = results.result.data;
                        this.scrollCalcs = this.scrollCalcs.concat(calcs)
                        this.scroller = results.result.next ? index + 40 : results.result.length
                        this.calclength = results.result.length;
                        if (index == 0) this.calcReady = true;
                    }
                } catch (err) {}
            }
        },
        handleScroll: debounce(function() {
            if (this.datasearch && this.datasearch.length >= 4 || this.activeIndex > 0) {
                return;
            }
            let scrollHeight = this.scrollContainer.scrollHeight
            let scrollValue = this.scrollContainer.scrollTop || 0
            let maxHeight = scrollHeight - window.document.documentElement.clientHeight
            let offset = this.scrollContainer && this.scrollContainer.id == 'app' ? 1200 : 4000;
            //console.log('scrolling', offset,  scrollHeight, scrollValue, maxHeight, maxHeight - offset);
            if (scrollHeight && scrollValue && maxHeight) {
                if (scrollValue >= maxHeight - offset) {
                    //console.log('scroller', scrollValue, scrollHeight, maxHeight, scrollHeight >= maxHeight)
                    if (!this.datasearch && (!this.calclength || this.scroller < this.calclength)) {
                        this.getCalcs()
                    }
                }
            }
        }, 200),
        runModerns(el) {
            var w = this;
            var evt = 'collapse-select';
            setTimeout(() => {
                w.$root.$emit(evt, 'collapse');
            }, 0)
            let customSampleArr = [];
            if (el == 'quickselect' && w.csv && w.customSampleCount > 0) {
                try {
                    let csv = w.csv.split('\n').filter(x => x != '')
                    csv.map(sample => {
                        customSampleArr.push({
                            sample: 'Custom:' + sample.split(',')[0].split(':').reverse()[0],
                            coords: sample.split(',').slice(-25).join(',')
                        })
                    })
                } catch (err) {
                    console.log(err);
                }
            }
            w.$store.commit('change', {
                spinner: true
            })
            let fullsample
            let index = w.currentIndex ? w.currentIndex : 0
            if (customSampleArr.length) {
                let index = 0;
                let element = this.$refs.quickselect
                if (element) {
                    let linenumber = element.value.substr(0, element.selectionStart).split("\n").length
                    index = linenumber && linenumber > 0 && customSampleArr[linenumber - 1] ? linenumber - 1 : 0
                }
                fullsample = {
                    group: customSampleArr[index].sample.split(':')[0],
                    sample: customSampleArr[index].sample.split(':')[1],
                    coords: customSampleArr[index].coords
                };
            } else if (el.option) {
                fullsample = el.option
            } else {
                if (w.sampleArray && w.sampleArray.length > 0 && w.sampleArray.find(x => x.index === w.categories[index].replace(/ ► /g, ':'))) {
                    fullsample = w.sampleArray.find(x => x.index === w.categories[index].replace(/ ► /g, ':'))
                } else {
                    fullsample = w.allSamples.find(x => x.index === w.categories[index].replace(/ ► /g, ':'))
                }
            }
            if (!this.onLine) {
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: 'Application offline',
                        text: 'Please re-run when the application is connected to the internet'
                    }
                });
                return false;
            }
            var subId = this.$store.getters.get('user').username + ':' + this.queryTimeStamp;
            var eta = 2000
            console.log(`ETA for query is ${Math.round(eta/1000)} seconds`);
            let execArray = ['allModernAverages', 'customUsers', 'allAncientAverages']
            let results = []
            let nearest = []
            this.recordEvent('getSampleInfo', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            async function getModerns() {
                w.start = Date.now()
                const fitsArr = execArray.map(async calc => {
                    try {
                        var subId = w.$store.getters.get('user').username + ':' + w.queryTimeStamp;
                        let checkfit = w.resources.checkfit[w.subType]
                        let params = {
                            sub: subId,
                            calculator: calc,
                            raw: false,
                            coords: fullsample.coords ? fullsample.coords : undefined,
                            scaled: true,
                            creator: 'internalGenoplot'
                        }
                        params.sample = fullsample.group + ':' + fullsample.sample
                        params.sample = fullsample.v ? params.sample.split(':')[0] + '|' + fullsample.v + ':' + params.sample.split(':')[1] : params.sample
                        //console.log('calling jsfit', getFitsQuery,  params);
                        const data = await w.$apollo.query({
                            query: getFitsQuery,
                            variables: {
                                params: JSON.stringify(params)
                            }
                        })
                        if (data && data.data && data.data.getFits && data.data.getFits.nearest) {
                            nearest = JSON.parse(data.data.getFits.nearest)
                            nearest = nearest.map((x, i) => {
                                let sample = x.sample == 'Average' ? x.group : x.sample
                                sample = x.ethnicity && x.ethnicity != 'Sindhi' ? `${sample} (${x.ethnicity})` : x.origin ? `${sample} (${x.origin})` : x.sample == 'Average' ? sample : `${x.sample} (${x.group})`
                                return {
                                    ...x,
                                    ...{
                                        index: i,
                                        _row: sample,
                                        sample: sample
                                    }
                                }
                            })
                            results.push({
                                calc: calc,
                                nearest: nearest
                            })
                        }
                        w.progress = 0;
                    } catch (err) {
                        console.log(err);
                        var error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                        w.$eventBus.$emit('appEvents', {
                            exec: 'setError',
                            component: 'nav',
                            params: error
                        })
                    }
                })
                try {
                    const fits = await Promise.all(fitsArr);
                    w.$store.commit('change', {
                        spinner: false
                    })
                    if (results.length > 0) {
                        setTimeout(() => {
                            w.$modal.show('checkfits', {
                                results: {
                                    sample: fullsample,
                                    nearest: results
                                },
                            });
                        }, 300)
                    }
                } catch (err) {
                    console.log(err)
                    w.$store.commit('change', {
                        spinner: false
                    })
                }
            }
            getModerns();
        },
        getSampleDetail(option) {
            let w = this;
            let name = option.label ? option.label : w.customSample(option)
            let description = option.description || false
            let ethnicity = option.ethnicity || false
            if (option.origin) ethnicity = ethnicity ? ethnicity + ' from ' + option.origin : option.origin
            let detail = `${name}<br>${description ? description + '<br>' : ''}${ethnicity || ''}`
            return detail
        },
        selectElementContents: function(el) {
            var range = document.createRange();
            range.selectNodeContents(el);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        },
        getInitialColorMode(value) {
            const persistedColorPreference = value == 'system' ? false : value
            const hasPersistedPreference = typeof persistedColorPreference === 'string';
            if (hasPersistedPreference) {
                this.setColors(persistedColorPreference)
                return persistedColorPreference;
            }
            const mql = window.matchMedia('(prefers-color-scheme: dark)');
            const hasMediaQueryPreference = typeof mql.matches === 'boolean';
            if (hasMediaQueryPreference) {
                this.setColors(mql.matches ? 'dark' : 'light')
                return mql.matches ? 'dark' : 'light';
            }
            this.setColors('light')
            return 'light';
        },
        setColors(value) {
            if (value == 'dark') {
                document.documentElement.style.setProperty('--bg-color', '#181818');
                document.documentElement.style.setProperty('--color', '#dfdfdf');
            } else {
                document.documentElement.style.setProperty('--bg-color', '##f2f2f2');
                document.documentElement.style.setProperty('--color', '#444444');
            }
        },
        toggleTheme() {
            let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
            this.syncStore('slider.theme.' + value)
            let genoTheme = this.getInitialColorMode(value)
            console.log('teheme', genoTheme)
            localStorage.setItem("genoTheme", genoTheme);
            this.theme = genoTheme && genoTheme == 'dark' ? true : false;
            let wn = document.getElementById('discussionframe')
            if (wn && wn.contentWindow) {
                wn = wn.contentWindow
                if (value == 'system') {
                    wn.postMessage({
                        action: 'removeStorage',
                        content: {
                            key: 'genoTheme'
                        },
                        source: 'genoplot.com'
                    }, '*')
                } else {
                    wn.postMessage({
                        action: 'setStorage',
                        content: {
                            key: 'genoTheme',
                            value: genoTheme
                        },
                        source: 'genoplot.com'
                    }, '*')
                }
            }
            this.currentShare = false;
            let sunOptions = this.sunOptions;
            let levels = sunOptions.series.levels;
            this.sunOptions = sunOptions;
            const el = document.body;
            if (el.classList.contains('dark') && genoTheme != 'dark') {
                el.classList.remove('dark')
            } else if (genoTheme == 'dark') {
                el.classList.add('dark')
            }
        },
        getFrameSource: async function() {
            let w = this;
            return new Promise((resolve, reject) => {
                let img = new Image()
                img.onload = () => {
                    console.log('img ping worked')
                    resolve(true)
                }
                img.onerror = (err) => {
                    console.log('img ping failed')
                    reject(true)
                }
                img.async = true
                img.src = w.$store.getters.get('env') === 'stagingT' ? "https://devdiscuss.genoplot.com/assets/images/ping.png?iframe=" + Date.now() : "https://discussions.genoplot.com/assets/images/ping.png?iframe=" + Date.now()
            })
        },
        handleFrameMessage: function(message) {
            let w = this;
            if (message && message.data && message.origin.slice(-12) == 'genoplot.com') {
                if (message.data.from == 'discussions' && message.data.event == 'action' && message.data.action && message.data.component) {
                    w.execFunc({
                        exec: message.data.action,
                        component: message.data.component,
                        params: message.data.params || undefined
                    })
                }
                if (message.data.source == 'genoplot' && message.data.event == 'iframedError') {
                    console.log(message.data);
                }
            }
        },
        execFunc(remoteFunc) {
            if (remoteFunc.exec == 'navigate' && remoteFunc.component == 'discussions') {
                this.$router.push(remoteFunc.params)
            } else {
                this.$eventBus.$emit('appEvents', remoteFunc)
            }
        },
        showDetails(slug) {
            console.log('showing ' + slug);
            this.spinner = true
            this.maintenance = false;
            this.embed = true
            //let url =  this.$store.getters.get('env') === 'staging' ? `https://devdiscuss.genoplot.com/topic/${slug}?iframe=true&embedded=true` :  `https://discussions.genoplot.com/topic/${slug}?iframe=true&embedded=true` 
            let qs = `?iframe=true&embedded=true`
            let theme = this.$store.getters.get('slider')['theme'] ? this.$store.getters.get('slider')['theme'].value : 'system'
            qs = qs + `&theme=${theme}`
            let url = this.$store.getters.get('env') === 'stagingT' ? `https://devdiscuss.genoplot.com/topic/${slug}${qs}` : `https://discussions.genoplot.com/topic/${slug}${qs}`
            this.getFrameSource().then(() => {
                this.src = url
                this.showshare = true;
            }).catch(err => {
                this.spinner = false;
                this.maintenance = true;
                this.showshare = true;
            })
        },
        simpleCoverage(index) {
            if (this.chartJSON && this.chartJSON[index] && this.chartJSON[index].stats) {
                let stats = this.chartJSON[index].stats
                let matches = stats.matches
                let total = stats.snps
                let percentage = (matches / total * 100).toFixed(2) + '%'
                return percentage
            } else {
                return false
            }
        },
        fullScreenGrid(event) {
            if (event && event == 'full') {
                this.$store.commit('change', {
                    topClass: true
                })
                let header = document.querySelector('body #app #page .ag-theme-balham.rotated .ag-header')
                let header2 = document.querySelector('body #app #page .ag-theme-balham .ag-header')
                let height
                if (header) {
                    height = (header.offsetHeight);
                    header.style.setProperty('--mainHeaderSpacer', (186 - height) + 'px')
                } else {
                    height = 131
                    header2.style.setProperty('--mainHeaderSpacer', (186 - height) + 'px')
                }
            } else {
                this.fullScreen = false;
                this.$store.commit('change', {
                    topClass: false
                })
            }
            console.log(event)
        },
        resetOptions() {
            this.filteredSamples = []
            this.filteredGroupSamples = []
        },
        searchGroups: function(input) {
            let search = input.toLowerCase();
            let result = this.groupOptions.filter(y => (y.label && y.label.toLowerCase().includes(search)) || (y.origin && y.origin.toLowerCase().includes(search)))
            this.filteredGroupSamples = result;
            return result;
        },
        searchSamples: function(input) {
            let search = input.toLowerCase();
            let w = this;
            if (this.G25calc) {
                if (this.G25calc && this.userSamples && this.userSamples[0] && this.userSamples[0].samples) {
                    let publicSamples = this.publicSamplesG25.filter(x => x.group !== this.userSamples[0].group)
                    let userSamples = JSON.parse(JSON.stringify(this.userSamples[0]))
                    userSamples.samples = userSamples.samples.filter(x => x.sample.indexOf('Average') < 0 && x.sample.indexOf('Median') < 0 && !x.customgroup)
                    let customgroups = userSamples.samples.length > 0 ? [userSamples] : []
                    this.userSamples[0].samples.map(sample => {
                        if (sample.customgroup) {
                            let customIndex = customgroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customgroups[customIndex].samples.push(sample)
                            } else {
                                customgroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    customgroup: sample.customgroup,
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    let options = customgroups.concat(publicSamples)
                    /*
                    let array = JSON.parse(JSON.stringify(options))
                    const newoptions = []
                    array.forEach(group => {
                        let samples = group.samples.filter(y => (y.customgroup && y.customgroup.toLowerCase().includes(search)) || (y.index && y.index.toLowerCase().includes(search)) || (y.origin && y.origin.toLowerCase().includes(search)))
                        if (samples.length > 0) {
                            group.samples = samples
                            newoptions.push(group)
                        }
                    })
                    */
                    const {
                        filteredData,
                        filterString
                    } = filterData(search, options, 'refs', 'samples');
                    this.filteredOptions = filteredData.length ? filteredData.slice(0, 1000) : [{
                        empty: true
                    }]
                } else {
                    let options = this.publicSamplesG25
                    /*
                    let array = JSON.parse(JSON.stringify(options))
                    const newoptions = []
                    array.forEach(group => {
                        let samples = group.samples.filter(y => (y.index && y.index.toLowerCase().includes(search)) || (y.origin && y.origin.toLowerCase().includes(search)))
                        if (samples.length > 0) {
                            group.samples = samples
                            newoptions.push(group)
                        }
                    })
                    */
                    const {
                        filteredData,
                        filterString
                    } = filterData(search, options, 'refs', 'samples');
                    console.log('filterString', filterString);
                    this.filteredOptions = filteredData.length ? filteredData.slice(0, 1000) : [{
                        empty: true
                    }]
                }
            } else if (this.rswitches.ancient) {
                let options = this.publicRawAncientGroups
                /*
                let array = JSON.parse(JSON.stringify(options))
                const newoptions = []
                array.forEach(group => {
                    let samples = group.samples.filter(y => (y.index && y.index.toLowerCase().includes(search)) || (y.origin && y.origin.toLowerCase().includes(search)))
                    if (samples.length > 0) {
                        group.samples = samples
                        newoptions.push(group)
                    }
                })
                this.filteredOptions = newoptions.slice(0, 1000)
                */
                const {
                    filteredData,
                    filterString
                } = filterData(search, options, 'refs', 'samples');
                this.filteredOptions = filteredData.length ? filteredData.slice(0, 1000) : [{
                    empty: true
                }]
            } else {
                w.addSample = function() {
                    w.editSamples('add');
                }
                let samples = this.sampleJSON.filter(x => x.samples.filter(y => y.mode === this.mode || y.type === this.mode).length > 0)
                let allsamples = samples.concat(this.publicRawGroups)
                if (this.initiateda && !this.addrawfile && samples.length == 0) {
                    this.addrawfile = this.$toasted.show('Click here to add Raw DNA files', {
                        position: 'top-left',
                        duration: null,
                        containerClass: 'addrawfile',
                        className: 'infoToast',
                        theme: 'bubble',
                    })
                    this.addrawfile.el.addEventListener('click', w.addSample)
                } else if (w.addrawfile && samples.length > 0) {
                    w.addrawfile.el.removeEventListener('click', w.addSample)
                    w.addrawfile.goAway()
                    delete w.addrawfile;
                }
                let options = allsamples
                /*
                let array = JSON.parse(JSON.stringify(options))
                const newoptions = []
                array.forEach(group => {
                    let samples = group.samples.filter(y => (y.index && y.index.toLowerCase().includes(search)) || (y.origin && y.origin.toLowerCase().includes(search)))
                    if (samples.length > 0) {
                        group.samples = samples
                        newoptions.push(group)
                    }
                })
                this.filteredOptions = newoptions.slice(0, 1000)
                */
                const {
                    filteredData,
                    filterString
                } = filterData(search, options, 'refs', 'samples');
                this.filteredOptions = filteredData.length ? filteredData.slice(0, 1000) : [{
                    empty: true
                }]
            }
        },
        detailResults: function(bb) {
            let w = this;
            if (!bb) {
                let string = ''
                let index = this.currentIndex || 0
                let json = this.chartJSON[index]
                let output = {}
                output['Calculator Result'] = {
                    Fit: json.distance.toFixed(4),
                    Scores: json.result
                }
                if (json.groupResult) output['Group Result'] = json.groupResult
                if (json.sampleResult) output['Sample Result'] = json.sampleResult
                if (json.mapResult) output['Geo Result'] = json.mapResult
                //consoleWithNoSource(JSON.stringify(output, null, 2))
                //consoleWithNoSource(this.$yaml.stringify(output).replace(/-\n/g,'\n').replace(/'/g,''))
                let result = this.$yaml.stringify(output, 4, 3).replace(/-\n/g, '\n').replace(/'/g, '')
                //consoleWithNoSource(result)
                copy(result, {
                    asHtml: false,
                });
            } else {
                let tabledata = []
                let index = this.currentIndex || 0
                let json = this.chartJSON[index]
                tabledata.push({
                    key: `[B][size=1]Detailed Results[/size][/B]`,
                    value: w.groupArray[0] ? `${decodeURI(w.groupArray[0].label).trim()} by ${decodeURI(w.groupArray[0].user).trim()}` : '',
                    value: '',
                    results: '',
                    subresults: ''
                })
                tabledata.push({
                    key: `Sample:   ${json.profile.replace(/_/g, ' ').replace(/:/g, " ► ")}`,
                    value: '',
                    results: '',
                    subresults: ''
                })
                let headers = {
                    key: 'Detailed Results',
                    value: '',
                    results: '',
                    subresults: ''
                }
                tabledata.push({
                    key: `Fit:    ${json.distance}`,
                    value: '',
                    results: '',
                    subresults: ''
                })
                tabledata.push({
                    key: '[B]Calculator Result[/B]',
                    value: '',
                    results: '',
                    subresults: ''
                })
                Object.keys(json.result).forEach((result, i) => {
                    let obj = {}
                    obj.key = ' ' + result.replace(/_/g, ' ').replace(/:/g, " ► ")
                    obj.results = ''
                    obj.value = '  ' + json.result[result]
                    obj.subresults = ''
                    tabledata.push(obj);
                })
                tabledata.push({
                    key: '[B]Group Result[/B]',
                    value: '',
                    results: '',
                    subresults: ''
                })
                Object.keys(json.groupResult).forEach((result, i) => {
                    let obj = {}
                    obj.key = ' ' + result.replace(/_/g, ' ').replace(/:/g, " ► ")
                    obj.results = ''
                    obj.value = '  ' + json.groupResult[result]
                    obj.subresults = ''
                    tabledata.push(obj);
                })
                tabledata.push({
                    key: '[B]Sample Result[/B]',
                    value: '',
                    results: '',
                    subresults: ''
                })
                Object.keys(json.sampleResult).forEach((result, i) => {
                    let obj = {}
                    obj.key = ' ' + result.replace(/_/g, ' ').replace(/:/g, " ► ")
                    obj.results = ''
                    obj.value = '  ' + json.sampleResult[result]
                    obj.subresults = ''
                    tabledata.push(obj);
                })
                tabledata.push({
                    key: '[B]Geo Result[/B]',
                    value: '',
                    results: '',
                    subresults: ''
                })
                Object.keys(json.mapResult).forEach((result, i) => {
                    let obj = {}
                    obj.results = ''
                    obj.key = ' ' + result.replace(/_/g, ' ').replace(/:/g, " ► ")
                    obj.value = json.mapResult[result] && json.mapResult[result].value ? '  ' + json.mapResult[result].value : ''
                    obj.subresults = ''
                    tabledata.push(obj);
                    if (json.mapResult[result] && json.mapResult[result].regional && Object.keys(json.mapResult[result].regional).length > 0) {
                        Object.keys(json.mapResult[result].regional).forEach((region, i) => {
                            let obj = {}
                            obj.results = ''
                            obj.key = '[I]   ' + region.replace(/_/g, ' ') + '[/I]'
                            obj.value = '[I]  ' + json.mapResult[result].regional[region] + '[/I]'
                            obj.subresults = ''
                            tabledata.push(obj);
                        })
                    }
                })
                var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
                var replaceHeaders = new RegExp('<thead>(.*?)</thead>')
                copyhtml = copyhtml.replace(replaceHeaders, '')
                copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
                var replace = new RegExp(' class=.*?]', 'g')
                copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']')
                let size = tabledata.length > 6 ? 1 : 1
                copyhtml = `[size=${size}]${copyhtml}[/size]`
                copy(copyhtml, {
                    asHtml: false,
                });
            }
        },
        getGroup(key, value) {
            return this.sampleOptions.find((option) =>
                option.samples.some((sample) => sample[key] === value)
            );
        },
        isAllOptionsSelectedInGroup(group, custom) {
            //console.log(Date.now(),group,custom, this.rawArrayLocal.filter(x => x.customgroup  == group.group).length)
            if (this.rawArrayLocal.filter(x => (custom ? x.customgroup : x.group) == group.group).length == group.samples.length) {
                return true
            } else {
                return false
            }
        },
        removeGroupOrOption(data, removeOptionFunction) {
            if (data.samples) {
                if (data.customgroup) {
                    this.rawArrayLocal = this.rawArrayLocal.filter(x => x.customgroup !== data.group)
                } else {
                    this.rawArrayLocal = this.rawArrayLocal.filter(x => x.group !== data.group)
                }
            } else {
                removeOptionFunction(data);
            }
        },
        clearUrl() {
            let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname
            window.history.replaceState({
                path: newurl
            }, '', newurl);
        },
        async sortCalcs(evt) {
            let w = this;
            w.clearUrl()
            this.activeItemIndex = false;
            let sortModel = this.sortModel == 'name' ? 'calculator' : this.sortModel
            w.lastSortOrder = w.sortOrder;
            w.lastSortModel = w.sortModel;
            if (this.datasearch && this.datasearch.length >= 4 || this.activeIndex > 0) {
                if (w.sortOrder == 'asc') {
                    this.scrollCalcs = this.scrollCalcs.sort((a, b) => a[sortModel] > b[sortModel] ? 1 : a[sortModel] < b[sortModel] ? -1 : 0)
                } else {
                    this.scrollCalcs = this.scrollCalcs.sort((a, b) => a[sortModel] > b[sortModel] ? -1 : a[sortModel] < b[sortModel] ? 1 : 0)
                }
            } else {
                try {
                    let results = await this.$worker.postMessage({
                        action: 'addCalcs',
                        data: {
                            index: 0,
                            length: 40,
                            sortOrder: w.sortOrder,
                            sortModel: sortModel,
                            dataset: w.G25 ? 'getCalculators' : 'getAdmixCalculators'
                        }
                    })
                    if (results && results.result) {
                        let calcs = results.result.data;
                        this.scrollCalcs = calcs
                        this.scroller = 40
                        this.calclength = results.result.length;
                        this.calcCount = results.result.length;
                    }
                } catch (err) {}
            }
        },
        initF(params) {
            console.log('Elapsed time Ready', Date.now() - window.__GenoStart)
            if (this.filterizr && this.datasearch) {
                this.filterizr.search(this.datasearch);
            }
            if (params) this.completeRerun(params);
        },
        clearSearch() {
            if (this.datasearch) {
                this.datasearch = undefined
                this.setCalcFilter('ALL', 0)
                this.sortCalcs()
            } else {
                this.setCalcFilter('ALL', 0)
            }
        },
        setCalcSettings() {
            if (this.calcArray[0] && this.calcArray[0].settings) {
                let settings = typeof(this.calcArray[0].settings) === 'string' ? JSON.parse(this.calcArray[0].settings) : this.calcArray[0].settings
                this.rswitches.lite = settings && settings.nmonte ? false : true
                if (settings.grouped.removeoutliers) {
                    this.rswitches.removeOutliers = true
                    this.rswitches.groupAveraged = false
                    this.rswitches.groupMedian = false
                }
                if (settings.grouped.median) {
                    this.rswitches.removeOutliers = false
                    this.rswitches.groupAveraged = false
                    this.rswitches.groupMedian = true
                }
                if (settings.grouped.average) {
                    this.rswitches.removeOutliers = false
                    this.rswitches.groupAveraged = true
                    this.rswitches.groupMedian = false
                }
                this.slider.limit.value = settings.slider && settings.slider.limit && settings.slider.limit.value ? settings.slider.limit.value : this.slider.limit.data[0][0]
                this.slider.min.value = settings.slider && settings.slider.min && settings.slider.min.value ? settings.slider.min.value : this.slider.min.data[0][0]
                this.rswitches.penalty = settings.penalty
                this.slider.batches.value = settings.nmonte && settings.slider.batches.value ? settings.slider.batches.value : 200
                this.slider.cycles.value = settings.nmonte && settings.slider.cycles.value ? settings.slider.cycles.value : 200
                console.log('setting calc settings', this.rswitches, this.slider);
            }
        },
        popState() {
            let w = this;
            if (window.location.search && window.location.search.substr(0, 11) == '?calculator') {
                let shared = decodeURI(window.location.search.replace(/\?calculator=/, ''))
                if (shared.split('&mode=').length > 1) {
                    let calculator = shared.split('&mode=')[0]
                    let mode = shared.split('&mode=')[1]
                    if (mode) {
                        this.G25 = mode == 'raw' ? false : true
                        this.setCalcType(true)
                        this.$nextTick(() => {
                            let calc = this.scrollCalcs.findIndex(x => decodeURI(x.calculator) == decodeURI(calculator))
                            if (calc || calc == 0) {
                                w.setItemActive(calc);
                            }
                        })
                    }
                }
            }
        },
        showProgress(eta) {
            this.progress = 0;
            let i = 0;
            let timer = Math.round(eta / 100)
            let lastTime = 0;
            let w = this;
            const increment = function(time) {
                if (w.progress < 100 && ((time - lastTime) >= timer)) {
                    w.progress += 1;
                    if (!w.chartReady) {
                        requestAnimationFrame(increment);
                    } else {
                        w.progress = 100;
                    }
                    lastTime = time;
                } else {
                    requestAnimationFrame(increment)
                }
            }
            requestAnimationFrame(increment)
        },
        runCalc() {
            let w = this;
            w.setCalcSettings();
            //let calcQuery = this.rswitches.lite ? getCalcResultQuery : getCalcRResultQuery
            let calcQuery = this.rswitches.lite ? getCalcResultQuery : getCalcResultQuery
            //let queryProp = this.rswitches.lite ? 'getCalcResult' : 'getCalcRResult'
            let queryProp = this.rswitches.lite ? 'getCalcResult' : 'getCalcResult'
            console.log('calcQuery', calcQuery, this.rswitches);
            let customsamples = false;
            //this.mapOptions = false;
            this.recordEvent('runCalc', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            //if (this.map && this.map.geo) { this.map.geo.center = undefined this.map.geo.zoom = 1.25 }
            this.chartReady = false;
            let eta = 12000
            eta = eta < 2000 ? 2000 : eta;
            eta = parseInt(this.slider.limit.value) && this.calcArray[0].samples ? (this.calcArray[0].samples / 1200) * eta * parseInt(this.slider.limit.value) : eta
            eta = this.rswitches.lite ? eta : eta * 2
            let credits = this.credits || 0
            let estimate = Math.ceil((0.8 * Math.round(eta / 1000)) / 3) * this.rawArrayLocal.length;
            estimate = parseInt(this.slider.limit.value) && this.calcArray[0].samples ? Math.ceil(eta / 3000) : estimate
            estimate = this.rswitches.lite ? estimate : estimate * 2
            console.log(`ETA for query is ${Math.ceil(eta/1000)} seconds`);
            if (estimate > credits) {
                let freesub = w.subs && w.subs.subType == 'free' ? true : false
                let buttons = [{
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.closable = false;
                        w.$modal.hide('dialog');
                    } // Button click handler
                }]
                if (freesub) {
                    buttons.unshift({
                        title: 'Subscribe',
                        handler: () => {
                            w.createNew = false;
                            w.$modal.hide('dialog');
                            w.recordEvent('subButtonAnalyze', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                }
                w.$modal.show('dialog', {
                    title: 'Apologies',
                    text: `Unfortunately, you appear to have insufficient credits to execute this action<br><br><b>You need ${estimate} credits</b>`,
                    class: 'warning',
                    buttons: buttons
                })
                this.spinner = false;
                return
            }
            //here this.$store.commit('change', { statusMessage: '' })
            if (!this.onLine) {
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: 'Application offline',
                        text: 'Please re-run when the application is connected to the internet'
                    }
                });
                return false;
            }
            this.gridKey += 1;
            this.$store.commit('change', {
                g25firstRun: true
            })
            if (!this.gridApi) this.gridApi = this.gridOptions.api;
            this.$store.commit('change', {
                lastSort: false
            })
            var subId = this.$store.getters.get('user').username + ':' + this.queryTimeStamp;
            this.$store.commit('change', {
                subId: subId
            })
            if (!this.running) {
                this.$store.commit('change', {
                    spinner: true
                })
            } else {
                var success = false;
                this.$store.commit('change', {
                    spinner: true
                })
                //    this.chartReady = false;
                var evt = 'collapse-select';
                this.$root.$emit(evt, 'collapse');
                //here this.$store.commit('change', { g25calcChartSeries: [] })
                this.chartReady = false;
                //here this.$store.commit('change', { rawchartSeries: [] })
                this.components = this.calcArray[0].components
                //here this.$store.commit('change', { rawchartComponents: this.components })
                var chartColors = this.chartColors[this.slider.colors.value - 1]
                var colors = [...chartColors].slice(0, this.components.length);
                this.$store.commit('change', {
                    rawchartColors: colors
                })
                var chartOptions = this.chartOptions;
                chartOptions.colors = colors;
                //here this.chartOptions = chartOptions;
                var arr2 = this.rawArrayLocal;
                var leftArr = []
                arr2.forEach(sample => {
                    leftArr.push(sample.sample)
                })
                //here this.$store.commit('change', { rawchartCategories: leftArr })
                var chartOptions = this.chartOptions;
                //here this.chartOptions = chartOptions;
                var obj = {}
                this.components = []
                var filtered = this.aggregatedCalc && !this.rswitches.removeOutliers ? false : true
                var averaged = this.aggregatedCalc && this.rswitches.groupAveraged ? true : undefined
                var median = this.aggregatedCalc && this.rswitches.groupMedian ? true : undefined
                //here this.$store.commit('change', { g25calcChartComponents: this.components })
                var arr2 = this.rawArrayLocal;
                var leftArr = []
                arr2.forEach(sample => {
                    let vsample = sample.v ? sample.group + '|' + sample.v : sample.group;
                    leftArr.push(vsample + ':' + sample.sample)
                    if (this.g25customsamples && this.g25customsamples.length > 0 && this.g25customsamples.findIndex(x => x.split(':')[1] == sample.sample && x.split(':')[0] == vsample) >= 0) customsamples = this.g25Rerun
                })
                //here this.$store.commit('change', { g25calcChartCategories: leftArr })
                var chartOptions = this.chartOptions;
                //here this.chartOptions = chartOptions;
                var params = {
                    sub: subId,
                    calculator: this.calcArray[0].calculator,
                    penalty: this.rswitches.penalty ? 0.001 : 0,
                    batches: this.rswitches.lite ? undefined : this.slider.batches.value ? this.slider.batches.value : 200,
                    cycles: this.rswitches.lite ? undefined : this.slider.cycles.value ? this.slider.cycles.value : 200,
                    filtered: filtered,
                    averaged: averaged,
                    median: median,
                    customsamples: customsamples,
                    raw: false,
                    scaled: this.calcArray[0].scaled,
                    creator: this.calcArray[0].user,
                }
                if (w.slider.limit && parseInt(w.slider.limit.value)) params.limit = parseInt(w.slider.limit.value)
                if (w.slider.min && parseInt(w.slider.min.value)) params.autofit = parseInt(w.slider.min.value)
                var samples = leftArr;
                //here w.$store.commit('change', { g25calcChartJSON: [] })
                //here w.$store.commit('change', { g25calcChartCategories: samples })
                chartOptions = w.chartOptions
                w.chartOptions = chartOptions;
                w.subResults = [];
                let resultArr = [];
                let errorArr = []
                async function getResults(samples, eta) {
                    w.reqnum = samples.length;
                    w.start = Date.now()
                    const profilesArr = samples.map(async sample => {
                        let newParams = JSON.parse(JSON.stringify(params));
                        newParams.sample = sample
                        newParams.id = sample;
                        const data = await w.$apollo.query({
                            query: calcQuery,
                            variables: {
                                params: JSON.stringify(newParams)
                            }
                        })
                        if (data.data && data.data[queryProp] && data.data[queryProp].result) {
                            let output = data.data[queryProp];
                            let result = output.result ? JSON.parse(output.result) : false
                            w.filterResults = {
                                quantity: output.quantity,
                                filtered: output.filtered
                            }
                            let nearest = output.nearest ? JSON.parse(output.nearest) : false
                            let geo = output.geo ? JSON.parse(output.geo) : false
                            let meta = output.meta ? JSON.parse(output.meta) : false
                            let outdata = {
                                geo: geo,
                                result: result,
                                nearest: nearest,
                                profile: output.profile,
                                distance: output.distance,
                                groupResult: output.groupResult,
                                sampleResult: output.sampleResult,
                                mapResult: output.mapResult,
                                meta: meta
                            };
                            let index = w.rawArrayLocal.find(x => x.index == sample)
                            if (index && index.alias) outdata.alias = index.alias
                            resultArr.push(outdata);
                            return outdata
                        } else {
                            errorArr.push(`sample ${sample.replace(/:/g, " ► ")} not found`)
                            return false;
                        }
                    });
                    //w.$sentry.configureScope(scope => { scope.setTag("transactionId", subId); });
                    try {
                        const profiles = await Promise.all(profilesArr);
                        w.spinner = false;
                        if (errorArr.length > 0) {
                            var errMessage = ''
                            errorArr.forEach(error => {
                                errMessage = errMessage + error + '<br>';
                            })
                            w.$store.commit('change', {
                                spinner: false
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: 'Error',
                                    text: errMessage,
                                    class: 'failure'
                                }
                            })
                        }
                        if (resultArr.length <= 1) {
                            if (resultArr.length === 0) {
                                w.$store.commit('change', {
                                    spinner: false
                                })
                                w.progress = 0;
                                return;
                            } else {
                                w.components = Object.keys(resultArr[0].result)
                                resultArr[0].groupResult = JSON.parse(resultArr[0].groupResult)
                                resultArr[0].sampleResult = JSON.parse(resultArr[0].sampleResult)
                                if (resultArr[0].mapResult) resultArr[0].mapResult = JSON.parse(resultArr[0].mapResult)
                                w.groupcomponents = Object.keys(resultArr[0].groupResult)
                                w.samplecomponents = Object.keys(resultArr[0].sampleResult)
                                var obj = resultArr[0].result
                                var keys = Object.keys(obj)
                            }
                        } else {
                            var sortKey = w.components[0]
                            var val = 0;
                            var index = 0;
                            var compindex = 0;
                            var profile = false;
                            let compObj = {}
                            let groupObj = {}
                            let sampleObj = {}
                            resultArr.map(x => {
                                x.groupResult = JSON.parse(x.groupResult);
                                x.sampleResult = JSON.parse(x.sampleResult);
                                if (x.mapResult) x.mapResult = JSON.parse(x.mapResult);
                                Object.keys(x.result).map(x => {
                                    compObj[x] = true
                                })
                                Object.keys(x.groupResult).map(x => {
                                    groupObj[x] = true
                                })
                                Object.keys(x.sampleResult).map(x => {
                                    sampleObj[x] = true
                                })
                            })
                            w.components = Object.keys(compObj);
                            w.groupcomponents = Object.keys(groupObj);
                            w.samplecomponents = Object.keys(sampleObj);

                            resultArr.forEach((sample, i) => {
                                w.components.forEach((comp, n) => {
                                    if (sample.result[comp] >= val) {
                                        sortKey = comp;
                                        val = sample.result[comp]
                                        profile = sample.profile
                                        index = i
                                        compindex = n
                                    }
                                })
                            })
                            var obj = resultArr[index].result
                            var keys = JSON.parse(JSON.stringify(w.components));
                        }
                        w.$store.commit('change', {
                            g25calcChartComponents: w.components
                        })
                        w.$store.commit('change', {
                            g25calcComponents: w.groupcomponents
                        })
                        w.$store.commit('change', {
                            g25calcSampleComponents: w.samplecomponents
                        })

                        var chartColors = w.chartColors[w.slider.colors.value - 1]
                        var colors = [...chartColors].slice(0, w.components.length);
                        w.$store.commit('change', {
                            g25calcChartColors: colors
                        })
                        var calcColors = w.chartColors[w.slider.colors.value - 1]
                        calcColors = [...calcColors].slice(0, w.components.length);
                        w.$store.commit('change', {
                            g25calcColors: calcColors
                        })
                        var chartOptions = w.chartOptions;
                        chartOptions.colors = colors;
                        w.chartOptions = chartOptions;
                        keys.sort(function(a, b) {
                            var x = obj[a] ? obj[a] : 0;
                            var y = obj[b] ? obj[b] : 0;
                            return ((x < y) ? 1 : ((x > y) ? -1 : 0))
                        })
                        w.components = keys
                        w.$store.commit('change', {
                            geo: resultArr[0].geo
                        })
                        w.$store.commit('change', {
                            rawchartJSON: resultArr
                        })
                        setTimeout(() => {
                            w.$store.commit('change', {
                                spinner: false
                            })
                        }, 100)
                        w.processJSON(w.components[0]);
                        w.progress = 100;
                        var filterMsg = w.filterResults && w.filterResults.filtered && w.filterResults.filtered > 0 ? ` >> filtered: ${w.filterResults.filtered} outliers/${w.filterResults.quantity} samples` : ''
                        if (w.sampleArray && w.sampleArray.length > 1) {
                            if (profiles.length < w.sampleArray.length) {
                                var status = `${new Date().toLocaleString()}: Query did not complete ${w.sampleArray.length - profiles.length} subqueries/${w.sampleArray.length} in ${Math.round((Date.now() - w.start) / 1000)} seconds` + filterMsg
                                console.log(status)
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'setError',
                                    component: 'nav',
                                    params: status
                                })
                            } else {
                                var status = `${new Date().toLocaleString()}: Query completed in ${Math.round((Date.now() - w.start) / 1000)} seconds with no incomplete subqueries/${w.sampleArray.length}` + filterMsg
                                console.log(status)
                                w.$store.commit('change', {
                                    lastQuery: status
                                })
                            }
                        } else {
                            var status = `${new Date().toLocaleString()}:` + ' Query completed in ' + Math.round((Date.now() - w.start) / 1000) + ' seconds' + filterMsg
                            console.log(status)
                            w.$store.commit('change', {
                                lastQuery: status
                            })
                        }
                        return profiles
                        w.progress = 0;
                    } catch (err) {
                        console.log('caught getResults ', err);
                        var error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                        w.$eventBus.$emit('appEvents', {
                            exec: 'setError',
                            component: 'nav',
                            params: error
                        })
                        w.$store.commit('change', {
                            spinner: false
                        })
                        w.progress = 0;
                        if (error.indexOf('insufficient credits') >= 0) {
                            let freesub = w.subs && w.subs.subType == 'free' ? true : false
                            let buttons = [{
                                title: 'Cancel',
                                default: true,
                                handler: () => {
                                    w.closable = false;
                                    w.$modal.hide('dialog');
                                } // Button click handler
                            }]
                            if (freesub) {
                                buttons.unshift({
                                    title: 'Subscribe',
                                    handler: () => {
                                        w.createNew = false;
                                        w.$modal.hide('dialog');
                                        w.recordEvent('subButtonAnalyze', {
                                            'event_category': 'function',
                                            'event_label': 'User initiated'
                                        })
                                        w.$eventBus.$emit('appEvents', {
                                            exec: 'checkSubStatus',
                                            component: 'nav',
                                        })
                                    } // Button click handler
                                })
                            }
                            w.$modal.show('dialog', {
                                title: 'Apologies',
                                text: `Unfortunately, you appear to have insufficient credits to execute this action`,
                                class: 'warning',
                                buttons: buttons
                            })
                        } else {
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: 'Error',
                                    text: error,
                                    class: 'failure'
                                }
                            })
                        }

                        //var json = w.$store.getters.get('g25calcChartJSON')
                        var json = resultArr;
                        if (Array.isArray(json) && json.length > 0) {
                            w.$store.commit('change', {
                                rawchartJSON: json
                            })
                            w.$store.commit('change', {
                                spinner: false
                            })
                            w.$store.commit('change', {
                                lastSort: false
                            })
                            if (json.length < w.rawArrayLocal.length) {
                                var status = `${new Date().toLocaleString()}: Query did not complete ${w.rawArrayLocal.length - json.length} subqueries/${w.rawArrayLocal.length} in ${Math.round((Date.now() - w.start) / 1000)} seconds`
                                console.log(status)
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'setError',
                                    component: 'nav',
                                    params: status
                                })
                            } else {
                                var status = `${new Date().toLocaleString()}: Query completed in ${Math.round((Date.now() - w.start) / 1000)} seconds with no incomplete subqueries/${w.rawArrayLocal.length}`
                                console.log(status)
                                w.$store.commit('change', {
                                    lastQuery: status
                                })
                            }
                            w.processJSON(w.components[0]);
                            w.unchanged = true;
                        }
                    }
                }
                w.showProgress(eta);
                getResults(samples);
            }
        },
        onLoad: function(evt) {
            console.log('loaded', evt)
            if (evt.target.src != '') {
                this.frameDisplay = 'block'
                this.spinner = false;
                this.frameReady = true
                this.saveReady2 = true
            }
        },
        closeDrawer: function() {
            this.showshare = false
            this.spinner = false
            this.embed = false
            this.src = false;
            this.frameDisplay = 'none'
            this.saveReady2 = false
        },
        recordEvent: function(evt, meta) {
            meta.component = this.component;
            let ignore = ['routechange', 'setcredits', 'refreshcache', 'getuser', 'rerun', 'reset']
            this.$gtag.event(evt, meta);
            if (ignore.indexOf(evt.toLowerCase()) < 0) this.$genericevent.trackEvent(evt, meta);
        },
        clearToken() {
            this.$store.commit('change', {
                lastsync: ''
            })
            this.$eventBus.$emit('appEvents', {
                exec: 'show',
                component: 'nav',
                params: {
                    title: "Token cleared",
                    text: "Your encryption token has been removed from memory<br>you will be prompted to provide the token the next time you run an admix calculator",
                    class: 'normal'
                }
            })
        },
        slide: function(value) {
            let index = this.$refs.authors.swiper.realIndex;
            let min = 0;
            let max = this.$refs.authors.swiper.slides.length
            let width = this.$refs.authors.swiper.width;
            let increment = width < 400 ? 3 : width < 800 ? 6 : width < 1200 ? 8 : 10
            if (value === "prev") {
                //this.$refs.authors.swiper.slideNext()
                //this.$refs.authors.swiper.slideTo(this.calcOwners.length - 1);
                this.$refs.authors.swiper.slideTo(index + increment > max ? max - 1 : index + increment)
            } else {
                //this.$refs.authors.swiper.slidePrev()
                //this.$refs.authors.swiper.slideTo(0)
                this.$refs.authors.swiper.slideTo(index - increment < min ? min : index - increment)
            }
        },
        setSortOrder(value) {
            if (value != this.sortOrder) {
                this.sortOrder = value
                this.sortCalcs()
            }
            //this.filterizr.sort(this.sortModel, this.sortOrder)
        },
        setActive(index) {
            if (index === 0 && this.datasearch && this.datasearch.length >= 4) {
                this.searchCalcs()
            } else {
                this.clearUrl()
                this.activeIndex = index;
            }
        },
        setItemActive(index) {
            let w = this;
            if (index != this.activeItemIndex) {
                this.activeItemIndex = index;
                let calc = this.scrollCalcs[index].calculator
                let label = this.scrollCalcs[index].label
                //let calc = this.calcArray[0].calculator
                if (calc) {
                    let title = this.calcArray[0].label.toLowerCase().includes('calculator') ? this.calcArray[0].label : this.calcArray[0].label + ' Calculator'
                    window.document.title = `Genoplot | ${title} by ${this.calcArray[0].owner}`
                    setTimeout(() => {
                        w.selectedCalc = label;
                        if (w.scrollContainer && w.scrollContainer.id == 'app') {
                            w.scrollContainer.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            })
                        } else {
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            })
                        }
                    }, 100)
                }
                let mode = this.G25calc ? 'g25' : 'raw'
                let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?calculator=' + calc + '&mode=' + mode;
                window.history.replaceState({
                    path: newurl
                }, '', newurl);
                this.series = []
            } else {
                this.activeItemIndex = false;
                this.selectedCalc = undefined;
                this.series = []
                let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname
                window.history.replaceState({
                    path: newurl
                }, '', newurl);
            }
        },
        getOptions: function() {
            var _this = this
            return {
                isJQueryFiltering: false,
                layoutMode: 'masonry',
                masonry: {
                    gutter: 10
                },
                getSortData: {
                    id: "calculator",
                    name: function(itemElem) {
                        return itemElem.label.toLowerCase();
                    }
                },
                getFilterData: {
                    isEven: function(itemElem) {
                        return itemElem.id % 2 === 0;
                    },
                    isOdd: function(itemElem) {
                        return itemElem.id % 2 !== 0;
                    },
                    filterByText: function(itemElem) {
                        return itemElem.label.toLowerCase().includes(_this.filterText.toLowerCase());
                    }
                }
            }
        },
        toggleDrawer: function() {
            this.drawer = !this.drawer
        },
        authState: function(info) {
            if (info === 'signedIn') {
                this.init
            }
        },
        setGroupArray: function(params) {
            this.calcArray = []
            params.groups.map(x => {
                let groupIndex = this.scrollGroups.findIndex(y => y.label === x)
                if (groupIndex >= 0) this.calcArray.push(this.publicGroups[groupIndex])
            })
            this.syncStore('calcArray');
            this.components = params.groups
            this.$store.commit('change', {
                rawchartComponents: this.components
            })
            var chartColors = this.chartColors[this.slider.colors.value - 1]
            var colors = [...chartColors].slice(0, this.calcArray.length);
            this.$store.commit('change', {
                rawchartColors: colors
            })
        },
        resetMode: function(evt) {
            this.markerState = false;
            if (evt !== 'G25') {
                this.calculator = true
                this.setCalculator();
                this.rswitches.groupSamples = false;
                this.syncStore('switches.groupSamples')
                this.rawArrayLocal = [];
                this.syncStore('rawArrayLocal');
                this.calcArray = this.groupOptions.find(calc => calc.type === evt) ? [this.groupOptions.find(calc => calc.type === evt)] : []
                this.syncStore('calcArray');
            } else {
                this.rawArrayLocal = [];
                this.syncStore('rawArrayLocal');
                this.calcArray = [];
                this.syncStore('calcArray');
            }

        },
        resizeEChart: function() {
            let echarts = Object.keys(this.$refs).filter(x => x.indexOf('echart-') >= 0)
            let w = this;
            echarts.map(chart => {
                if (w.$refs[chart]) {}
            })
        },
        debounce: (func, wait) => {
            let timeout;
            console.log('exec', wait);

            return function executedFunction() {
                const later = () => {
                    clearTimeout(timeout);
                    console.log('cleared timeout')
                    func();
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        },
        debounce2: function(func, wait, immediate) {
            console.log('debounce', func, wait, immediate);
            var timeout;
            return function() {
                var context = this,
                    args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) {
                        func.apply(context, args);
                    }
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) {
                    func.apply(context, args);
                }
            };
        },
        newColor: function(H, hue, sat, lum) {
            hue = hue ? hue : 0
            lum = lum ? lum : 0
            sat = sat ? sat : 0
            let r = 0,
                g = 0,
                b = 0,
                a = 1;

            if (H.length == 5) {
                r = "0x" + H[1] + H[1];
                g = "0x" + H[2] + H[2];
                b = "0x" + H[3] + H[3];
                a = "0x" + H[4] + H[4];
            } else if (H.length == 9) {
                r = "0x" + H[1] + H[2];
                g = "0x" + H[3] + H[4];
                b = "0x" + H[5] + H[6];
                a = "0x" + H[7] + H[8];
            } else if (H.length == 7) {
                r = "0x" + H[1] + H[2];
                g = "0x" + H[3] + H[4];
                b = "0x" + H[5] + H[6];
                a = "0xff";
            }
            r /= 255;
            g /= 255;
            b /= 255;
            let cmin = Math.min(r, g, b),
                cmax = Math.max(r, g, b),
                delta = cmax - cmin,
                h = 0,
                s = 0,
                l = 0;

            if (delta == 0)
                h = 0;
            else if (cmax == r)
                h = ((g - b) / delta) % 6;
            else if (cmax == g)
                h = (b - r) / delta + 2;
            else
                h = (r - g) / delta + 4;

            h = Math.round(h * 60);

            if (h < 0)
                h += 360;

            l = (cmax + cmin) / 2;
            s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
            s = +(s * 100).toFixed(1);
            l = +(l * 100).toFixed(1);

            a = (a / 255).toFixed(3);
            return "hsla(" + (h + hue) + "," + (s + sat) + "%," + (l + lum) + "%," + a + ")";
        },
        appEvents: function(info) {
            if (typeof(info) === 'object' && (info.component === 'g25' || info.component === 'admix' || info.component === 'global')) {
                if (this[info.exec]) {
                    this[info.exec](info.params)
                }
            }
        },
        getUserSamples: async function(nextToken) {
            var w = this;
            if (!nextToken) {
                this.$store.commit('change', {
                    userSamples: []
                })
            }
            let currentSamples = nextToken ? this.$store.getters.get('userSamples') : []
            let proxy = (this.isAdmin && this.user && this.user.username && this.user.username == 'Genoplot' && this.$store.getters.get('proxyUser') != this.user.username) ? w.$store.getters.get('proxyUser') : false
            if (proxy) console.log('getting samples for ' + proxy)
            console.log(`getting${nextToken ? ' more ' : ' '}user samples...`)
            if (proxy || w.user && w.user.username) {
                try {
                    let variables = {
                        owner: proxy ? proxy : w.user.username,
                        type: w.G25 ? 'G25' : 'RAW'
                    }
                    if (nextToken) variables.nextToken = nextToken
                    let data = await w.$apollo.query({
                        query: queryByOwnerType,
                        variables: variables,
                        fetchPolicy: 'network-only'
                    })
                    if (data && data.data && data.data.queryByOwnerTypeIndex && data.data.queryByOwnerTypeIndex.items && data.data.queryByOwnerTypeIndex.items.length > 0) {
                        var samples = data.data.queryByOwnerTypeIndex.items
                        samples = currentSamples.concat(samples);
                        samples.sort((a, b) => a.sample.toLowerCase() > b.sample.toLowerCase() ? 1 : a.sample.toLowerCase() < b.sample.toLowerCase() ? -1 : 0)
                        samples.forEach((sample, index) => {
                            sample.sample = sample.sample
                            sample.alias = this.alias
                            sample.index = sample.group + ':' + sample.sample
                            sample.refs = ((sample.alias || sample.group) + ':' + sample.sample + (sample.origin || '') + (sample.ethnicity || '')).toLowerCase()
                            sample.type = sample.type ? sample.type : 'G25';
                            sample.class = sample.outlier ? 'outlier user' : 'default user';
                        })
                        this.$store.commit('change', {
                            userSamples: samples
                        })
                        if (data.data.queryByOwnerTypeIndex.nextToken) await w.getUserSamples(data.data.queryByOwnerTypeIndex.nextToken)
                    } else {
                        console.log(`No samples associated with ${w.user.username} found`);
                        var userSamples = [{
                            group: w.user.username,
                            samples: []
                        }]
                        //this.userSamples = userSamples
                        this.$store.commit('change', {
                            userSamples: []
                        })
                    }
                    this.filteredOptions = []
                    /*
                    setTimeout(() => {
                        if (this.publicSamples && this.publicSamples.length == 0) {
                            console.log('refreshing cache')
                            this.refreshCache()
                        }
                    }, 3000)
                    */
                } catch (error) {
                    console.log('getOwnerSamples', error);
                };
            }
        },
        init: function(mount) {
            console.log('initializing user session for AdmixCalc...')
            this.initiated = true;
            requestIdleCallback(async () => {
                this.getUserSamples()
                var w = this;
                w.$apollo.query({
                        query: getOwnerCalcsQuery,
                        variables: {
                            user: w.user.username
                        },
                        fetchPolicy: 'network-only'
                    })
                    .then(data => {
                        if (data && data.data && data.data.queryGenoCalcsByOwner && data.data.queryGenoCalcsByOwner.items && data.data.queryGenoCalcsByOwner.items.length > 0) {
                            var calcs = data.data.queryGenoCalcsByOwner.items
                            calcs.map(calc => {
                                calc.label = calc.calculator;
                                calc.class = 'default calc';
                            })
                            this.$store.commit('change', {
                                userCalcs: calcs
                            })
                            this.userCalcs = calcs
                        } else {
                            this.userCalcs = []
                            this.$store.commit('change', {
                                userCalcs: []
                            })
                        }
                    })
                    .catch(error => {
                        console.log('getOwnerCalcs', error);
                    });
                if (mount) {
                    var name = this.user.username + ':slider'
                    var slider = localStorage.getItem(name);
                    if (slider) {
                        slider = JSON.parse(slider).slider
                        let currentSlider = JSON.parse(JSON.stringify(this.slider))
                        Object.keys(currentSlider).map(key => {
                            if (!slider[key]) slider[key] = currentSlider[key]
                        })
                        this.$store.commit('change', {
                            slider: slider
                        })
                    }
                    var slider = localStorage.getItem(name);
                    name = this.user.username + ':switches'
                    var lswitches = localStorage.getItem(name);
                    if (lswitches) this.$store.commit('change', JSON.parse(lswitches))
                    name = this.user.username + ':rawArrayLocal'
                    var lrawArrayLocal = localStorage.getItem(name);
                    if (lrawArrayLocal) {
                        this.$store.commit('change', JSON.parse(lrawArrayLocal))
                        this.rawArrayLocal = JSON.parse(lrawArrayLocal).rawArrayLocal
                    }
                    name = this.user.username + ':calcArray'
                    var lcalcArray = localStorage.getItem(name);
                    if (lcalcArray) {
                        this.$store.commit('change', JSON.parse(lcalcArray))
                        this.calcArray = JSON.parse(lcalcArray).calcArray
                    }
                }
            })
        },
        getShare: async function(key, norerun) {
            let w = this;
            w.$store.commit('change', {
                spinner: true
            })
            let variables = {
                key: key
            };
            try {
                let data = await w.$apollo.query({
                    query: getShareQuery,
                    variables: variables,
                    fetchPolicy: 'network-only'
                })
                w.$store.commit('change', {
                    spinner: false
                })
                if (data && data.data && data.data.getShare && data.data.getShare.params) {
                    let buffer = Buffer.from(data.data.getShare.params, 'base64')
                    let jsonStr = w.$zlib.unzipSync(buffer).toString()
                    let params = JSON.parse(jsonStr)
                    if (params.samples) {
                        w.g25customsamples = params.samples
                        w.g25Rerun = params.type + '-shares.genoplot.com/' + params.path + '/samples'
                    }
                    if (norerun) {
                        return params
                    } else {
                        w.rerun(params);
                    }
                } else {
                    return false
                }
            } catch (err) {
                console.log(err)
                w.$store.commit('change', {
                    spinner: false
                })
                this.collapsed = false;
                return false
            }
        },
        rerun: async function(params) {
            if (params) {
                let key = params.type + '|' + params.path.replace(/\//, ':')
                params = await this.getShare(key, true)
            }
            console.log(params);
            if (params.published) {
                this.topics[params.path] = params.published
            }
            if (params.json) {
                params.json = params.json.map(sample => {
                    let alias = this.sampleOptions.find(x => x.originalGroup == sample.profile.split(':')[0]) || this.publicSamples.find(x => x.originalGroup == sample.profile.split(':')[0])
                    return sample
                })
            }
            let current = this.G25
            let g25calc = params.mode && params.mode == 'G25' ? true : false;
            try {
                this.rswitches['ancient'] = params.switches.ancient || false
                Object.keys(params.switches).map(x => {
                    this.rswitches[x] = params.switches[x]
                    this.syncStore('rswitches.' + x)
                })
            } catch (err) {
                console.log(err)
            }
            if (current != g25calc) {
                this.G25calc = g25calc;
                this.G25 = this.G25calc;
                this.changeCalcType(true, params)
            } else {
                this.changeCalcType(true, params)
            }
        },
        completeRerun: async function(params) {
            setTimeout(() => {
                this.drawer = false;
                this.chartReady = false;
                this.$store.commit('change', {
                    rawchartSeries: []
                })
                this.calcArray = []
                this.rawArrayLocal = []
                this.activePath = params.path;
                this.activeName = params.name ? params.name : false;
                this.activeContent = params.content || undefined
                this.syncStore('rawArrayLocal');
                this.syncStore('calcArray');
                window.allgroups = this.sampleOptions
                try {
                    if (params.calculator) {
                        this.calcArray = [];
                        params.categories.map(c => {
                            let z = c.split(' (')[0].trim()
                            let group = c.split(' (').length > 1 ? c.split(' (')[1].replace(/\)/, '').trim() : this.user.username
                            let sample = this.sampleOptions.find(s => s.originalGroup == group || s.group === group) ? this.sampleOptions.find(s => s.originalGroup == group || s.group === group).samples.find(s => s.sample === z) : false
                            if (sample) this.rawArrayLocal.push(sample)
                        })
                        this.syncStore('rawArrayLocal');
                        let calc = this.publicCalcs.find(calc => calc.calculator === params.calculator.split(':')[1])
                        this.calcArray = calc ? [calc] : []
                        this.syncStore('calcArray');
                    }
                    let evt = 'collapse-select';
                    let action = this.rawArrayLocal.length > 0 ? 'collapse' : 'activate'
                    this.$root.$emit(evt, action);
                    let w = this;
                    setTimeout(() => {
                        let w = this;
                        var json = params
                        let key = json.components[0]
                        w.colors = json.colors;
                        w.components = json.components;
                        w.$store.commit('change', {
                            rawchartJSON: json.json
                        })
                        if (w.refs && w.refs.samples && w.refs.samples.length > 0) {
                            w.$store.commit('change', {
                                rawchartRefs: w.refs
                            })
                        }
                        w.processJSON(key)
                    }, 0)
                } catch (err) {
                    console.log(err)
                    setTimeout(() => {
                        this.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: "Error",
                                text: "Unable to rerun  model<br>Perhaps some of the groups or samples are no longer available.",
                                class: 'warning'
                            }
                        })
                    }, 300)
                }
                this.markerState = params.markerState ? params.markerState : false;
                this.lastMarkerState = this.markerState;
            }, 0)
        },
        share: function(obj) {
            let w = this;
            let functions = {
                facebook: function(params) {
                    let path = params.path
                    let theme = params.theme
                    w.shareUrl = {
                        social: 'facebook',
                        shareQuote: 'my Genoplot Admixture Calculator results',
                        shareUrl: 'https://genoplot.com/shared/admix/?share=' + path + '#' + theme,
                        shareDesc: "Genetic Ancestry Modeling",
                        shareTitle: "Genoplot Admix results"
                    }
                },
                twitter: function(params) {
                    let shareHash = 'genoplot,genetics,geneology,ancestry,admixture'
                    let path = params.path
                    let theme = params.theme
                    w.shareUrl = {
                        social: 'twitter',
                        shareHash: shareHash,
                        shareVia: 'genoplot',
                        shareText: 'my Genoplot Admixture Calculator results',
                        shareUrl: 'https://genoplot.com/shared/admix/?share=' + path + '#' + theme
                    }
                },
                reddit: function(params) {
                    let shareHash = 'genoplot,genetics,ancestry,admixture,calculator' + w.components.map(x => x.replace(/ ► /g, '_').replace(/ /g, '')).join(',')
                    let path = params.path
                    let theme = params.theme
                    w.shareUrl = {
                        social: 'reddit',
                        shareHash: shareHash,
                        shareVia: 'genoplot',
                        shareText: 'my Genoplot Admixture calculator results',
                        shareUrl: 'https://genoplot.com/shared/admix/?share=' + path + '#' + theme
                    }
                }
            }
            functions[obj.name](obj.params)
        },
        saveShare: function(params) {
            let w = this;
            let recordSave = params == 'save' ? `save-${this.component}` : `share-${params}-${this.component}`
            this.recordEvent(recordSave, {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            w.createNew = true;
            params = params || 'save'
            if (w.plotId !== w.lastShared || !w.currentShare) {
                if (w.activePath) {
                    let buttons = [{
                            title: 'Update',
                            handler: () => {
                                w.createNew = false;
                                saveShare();
                                w.$modal.hide('dialog');
                            } // Button click handler
                        },
                        {
                            title: 'Create New',
                            handler: () => {
                                w.createNew = true;
                                saveShare();
                                w.$modal.hide('dialog');
                            } // Button click handler
                        },
                        {
                            title: 'Cancel',
                            default: true,
                            handler: () => {
                                w.closable = false;
                                w.$modal.hide('dialog');
                            } // Button click handler
                        }
                    ]
                    this.$modal.show('dialog', {
                        title: 'Update or Create New?',
                        text: 'Do you want to save to existing Chart<br/>or save as a new Chart?',
                        class: undefined,
                        buttons: buttons
                    })
                } else {
                    saveShare()
                }

                function saveShare() {
                    console.log(w.calcArray[0].calculator, w.calcArray[0].label);
                    let calc = w.calcArray[0].calculator
                    let payload = {
                        date: Date.now(),
                        version: w.calcArray[0] && w.calcArray[0].v ? w.calcArray[0].v : 0,
                        user: w.user.username,
                        json: w.chartJSON,
                        markers: w.lastMarkerState ? true : false,
                        markerState: w.lastMarkerState,
                        shareType: params,
                        sort: !w.lastSort ? true : false,
                        index: w.currentIndex,
                        key: w.chartKey,
                        mode: w.G25calc ? 'G25' : undefined,
                        categories: w.categories,
                        components: w.components,
                        colors: w.$store.getters.get('rawchartColors'),
                        //calcComponents: w.calcComponents &&  w.calcComponents.length > 0 ? w.calcComponents : undefined,
                        calculator: w.calcArray[0] && w.calcArray[0].calculator && w.calcArray[0].owner ? w.calcArray[0].owner + ':' + calc : undefined,
                        calcArray: w.calcArray.map(x => x.index ? x.index : x.label),
                        sliders: {
                            colors: (w.slider.colors.value - 1) % 5,
                            batches: w.slider.batches.value,
                            cycles: w.slider.cycles.value,
                        },
                        switches: {
                            scaled: w.rswitches.scaled,
                            penalty: w.rswitches.penalty,
                            groupAveraged: w.rswitches.groupAveraged,
                            ancient: w.rswitches.ancient || false,
                            groupMedian: w.rswitches.groupMedian,
                            removeOutliers: w.rswitches.removeOutliers,
                            calculator: w.calculator
                        },
                        primaryTab: w.primaryT === "" ? "chart" : w.primaryT,
                        secondaryTab: w.secondaryT === "" ? "table" : w.secondaryT
                    }
                    if (w.alias && !(w.activeName && !w.createNew) || w.alias && !w.createNew && w.activePath && w.activePath.split('/')[0] == w.alias) {
                        payload.alias = w.alias;
                    }
                    let defaultName = w.activeName && !w.createNew ? w.activeName : (payload.categories && payload.categories[0] ? (payload.categories[0].split(':').length > 1 ? payload.categories[0].split(':')[1].split('@')[0] : payload.categories[0].split(' ').reverse()[0]).split('@')[0] : '') + (payload.components ? '| ' + payload.components.join(', ').replace(/_/g, ' ') : '')
                    let postContent = w.activeContent && !w.createNew ? w.activeContent : undefined
                    if (w.subType > 0) {
                        let buttons = [{
                                title: 'OK',
                                handler: () => {
                                    try {
                                        let input = document.getElementById('saveDialog')
                                        defaultName = input.textContent || defaultName
                                        w.activeName = w.createNew ? false : defaultName
                                        w.activeContent = w.createNew ? undefined : postContent
                                        let post = document.getElementById('shared-description')
                                        postContent = post.value || undefined
                                        if (!defaultName || (defaultName && defaultName.length < 16)) {
                                            w.$modal.show('dialog', {
                                                title: 'Title is too short',
                                                text: 'Please set a longer title. Titles need to be at least 16 characters long. You are short by ' + (16 - defaultName.length) + ' characters',
                                            })
                                        } else {
                                            save()
                                            w.$modal.hide('saveDialog');
                                        }
                                    } catch (err) {
                                        w.$modal.show('dialog', {
                                            class: 'warning',
                                            title: 'Error',
                                            text: err
                                        })
                                        console.log(err);
                                    }
                                } // Button click handler
                            },
                            {
                                title: 'Cancel',
                                default: true,
                                handler: () => {
                                    w.closable = false;
                                    w.$modal.hide('saveDialog');
                                } // Button click handler
                            }
                        ]
                        if (w.createNew || !w.createNew) {
                            w.$modal.show('saveDialog', {
                                payload: {
                                    ...payload,
                                    ...{
                                        name: defaultName,
                                        type: 'admix',
                                        component: 'calculators',
                                        content: postContent
                                    }
                                },
                                buttons: buttons
                            })
                            setTimeout(() => {
                                let input = document.getElementById('saveDialog');
                                if (input && w.createNew) {
                                    input.focus();
                                    w.selectElementContents(input)
                                }
                            }, 100)
                        } else {
                            save()
                        }
                    } else {
                        save()
                    }
                    async function save() {
                        let name = w.alias ? w.alias : w.user.username;
                        let path = !w.createNew && w.activePath ? w.user.username + '/' + w.activePath.split('/')[1] : `${name}/${Date.now().toString(16)}`
                        payload.name = defaultName
                        if (w.subType > 0) {
                            w.activePath = path;
                            w.activeName = defaultName;
                        }
                        path = path;
                        let theme = w.theme ? 2 : 1
                        let type = 'admix'
                        payload.path = path
                        if (postContent) payload.content = postContent
                        if (w.topics && w.topics[path] && !w.createNew) payload.published = w.topics[path]
                        payload.theme = theme
                        payload.type = type
                        let contentType = 'application/json'
                        w.spinner = true
                        let sigparams = {
                            filePath: path,
                            fileType: type,
                            shareType: payload.shareType,
                            email: w.user.email,
                            username: w.user.username,
                            contentType: contentType,
                            jsonPayload: payload
                        }
                        if (w.env && typeof(w.env) == 'string' && (w.env == 'development' || w.env == 'staging')) {
                            sigparams.debug = true
                            sigparams.env = 'dev'
                        }
                        let data = await w.$apollo.query({
                            query: getS3SignatureQuery,
                            variables: {
                                params: JSON.stringify(sigparams)
                            },
                            fetchPolicy: 'network-only'
                        })
                        if (data && data.data && data.data.gets3Signature && data.data.gets3Signature.result) {
                            let result = JSON.parse(data.data.gets3Signature.result);
                            if (result.url && !result.uploaded) {
                                let signedUrl = result.url;
                                let options = {
                                    headers: {
                                        'Content-Type': contentType,
                                        'Content-Encoding': 'gzip'
                                    }
                                }
                                axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(JSON.stringify(payload))), options)
                                    .then(function(result) {
                                        w.spinner = false
                                        w.currentShare = {
                                            params: params,
                                            theme: theme,
                                            path: path
                                        }
                                        w.lastShared = w.plotId
                                        showShare(params, path, theme)
                                    })
                                    .catch(function(err) {
                                        w.spinner = false
                                        console.log(err);
                                        w.$eventBus.$emit('appEvents', {
                                            exec: 'show',
                                            component: 'nav',
                                            params: {
                                                title: "Error",
                                                text: "unable to save model",
                                                class: 'warning'
                                            }
                                        })
                                    });
                            } else if (result.uploaded) {
                                w.spinner = false
                                w.currentShare = {
                                    params: params,
                                    theme: theme,
                                    path: path
                                }
                                w.lastShared = w.plotId
                                showShare(params, path, theme)
                            } else {
                                w.spinner = false
                                console.log(result);
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'show',
                                    component: 'nav',
                                    params: {
                                        title: "Error",
                                        text: "unable to save model",
                                        class: 'warning'
                                    }
                                })

                            }
                        } else {
                            w.spinner = false
                            console.log(data);
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: "Error",
                                    text: "unable to save model",
                                    class: 'warning'
                                }
                            })
                        }
                    }
                }
            } else {
                showShare(params, w.currentShare.path, w.currentShare.theme)
            }

            function showShare(params, path, theme) {
                if (params === 'save') {
                    let url = 'https://genoplot.com/shared/admix/?share=' + path + '#' + theme
                    let buttons = [{
                        title: "Copy URL",
                        handler: (i, event) => {
                            copy(url)
                            document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                        }
                    }, {
                        title: '<a href="mailto:?subject=my Genoplot PCA&body=' + url + '" >Email</a>'
                    }, {
                        title: 'Close',
                        default: true
                    }]
                    w.$modal.show('dialog', {
                        title: 'Share',
                        text: "You can now share this PCA from this <a target='_blank' href='https://genoplot.com/shared/admix/?share=" + path + "#" + theme + "'>link</a>",
                        buttons: buttons,
                        clickToClose: false,
                        class: 'alert',
                        beforeClosed: function(event) {
                            console.log('closing', event)
                        }
                    })
                } else {
                    w.share({
                        name: params,
                        params: {
                            theme: theme,
                            path: path
                        }
                    })
                }
            }
        },
        saveShare2: function(params) {
            let w = this;
            params = params || 'save'
            if (w.subId !== w.lastShared || !w.currentShare) {
                w.spinner = true
                //let categories = this.categories.map( x => x.replace(/ ► /,':')).map( x => this.rawArrayLocal.find( s => s.index === x )).map( x => x.index + '|' + ( x.v ? x.v : -1 ))
                let payload = {
                    date: Date.now(),
                    version: w.calcArray[0] && w.calcArray[0].v ? w.calcArray[0].v : 0,
                    user: w.user.username,
                    json: w.chartJSON,
                    shareType: params,
                    sort: !w.lastSort ? true : false,
                    index: w.currentIndex,
                    key: w.chartKey,
                    categories: w.categories,
                    components: w.components,
                    colors: w.$store.getters.get('rawchartColors'),
                    //calcComponents: w.calcComponents &&  w.calcComponents.length > 0 ? w.calcComponents : undefined,
                    calculator: w.calcArray[0] && w.calcArray[0].calculator && w.calcArray[0].owner ? w.calcArray[0].owner + ':' + w.calcArray[0].calculator : undefined,
                    calcArray: w.calcArray.map(x => x.index ? x.index : x.label),
                    sliders: {
                        colors: (w.slider.colors.value - 1) % 5,
                        batches: w.slider.batches.value,
                        cycles: w.slider.cycles.value,
                    },
                    switches: {
                        scaled: w.rswitches.scaled,
                        penalty: w.rswitches.penalty,
                        groupAveraged: w.rswitches.groupAveraged,
                        groupMedian: w.rswitches.groupMedian,
                        removeOutliers: w.rswitches.removeOutliers,
                        calculator: w.calculator
                    },
                    primaryTab: w.primaryT === "" ? "chart" : w.primaryT,
                    secondaryTab: w.secondaryT === "" ? "table" : w.secondaryT
                }
                let path = `${w.user.username}/${Date.now().toString(16)}`
                path = w.subType === 0 ? 'base/' + path : path;
                let theme = w.theme ? 2 : 1
                let type = 'admix'
                payload.path = path
                payload.theme = theme
                payload.type = type
                let contentType = 'application/json'
                axios.post('https://genoplot.com/api/s3upload', {
                        filePath: path,
                        fileType: type,
                        contentType: contentType,
                    })
                    .then(function(result) {
                        var signedUrl = result.data.url;
                        var options = {
                            headers: {
                                'Content-Type': contentType,
                                'Content-Encoding': 'gzip'
                            }
                        };
                        return axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(JSON.stringify(payload))), options);
                    })
                    .then(function(result) {
                        w.spinner = false
                        w.currentShare = {
                            params: params,
                            theme: theme,
                            path: path
                        }
                        w.lastShared = w.subId;
                        showShare(params, path, theme)
                    })
                    .catch(function(err) {
                        w.spinner = false
                        console.log(err);
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: "Error",
                                text: "unable to save Admixture result(s)",
                                class: 'warning'
                            }
                        })
                    });

            } else {
                showShare(params, w.currentShare.path, w.currentShare.theme)
            }

            function showShare(params, path, theme) {
                if (params === 'save') {
                    let url = 'https://genoplot.com/shared/admix/?share=' + path + '#' + theme
                    let buttons = [{
                        title: "copy url",
                        handler: (i, event) => {
                            copy(url)
                            document.getElementById('button-dialog-' + i).textContent = "url copied!"
                        }
                    }, {
                        title: '<a href="mailto:?subject=my genoplot admix calculator results&body=' + url + '" >email</a>'
                    }, {
                        title: 'close',
                        default: true
                    }]
                    w.$modal.show('dialog', {
                        title: 'Share',
                        text: "You can now share these Admixture calculator results from this <br><a target='_blank' href='https://genoplot.com/shared/admix/?share=" + path + "#" + theme + "'>link</a><br>",
                        buttons: buttons,
                        clickToClose: false,
                        class: 'alert',
                        beforeClosed: function(event) {
                            console.log('closing', event)
                        }
                    })
                } else {
                    w.share({
                        name: params,
                        params: {
                            theme: theme,
                            path: path
                        }
                    })
                }
            }
        },
        startIntro: function() {
            this.recordEvent('runWalkThru', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
        },
        keySort: function(key) {
            return function naturalSort(a, b) {
                var naturalKey = key

                function isInt(str) {
                    if (isNaN(parseInt(str))) {
                        return false
                    } else {
                        return true
                    }
                }
                var aIsString = isInt(a[naturalKey]) ? false : true
                var bIsString = isInt(b[naturalKey]) ? false : true
                var aIsNumeric = isInt(a[naturalKey]) ? true : false
                var bIsNumeric = isInt(b[naturalKey]) ? true : false
                if (aIsString && bIsString) {
                    if (a[naturalKey] < b[naturalKey]) return -1;
                    if (a[naturalKey] > b[naturalKey]) return 1;
                    return 0
                } else if (aIsNumeric && bIsNumeric) {
                    return parseFloat(a[naturalKey]) - parseFloat(b[naturalKey]);
                } else if (aIsString && bIsNumeric) {
                    return -1;
                } else if (aIsNumeric && bIsString) {
                    return 1;
                } else if (aIsString || aIsNumeric) {
                    return -1;
                } else if (bIsString || bIsNumeric) {
                    return 1;
                } else {
                    return 0;
                }
            };
        },
        setCurrentChart: function(event) {
            if (event === 'chart') this.onSelectionChanged();
            if (event === 'table') this.gridOptions.api.sizeColumnsToFit()
            if (event === 'references') this.refsGridOptions.api.sizeColumnsToFit()
            this.currentShare = false;
        },
        log: function(event) {
            console.log('fired', event);
        },
        toggleGrid: function(klass) {
            var layout = klass === 0 ? 'Chart' : klass === 1 ? 'Data' : 'Both';
            this.$store.commit('change', {
                showGrid: klass
            })
            var slider = this.slider;
            slider.layout.value = layout;
            this.$store.commit('change', {
                slider: slider
            })
        },
        featureRequest(item) {
            console.log(item);
            this.recordEvent(item, {
                'event_category': 'feature',
                'event_label': 'click'
            })
            if (item === 'instagram') {
                this.drawer = !this.drawer
                return
            }
            if (item !== 'calculators') {
                this.$eventBus.$emit('spinner', 'run')
                setTimeout(() => {
                    this.$eventBus.$emit('spinner', 'stop')
                }, 3000)
                var options = {
                    save: {
                        title: 'Save Report',
                        text: "Save to the cloud functionality is coming soon!<br/><br/>In the meantime, you can export charts, maps and data to svg, png and xls files on your device<br><br><b>Right-click on the charts and tables to see the options available</b>",
                        class: 'alert'
                    },
                    upload: {
                        title: 'Upload Raw DNA files',
                        text: "Thank you for your interest,the ability to upload raw DNA files will be available in an upcoming release!"
                    },
                    twitter: {
                        title: 'Share to Twitter',
                        text: "The ability to share your results to Twitter will be available in the next release!"
                    },
                    facebook: {
                        title: 'Share to Facebook',
                        text: "The ability to share your results to Facebook will be available in a future release!"
                    },
                    instagram: {
                        title: 'Share to Instagram',
                        text: "The ability to share your results to Instagram will be available in a future release!"
                    },
                    calculators: {
                        title: 'Custom Calculators',
                        text: "Thank you for your interest, but custom calculators are not yet available"
                    }
                }
                var title = options[item].title
                var text = options[item].text
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: title,
                        text: text,
                        class: 'alert'
                    }
                })
            }
        },
        editSamples: function(event) {
            this.$stepAudio.unlockAudioContext()
            this.$stepAudio.play('https://static.genoplot.com/media/addSampleStep1.v5.mp3', 11);
            /*
                this.player = new this.$howl({
                        src: 'https://static.genoplot.com/media/addSampleStep1.v5.mp3',
                        autoplay: true,
                        volume: 0.0001,
                        onend: function() {}
                    });
                    */
            this.spinner = true;
            console.log('editing', event);
            this.queryTimeStamp = Date.now();
            this.recordEvent('editSamples', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            this.calculator = false;
            this.setCalculator();
            if (this.G25calc) {
                let params = {
                    groupJSON: this.groupJSON,
                    sampleJSON: this.sampleJSON,
                    showNonRawUploadIcons: true,
                    add: event === 'add' || event == 'addhelp' ? true : false,
                    mode: 'G25'
                };
                console.log(params);
                setTimeout(() => {
                    this.$modal.show('SamplesModal', params)
                    this.spinner = false;
                }, 100)
            } else {
                let params = {
                    groupOptions: this.groupOptions,
                    showNonRawUploadIcons: this.showNonRawUploadIcons,
                    add: event === 'add' || event == 'addhelp' ? true : false,
                    intro: (event == 'addhelp' || this.newUser) && !this.G25 ? {
                        steps: true
                    } : false
                };
                setTimeout(() => {
                    this.$modal.show('SamplesModal', params)
                    this.spinner = false;
                }, 100)
                this.destroyIntro();
                let name = this.user.username + ':' + 'addsamples'
                localStorage.setItem(name, 'true')
            }
            return;
        },
        editCalculators: function(event) {
            this.recordEvent('editCalculators', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            let params = {
                groupJSON: this.groupJSON,
                sampleJSON: this.sampleJSON,
                showNonRawUploadIcons: this.showNonRawUploadIcons,
                add: event === 'add' ? true : false
            };
            this.$modal.show('CalcSamplesModal', params);
            return;
        },
        customExec: function(event) {
            this.featureRequest('save')
            return;
            this.chartReady = !this.chartReady
            this.$store.commit('change', {
                spinner: !this.running
            })
            this.progress = this.progress === 0 ? 50 : 0;
            return false;
        },
        onDragStopped() {
            var headers = [];
            var columns = this.gridOptions.columnApi.getAllGridColumns()
            columns.forEach((col, i) => {
                if (col.colDef.field !== 'sample' && col.colDef.field !== 'distance') {
                    headers.push(col.colDef.field)
                }
            })
            this.$store.commit('change', {
                rawchartComponents: headers
            })
            this.components = headers;
            var series = this.series;
            var result = []
            headers.forEach(component => {
                result.push(series.find(item => item.name === component))
            })
            this.$store.commit('change', {
                rawchartSeries: result
            })
        },
        selectBarChart: function(index) {
            var index = index;
            if (index || index === 0) {
                this.currentIndex = index;
                this.$store.commit('change', {
                    currentIndex: index
                })
                let profile = this.categories[this.currentIndex]
                let chartindex = 0;
                chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '')} (${x.alias.split(':')[0]})`.trim() == this.categories[this.currentIndex].replace(/-raw/, '').trim())
            this.currentChartIndex = chartindex;
            this.currentChartIndex = this.currentChartIndex >= 0 ? this.currentChartIndex : 0;
                let labels = []
                let colors = []
                let comps = []
                this.newcomponents.forEach((comp, i) => {
                    labels.push("<div class='result-tip'>" + comp.replace(/_/g, " ") + "</div><b><div class='result-tip-value'>" + this.newseries[i].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>")
                })
                var chartOptions = JSON.parse(JSON.stringify(this.chartOptions))
                chartOptions.labels = labels;
                chartOptions.colors = this.newcolors;
                chartOptions.legend.offsetY = (16 - this.newcomponents.length) * 4 - 20
                this.chartOptions = chartOptions;
                this.map.series[0].data = this.mapseries
                // change for raw calcs
                if (this.calculator2 && this.calcComponents.length > 0) this.sunOptions.series.data = this.sunburstSeries
            } else {
                return false;
            }
        },
        onSelectionChanged() {
            if (this.gridOptions && this.gridOptions.api) {
                this.gridApi = this.gridOptions.api
                var selectedRows = this.gridApi.getSelectedRows();
                if (selectedRows.length > 0) {
                    this.rowsSelected = true;
                    let index = this.categories.findIndex(x => x.replace(/_/g, ' ').replace(/-raw/, '').trim() === selectedRows[0].originalsample.replace(/_/g, ' ').trim() || x.replace(/_/g, ' ').replace(/-raw/, '').trim() === selectedRows[0].sample.replace(/_/g, ' ').trim())
                    let chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '').replace(/_/g, ' ')} (${x.alias.split(':')[0].replace(/_/g, ' ')})`.trim() == selectedRows[0].sample.trim())
                    this.currentChartIndex = chartindex;
                    this.currentChartIndex = this.currentChartIndex >= 0 ? this.currentChartIndex : 0;
                    this.currentIndex = index;
                    this.$store.commit('change', {
                        currentIndex: index
                    })
                    let labels = []
                    let colors = []
                    let comps = []
                    this.newcomponents.forEach((comp, i) => {
                        labels.push("<div class='result-tip'>" + comp.replace(/_/g, " ") + "</div><b><div class='result-tip-value'>" + this.newseries[i].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>")
                    })
                    var chartOptions = JSON.parse(JSON.stringify(this.chartOptions))
                    chartOptions.labels = labels;
                    chartOptions.updated = Date.now();
                    chartOptions.colors = this.newcolors;
                    chartOptions.legend.offsetY = (16 - this.newcomponents.length) * 4 - 20
                    this.chartOptions = chartOptions;
                    //this.map.series[0].data = this.mapseries
                    // change for raw calcs
                    if (this.calculator2 && this.calcComponents.length > 0) this.sunOptions.series.data = this.sunburstSeries
                } else {
                    this.rowsSelected = false;
                }
            }
        },
        onSortChanged(event) {
            var columns = this.gridOptions.columnApi.getAllGridColumns()
            var sorted = columns.find(col => typeof(col.sort) !== 'undefined');
            //if (sorted && sorted.colDef && sorted.colDef.field) this.processJSON(sorted.colDef.field, sorted.sort);
        },
        copyTableSelectionBB() {
            var w = this;
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsArray = []
            selectedRows.forEach(function(selectedRow, index) {
                selectedRowsArray.push(selectedRow);
            });
            if (selectedRowsArray.length === 1) {
                var headers = {}
                var w = this;
                headers.key = 'Results'
                headers.value = ''
                headers.results = ''
                var tabledata = []
                var currentIndex = this.currentIndex ? this.currentIndex : 0
                var sample = selectedRowsArray[0]
                tabledata.push({
                    key: 'Sample:',
                    value: sample.sample.replace(/_/g, ' ').replace(/:/g, " ► "),
                    results: ''
                })
                w.components.forEach((result, i) => {
                    if (typeof(sample[result]) !== 'undefined') {
                        let obj = {}
                        obj.key = i === 0 ? 'Results:' : ''
                        obj.value = result.replace(/_/g, ' ')
                        obj.results = sample[result]
                        if (sample[result] && parseFloat(sample[result]) > 0) tabledata.push(obj);
                    }
                })
                var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
                var replaceHeaders = new RegExp('<thead>(.*?)</thead>')
                copyhtml = copyhtml.replace(replaceHeaders, '')
                copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
                var replace = new RegExp(' class=.*?]', 'g')
                copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']')
                let size = tabledata.length > 6 ? 1 : 1
                copyhtml = `[size=${size}]${copyhtml}[/size]`
                if (w.subId === w.lastShared) copyhtml = `[URL="https://genoplot.com/shared/admix/?share=${w.currentShare.path + '#' + w.currentShare.theme}"][IMG]https://genoplot.com/genoplot16.png[/IMG]&#8194;[B][SIZE=3]GenoPlot[/SIZE][/B][/URL]\n` + copyhtml
            } else {
                var headers = {}
                headers.sample = 'Sample'
                if (this.coverage) headers.coverage = 'Coverage'
                this.components.forEach(comp => headers[comp] = comp.replace(/_/g, ' '))
                var tabledata = []
                selectedRowsArray.forEach((sample, n) => {
                    var obj = {};
                    obj.sample = sample.sample.replace(/_/g, ' ')
                    obj.coverage = this.simpleCoverage(n) ? this.simpleCoverage(n) : ''
                    this.components.forEach(result => obj[result] = typeof(sample[result]) !== 'undefined' ? sample[result] : 0);
                    tabledata.push(obj)
                })
                var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
                copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
                var replace = new RegExp(' class=.*?]', 'g')
                copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']').replace(/:/g, " ► ")
                copyhtml = `[size=1]${copyhtml}[/size]`
                if (w.subId === w.lastShared) copyhtml = `[URL="https://genoplot.com/shared/admix/?share=${w.currentShare.path + '#' + w.currentShare.theme}"][IMG]https://genoplot.com/genoplot16.png[/IMG]&#8194;[B][SIZE=3]GenoPlot[/SIZE][/B][/URL]\n\n` + copyhtml
            }
            copy(copyhtml, {
                ashtml: false,
            });
        },
        copyTableSelection(type) {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsArray = []
            selectedRows.forEach(function(selectedRow, index) {
                selectedRowsArray.push(selectedRow);
            });
            var headers = {}
            headers.sample = 'Sample'
            if (this.coverage) headers.coverage = 'Coverage'
            this.components.forEach(comp => headers[comp] = comp.replace(/_/g, ' '))
            var tabledata = []
            selectedRowsArray.forEach((sample, n) => {
                var obj = {};
                obj.sample = sample.sample.replace(/_/g, ' ').replace(/-raw/, '')
                obj.coverage = this.simpleCoverage(n) ? this.simpleCoverage(n) : ''
                this.components.forEach(result => obj[result] = typeof(sample[result]) !== 'undefined' ? sample[result] : 0);
                tabledata.push(obj)
            })
            var copyhtml = new Table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            let copytext = this.$yaml.stringify(tabledata, 2).replace(/-\n/g, '\n').replace(/'/g, '')
            if (type && type == 'md') {
                let table = []
                let tablehead = Object.keys(headers).map(x => headers[x])
                table.push(tablehead);
                tabledata.map(x => {
                    let row = []
                    Object.keys(headers).map(y => {
                        row.push(typeof(x[y]) == 'string' ? x[y].replace('<b>', '').replace('</b><br/><br/>', '').replace('<br/>', ' ') : x[y])
                    })
                    table.push(row);
                })
                let copyhtml = w.$mdtable(table)
                copy(copyhtml, {
                    asHtml: false
                });
            } else if (type === 'text') {
                copy(copytext, {
                    asHtml: false,
                });
            } else {
                copy(copyhtml, {
                    asHtml: true,
                });
            }
        },
        fadeResults: function() {
            this.chartReady = false;
        },
        showResults: function() {
            if (this.series && this.series.length > 0) {
                this.chartReady = true;
            }
        },
        resetSamples: function() {
            this.markerState = false;
            this.drawer = false;
            this.chartReady = false;
            this.$store.commit('change', {
                rawchartSeries: []
            })
            this.$store.commit('change', {
                rawchartKey: false
            })
            this.$store.commit('change', {
                rawchartJSON: []
            })
            this.$store.commit('change', {
                rawchartRefs: false
            })
            var name = this.user.username + ':' + 'rawArrayLocal'
            localStorage.setItem(name, JSON.stringify({
                rawArrayLocal: []
            }));
            this.$store.commit('change', {
                rawArrayLocal: []
            })
            this.rawArrayLocal = [];
            if (this.calcArray.length === -100) {
                this.$eventBus.$emit('appEvents', {
                    exec: 'reset',
                    component: 'nav'
                })
            }
        },
        setCalculator: function() {
            if (this.calculator) this.resetGroups();
            this.rswitches.optimaFit = false;
            this.syncStore('switches.optimaFit');
            this.syncStore('calculator');
        },
        resetGroups: function() {
            this.markerState = false;
            this.activeName = false;
            this.activeContent = false;
            this.activePath = false;
            var name = this.user.username + ':' + 'calcArray'
            localStorage.setItem(name, JSON.stringify({
                calcArray: []
            }));
            this.$store.commit('change', {
                calcArray: []
            })
            this.calcArray = [];
            if (this.rawArrayLocal.length === -100) {
                this.$eventBus.$emit('appEvents', {
                    exec: 'reset',
                    component: 'nav'
                })
            }
        },
        setChartReady: function() {
            //this.series = this.sampledata;
            this.chartReady = true;
        },
        getDetail: function(comp) {
            if (this.groupJSON) {
                var group = this.groupJSON.find(x => x.label === comp)
                if (group && (group.origin || group.age)) {
                    var label = group.label.replace(/_/g, " ");
                    var age = group.age ? group.age : null
                    var origin = group.origin ? group.origin : null
                    //returnLabel(label, age, origin);
                    if ((age !== null && typeof(age) !== 'undefined') || (origin !== null && typeof(origin) !== 'undefined')) {
                        age = age === null || typeof(age) === 'undefined' ? '' : (age - 100000) < 0 ? -1 * (age - 100000) + ' BCE' : age - 100000 + ' CE';
                        origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                        return origin + ' ' + label + '  ' + age
                    } else {
                        return label
                    }
                } else {
                    return comp
                }
            } else {
                return comp
            }

            function returnLabel(label, age, origin) {}
        },
        writeSheet() {
            if (this.sheet) {
                this.$store.commit('change', {
                    spinner: true
                })
                this.getXLS().then((res) => {
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.aoa_to_sheet(this.sheet);
                    XLSX.utils.book_append_sheet(wb, ws, "results");
                    XLSX.writeFile(wb, "results.csv", {
                        compression: true
                    });
                    this.$store.commit('change', {
                        spinner: false
                    })
                }).catch(err => {
                    this.$store.commit('change', {
                        spinner: false
                    })
                    console.log(err)
                })
            } else {
                console.log('Nothing to export..')
            }
        },
        createImage(el, type) {
            let w = this;
            console.log('creating image: ', el);
            w.exporting = true;
            try {
                var filename = el === 'apex-wrapper' ? 'chart' : el;
                var node = document.getElementById(el);
                var style = el === 'table' ? {
                    marginTop: '-50px',
                    padding: 0
                } : el === 'chartresult' ? {
                    'margin-left': 'unset',
                    'width': '100%',
                    marginTop: '-35px',
                    paddingTop: '0px'
                } : el == 'chart' ? {
                    'margin': 0,
                    'width': '100%',
                    marginTop: '106.5px',
                    padding: 'unset',
                } : el === 'barchart' ? {
                    'margin': 0,
                    'width': '100%',
                    marginTop: '-10px',
                    padding: 'unset',
                    paddingLeft: '50px',
                    paddingRight: '10px'
                } : {
                    margin: 0,
                    padding: 0
                }
                if (type && type === 'svg') {
                    domtoimage.toSvg(node, {
                            bgcolor: this.theme ? '#14191f' : '#f2f2f2',
                            style: style
                        })
                        .then(function(blob) {
                            var img = new Image();
                            var svgBlob = new Blob([blob], {
                                type: "image/svg+xml;charset=utf-8"
                            });
                            var svgUrl = URL.createObjectURL(svgBlob);
                            img.src = svgUrl
                            console.log(style);
                            window.saveAs(blob, `${filename}.svg`);

                        });
                } else {
                    var style = el === 'table' ? {
                        marginLeft: 0,
                        marginTop: '-50px',
                        padding: 0,
                        paddingLeft: '50px',
                        paddingRight: '10px'
                    } : el === 'chartresult' ? {
                        'margin-left': 'unset',
                        'width': '100%',
                        marginTop: '-35px',
                        paddingTop: '0px'
                    } : el === 'chart' ? {
                        'margin-left': 'unset',
                        'width': '100%',
                        marginTop: '106.5px',
                        padding: 'unset'
                    } : el === 'barchart' ? {
                        'margin-left': 'unset',
                        'width': '100%',
                        marginTop: '-10px',
                        padding: 'unset',
                        paddingLeft: '50px',
                        paddingRight: '10px'
                    } : {
                        marginLeft: 0,
                        padding: 0
                    }
                    console.log(style);
                    domtoimage.toBlob(node, {
                            bgcolor: this.theme ? '#181818' : 'white',
                            style: style
                        })
                        .then(function(blob) {
                            var img = new Image();
                            img.src = blob
                            window.saveAs(blob, `${filename}.png`);
                            w.exporting = false;
                        }).catch(err => {
                            w.exporting = false;
                        })
                }
            } catch (err) {
                w.exporting = false;
            }

        },
        copyToClipForum() {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            if (this.coverage) headers.coverage = 'Coverage'
            w.components.forEach(comp => headers[comp] = comp.replace(/_/g, ' ').replace(/_/g, ' '))
            var tabledata = []
            w.chartJSON.forEach((sample, n) => {
                var obj = {};
                obj.sample = sample.profile.replace(/_/g, ' ').replace(/-raw/, '');
                obj.coverage = this.simpleCoverage(n) ? this.simpleCoverage(n) : ''
                w.components.forEach(result => obj[result] = typeof(sample.result[result]) !== 'undefined' ? sample.result[result] : 0);
                tabledata.push(obj)
            })
            var copyhtml = new Table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
            var replace = new RegExp(' class=.*?]', 'g')
            copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']').replace(/:/g, " ► ")
            copyhtml = `[size=1]${copyhtml}[/size]`
            //if (w.subId === w.lastShared) copyhtml = `[URL="https://genoplot.com/shared/g25/#${w.currentShare.path + w.currentShare.theme}"]GenoPlot[/URL]\n` + copyhtml
            if (w.subId === w.lastShared) copyhtml = `[URL="https://genoplot.com/shared/admix/?share=${w.currentShare.path + '#' + w.currentShare.theme}"][IMG]https://genoplot.com/genoplot16.png[/IMG]&#8194;[B][SIZE=3]GenoPlot[/SIZE][/B][/URL]\n\n` + copyhtml
            copy(copyhtml, {
                asHtml: false,
            });
        },
        copyToClip(type) {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            if (this.coverage) headers.coverage = 'Coverage'
            w.components.forEach(comp => headers[comp] = comp.replace(/_/g, ' '))
            var tabledata = []
            w.chartJSON.forEach((sample, n) => {
                var obj = {};
                obj.sample = sample.profile.replace(/_/g, ' ').replace(/-raw/, '')
                obj.coverage = this.simpleCoverage(n) ? this.simpleCoverage(n) : ''
                w.components.forEach(result => obj[result] = typeof(sample.result[result]) !== 'undefined' ? sample.result[result] : 0);
                tabledata.push(obj)
            })
            var copyhtml = new Table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            copyhtml = juice.inlineContent(copyhtml, tablecss)
            let copytext = this.$yaml.stringify(tabledata, 2).replace(/-\n/g, '\n').replace(/'/g, '')
            if (type && type == 'md') {
                let table = []
                let tablehead = Object.keys(headers).map(x => headers[x])
                table.push(tablehead);
                tabledata.map(x => {
                    let row = []
                    Object.keys(headers).map(y => {
                        row.push(typeof(x[y]) == 'string' ? x[y].replace('<b>', '').replace('</b><br/><br/>', '').replace('<br/>', ' ') : x[y])
                    })
                    table.push(row);
                })
                let copyhtml = w.$mdtable(table)
                copy(copyhtml, {
                    asHtml: false
                });
            } else if (type === 'text') {
                copy(copytext, {
                    asHtml: false,
                });
            } else {
                copy(copyhtml, {
                    asHtml: true,
                });
            }
        },
        copyToClipBB() {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.calculator = 'Calculator'
            w.components.forEach(comp => headers[comp] = comp.replace(/_/g, ' '))
            var tabledata = []
            w.chartJSON.forEach(sample => {
                var obj = {};
                obj.sample = sample.profile.replace(/_/g, ' ')
                obj.calculator = sample.label;
                w.components.forEach(result => {
                    if (typeof(sample.result[result]) !== 'undefined') obj[result] = typeof(sample.result[result]) !== 'undefined' ? sample.result[result] : 0
                });
                tabledata.push(obj)
            })
            var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
            copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
            var replace = new RegExp(' class=.*?]', 'g')
            copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']').replace(/:/g, " ► ")
            copyhtml = `[size=1]${copyhtml}[/size]`
            copy(copyhtml, {
                asHtml: false,
            });
        },
        rawData(index) {
            var index = index ? index : this.currentIndex ? this.currentIndex : 0
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.distance = 'Fit'
            w.components.forEach(comp => headers[comp] = comp.replace(/_/g, ' '))
            var tabledata = []
            var startIndex = index === -1 ? 0 : index;
            var endIndex = index === -1 ? w.chartJSON.length : index + 1;
            for (let n = startIndex; n < endIndex; n++) {
                var sample = w.chartJSON[n]
                var obj = {};
                obj.sample = sample.profile.replace(/_/g, ' ')
                obj.distance = sample.distance;
                w.components.forEach(result => obj[result] = typeof(sample.result[result]) !== 'undefined' ? sample.result[result] : 0);
                tabledata.push(obj)
            }
            var pretty = JSON.stringify(tabledata, null, 2);
            console.log(pretty);
            copy(pretty, {
                asHtml: false,
            });
        },
        copySampleToClipBB() {
            var headers = {}
            var w = this;
            headers.key = 'Results'
            headers.value = ''
            headers.results = ''
            var tabledata = []
            var currentIndex = this.currentIndex ? this.currentIndex : 0
            var sample = w.chartJSON[currentIndex]
            var calc = this.calcArray && this.calcArray[0] ? this.calcArray[0].label : false
            tabledata.push({
                key: 'Sample:',
                value: sample.profile.replace(/_/g, ' ').replace(/:/g, " ► "),
                results: ''
            })
            if (calc) tabledata.push({
                key: 'Calculator:',
                value: calc,
                results: ''
            })
            if (this.coverage) tabledata.push({
                key: 'Coverage:',
                value: this.coverage,
                results: ''
            })
            w.components.forEach((result, i) => {
                if (typeof(sample.result[result]) !== 'undefined' && sample.result[result] > 0) {
                    let obj = {}
                    obj.key = i === 0 ? 'Results:' : ''
                    obj.value = result.replace(/_/g, ' ')
                    obj.results = sample.result[result]
                    //if ( sample.result[result]
                    tabledata.push(obj);
                }
            })
            var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
            var replaceHeaders = new RegExp('<thead>(.*?)</thead>')
            copyhtml = copyhtml.replace(replaceHeaders, '')
            copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
            var replace = new RegExp(' class=.*?]', 'g')
            copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']')
            let size = tabledata.length > 6 ? 1 : 1
            copyhtml = `[size=${size}]${copyhtml}[/size]`
            if (w.subId === w.lastShared) copyhtml = `[URL="https://genoplot.com/shared/admix/?share=${w.currentShare.path + '#' + w.currentShare.theme}"][IMG]https://genoplot.com/genoplot16.png[/IMG]&#8194;[B][SIZE=3]GenoPlot[/SIZE][/B][/URL]\n` + copyhtml
            //copyhtml = `[color=#153545]${copyhtml}[/color]`
            copy(copyhtml, {
                asHtml: false,
            });
        },
        copySampleHtml(type) {
            var headers = {}
            var w = this;
            headers.key = ''
            headers.value = ''
            headers.results = ''
            var tabledata = []
            var currentIndex = this.currentIndex ? this.currentIndex : 0
            var sample = w.chartJSON[currentIndex]
            tabledata.push({
                key: '<b>Sample:</b><br/><br/>',
                value: sample.profile.replace(/_/g, ' ').replace(/:/g, " ►<br/>"),
                results: ''
            })
            if (sample.distance) {
                tabledata.push({
                    key: 'Fit:',
                    value: sample.distance ? sample.distance : '',
                    results: ''
                })
            }
            var calc = this.calcArray && this.calcArray[0] ? this.calcArray[0].label : false
            if (calc) tabledata.push({
                key: 'Calculator:',
                value: calc,
                results: ''
            })
            if (this.coverage) tabledata.push({
                key: 'Coverage:',
                value: this.coverage,
                results: ''
            })
            w.components.forEach((result, i) => {
                if (typeof(sample.result[result]) !== 'undefined') {
                    let obj = {}
                    obj.key = i === 0 ? 'Results:' : ''
                    obj.value = result.replace(/_/g, ' ')
                    obj.results = sample.result[result]
                    tabledata.push(obj);
                }
            })
            if (type && type == 'md') {
                let table = []
                tabledata.map(x => {
                    let row = []
                    Object.keys(headers).map(y => {
                        row.push(typeof(x[y]) == 'string' ? x[y].replace('<b>', '').replace('</b><br/><br/>', '').replace('<br/>', ' ') : x[y])
                    })
                    table.push(row);
                })
                let copyhtml = w.$mdtable(table, {
                    align: ['l', 'l', 'l']
                })
                console.log(copyhtml);
                copy(copyhtml, {
                    asHtml: false
                });
            } else {
                var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
                //var replaceHeaders = new RegExp('<thead>(.*?)</thead>')
                //copyhtml = copyhtml.replace(replaceHeaders, '')
                //console.log(copyhtml);
                copy(`<p>${copyhtml}</p>`, {
                    asHtml: true
                });
            }
            window.parent.postMessage({
                action: 'pasteIntoEditor',
                content: `<p>${copyhtml}</p><p><br/></p><br/>`,
                source: 'shares'
            }, '*')
        },
        copySampleToClip(type) {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            //headers.distance = 'Fit'
            w.components.forEach(comp => headers[comp] = comp.replace(/_/g, ' '))
            var tabledata = []
            var currentIndex = this.currentIndex ? this.currentIndex : 0
            var sample = w.chartJSON[currentIndex]
            var obj = {};
            obj.Sample = sample.profile.replace(/_/g, ' ').replace(/:/g, " ► ")
            var calc = this.calcArray && this.calcArray[0] ? this.calcArray[0].label : false
            if (calc) obj.Calculator = calc
            if (this.coverage) obj.Coverage = this.coverage
            //obj.distance = sample.distance;
            w.components.forEach(result => obj[result] = typeof(sample.result[result]) !== 'undefined' ? sample.result[result] : 0);
            tabledata.push(obj)
            var copyhtml = new Table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            copyhtml = juice.inlineContent(copyhtml, tablecss)
            let copytext = this.$yaml.stringify(tabledata, 2).replace(/-\n/g, '\n').replace(/'/g, '')
            if (type === 'text') {
                copy(copytext, {
                    asHtml: false,
                });
            } else {
                copy(copyhtml, {
                    asHtml: true,
                });
            }
        },
        chartaHeight() {
            var length = this.calcArray ? this.calcArray.length : 0
            var height = (length > 0 ? 20 * length : 20);
            return height
        },
        getChart(key) {
            var key = typeof(key) === 'undefined' ? 'Ganj_Dareh_N' : key;
            var json = this.chartJSON ? this.chartJSON : false
            if (!json) {
                var vm = this;
                axios.get('https://static.genoplot.com/public/results.json?v=12').then(response => {
                    var json = response.data
                    //vm.chartJSON = json;
                    vm.$store.commit('change', {
                        rawchartJSON: json
                    })
                    vm.processJSON(key)
                })
            } else {
                var vm = this;
                vm.processJSON(key)
            }

        },
        processJSON(key, sort) {
            console.log('processing ', key, sort);
            if (this.debug && this.env === 'development') console.log('processing JSON key ', key)
            this.currentIndex = 0;
            var key = key;
            var json = JSON.parse(JSON.stringify(this.chartJSON))
            console.log('json', json[0].profile, json[0].chromosome);
            /*
            var jsonBlob = new Blob([JSON.stringify(json)], {
                type: "application/json"
            });
            window.saveAs(jsonBlob, `data.json`);
            */
            if (this.debug && this.env === 'development') console.log('JSON', json)
            this.$store.commit('change', {
                rawchartKey: key
            })
            if (key === 'distance' || key === 'sample') {
                var naturalKey = sort ? 'chromosome' : key === 'distance' ? key : 'profile';
                json.sort(this.keySort(naturalKey));
            } else {
                sort = json.find( x => x.chromosome) ? true : false
                json.sort(function(a, b) {
                    let sortkey = sort || a.chromosome ? 'chromosome' : key
                    if ( sort ) {
                    var x = parseInt(a[sortkey]) ? parseInt(a[sortkey]) : 0;
                    var y = parseInt(b[sortkey]) ? parseInt(b[sortkey]) : 0;
                    return (x < y ? -1 : x > y ? 1 : 0)
                    } else {
                    var x = a.result[sortkey] ? a.result[sortkey] : 0;
                    var y = b.result[sortkey] ? b.result[sortkey] : 0;
                    return (x < y ? 1 : x > y ? -1 : a.profile < b.profile ? 1 : a.profile > b.profile ? -1 : 0)
                    }
                })
            }
            if (this.lastSort === key) {
                json.reverse();
                this.$store.commit('change', {
                    lastSort: false
                })
            } else {
                this.$store.commit('change', {
                    lastSort: key
                })
            }
            let w = this;
            var categories = []
            json.forEach(function(s, n) {
                let profileIndex = w.rawArrayLocal.find(x => x.index == s.profile || x.alias && `${x.alias}:${x.sample}` == s.profile)
                let profile = profileIndex ? `${profileIndex.originalGroup ? profileIndex.originalGroup : profileIndex.alias ? profileIndex.alias : profileIndex.group}:${profileIndex.sample}` : s.profile
                s.alias = profile || s.profile;
                categories.push(profile.split(':').length > 1 ? `${profile.split(':')[1]} (${profile.split(':')[0]})` : profile)
            })
            w.$store.commit('change', {
                rawchartJSON: json
            })
            if (this.debug && this.env === 'development') console.log('categories', categories)
            Array.prototype.rotate = function(n) {
                var len = this.length;
                return !(n % len) ? this.slice() :
                    this.map((e, i, a) => a[(i + (len + n % len)) % len]);
            };
            var components = JSON.parse(JSON.stringify(this.components))
            var index = components.indexOf(key);
            var colors = w.colors;
            colors = colors.rotate(index);
            var chartOptions = JSON.parse(JSON.stringify(w.chartOptions))
            components = components.rotate(index);
            var series = []
            let newcomponents = []
            let newcolors = []
            components.forEach(function(c, i) {
                var component = c;
                var data = [];
                json.forEach(function(y, t) {
                    var value = y.result[component] ? y.result[component] : 0;
                    if (y.result[component] && t === w.currentIndex) {
                        newcomponents.push(component)
                        let index = components.findIndex(x => x === component)
                        newcolors.push(w.colors[index % w.colors.length])
                    }
                    data.push(value)
                });
                series.push({
                    name: component,
                    data: data
                })
            })
            chartOptions.colors = newcolors;
            chartOptions.legend.offsetY = (16 - newcomponents.length) * 4 - 20
            w.$store.commit('change', {
                rawchartColors: colors
            })
            w.$store.commit('change', {
                rawchartSeries: series
            })
            w.$store.commit('change', {
                rawchartCategories: categories
            })
            if (w.firstRun && w.gridApi) {
                w.gridApi.refreshCells({
                    force: true
                });
                w.$store.commit('change', {
                    g25firstRun: false
                })
            }
            var labels = []
            newcomponents.forEach((comp, i) => {
                labels.push(w.newseries[i] ? "<div class='result-tip'>" + comp.replace(/_/g, " ") + "</div><b><div class='result-tip-value'>" + w.newseries[i].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>" : '') // "<div class='result-tip faded'>" + comp.replace(/_/g, " ") + "</div><b><div class='result-tip-value faded'>" + w.newseries[i].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>")
            })
            w.components = components;
            w.$store.commit('change', {
                rawchartComponents: components
            })
            chartOptions.labels = labels;
            chartOptions.comps = components;
            w.chartOptions = chartOptions;
            var showGrid = w.series[0] && w.series[0].data && w.series[0].data.length === 1 ? 0 : w.showGrid
            w.$store.commit('change', {
                showGrid: showGrid
            })
            //let pieOptions = JSON.parse(JSON.stringify(w.pieOptions))
            if (this.calcArray && this.calcArray[0]) {
                this.drawer = true;
                this.chartReady = true;
            }
        },
        selectSearchText(ref) {
            this.$refs[ref].$refs.search.focus()
            this.$refs[ref].$refs.search.select()
        },
        syncStore(name) {
            if (name.includes('Local')) return;
            this.queryTimeStamp = Date.now();
            this.unchanged = false;
            this.currentShare = false;
            var props = name.split('.')
            var prop = props[0]
            if (prop === 'rswitches' && props[1]) {
                var swtch = props[1];
                if (swtch == 'ancient') this.resetOptions()
                if (swtch === 'removeOutliers' && this[prop].removeOutliers === true) {
                    this[prop].groupAveraged = false;
                    this[prop].groupMedian = false;
                }
                if (swtch === 'groupAveraged' && this[prop].groupAveraged === true) {
                    this[prop].removeOutliers = false;
                    this[prop].groupMedian = false;
                }
                if (swtch === 'groupMedian' && this[prop].groupMedian === true) {
                    this[prop].groupAveraged = false;
                    this[prop].removeOutliers = false;
                }
            }
            if (prop === 'slider' && props[1] && props[2]) {
                var slider = props[1];
                if (slider === 'colors') {
                    var theme = (props[2] - 1) % 5
                    var colors = this.chartColors[theme];
                    colors = colors.slice(0, this.components.length)
                    var chartOptions = JSON.parse(JSON.stringify(this.chartOptions))
                    chartOptions.colors = colors;
                    this.chartOptions = chartOptions;
                    if (this.categories.length === 1) {
                        this.series[0].data[0] = (this.series[0].data[0] * 1.000001).toFixed(1);
                    }
                    this.$store.commit('change', {
                        rawchartColors: colors
                    })
                    this.map.series[0].data = this.mapseries
                    if (this.calculator && this.calcComponents && this.calcComponents.length > 0) {
                        if (this.categories.length === 1) {
                            this.processJSON(this.components[0]);
                        } else {
                            this.sunOptions.series.data = this.sunburstSeries;
                        }
                    }
                }
                if (slider === 'layout') {
                    var layout = props[2]
                    var showGrid = layout === 'Data' ? 1 : layout === 'Both' ? 2 : 0;
                    layout = this.chartColors[theme];
                    this.$store.commit('change', {
                        showGrid: showGrid
                    })
                }
            }
            var obj = {};
            obj[prop] = this[prop];
            var localname = this.user.username + ':' + prop
            localStorage.setItem(localname, JSON.stringify(obj));
            if (name === 'rawArrayLocal' && this.rawArrayLocal.length === 0) this.resetSamples()
        },
        customCalcSmallLabel(calc) {
            return (`${unescape(calc.label)} by ${calc.owner}`)
        },
        customCalcLabel(calc) {
            return (`${unescape(calc.label)} by ${calc.owner}`)
        },
        unescape(string) {
            return unescape(string)
        },
        customLabel({
            label,
            age,
            origin,
            v,
            outlier

        }) {
            if ((age !== null && typeof(age) !== 'undefined') || (origin !== null && typeof(origin) !== 'undefined')) {
                age = age === null || typeof(age) === 'undefined' ? '' : (age - 100000) < 0 ? -1 * (age - 100000) + ' BCE' : age - 100000 + ' CE';
                origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                return (label.replace(/_/g, " ") + ' ( ' + age + ' ' + origin + ' )' + outlier).replace(/:/, ' ► ')
            } else {
                origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                return (label.replace(/_/g, " ") + outlier + origin).replace(/:/, ' ► ')
            }
        },
        customSample({
            group,
            sample,
            alias,
            age,
            origin,
            type,
            outlier,
            variability
        }) {
            group = alias ? alias : group
            if ((age !== null && typeof(age) !== 'undefined') || (origin !== null && typeof(origin) !== 'undefined')) {
                age = age === null || typeof(age) === 'undefined' ? '' : (age - 100000) < 0 ? -1 * (age - 100000) + ' BCE' : age - 100000 + ' CE';
                origin = origin === null || typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                variability = typeof(variability) !== 'undefined' && variability !== null ? ` (${(variability/3.5).toFixed(2)}%)` : ''
                var message = group + ' ► ' + sample + outlier + ' ( ' + age + ' ' + origin + ' )'
                if (type === 'user') message = 'User ► ' + message
                return message.replace(/_/g, ' ')
            } else {
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                variability = typeof(variability) !== 'undefined' && variability !== null ? ` (${(variability/3.5).toFixed(2)}%)` : ''
                return (group + ' ► ' + sample + outlier).replace(/_/g, ' ')
            }
        },
        resetTip() {
            this.tipDisabled = false;
        },
        runOracles() {
            this.recordEvent('runOraclesRaw', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            this.tipDisabled = true;
            setTimeout(() => {
                this.tipDisabled = false;
            }, 70000)
            if (!this.onLine) {
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: 'Application offline',
                        text: 'Please re-run when the application is connected to the internet'
                    }
                });
                return false;
            }
            var subId = this.$store.getters.get('user').username + ':' + this.queryTimeStamp;
            var w = this;
            let eta = 8000
            var nearest = false
            var calculator = this.calcArray[0].calculator
            var creator = 'internalGenoplot'
            let coords = []
            let components = w.G25calc ? window.g25cache.getCalculators.find(x => x.calculator === calculator).components : window.g25cache.getAdmixCalculators.find(x => x.calculator === calculator).components
            console.log('index2', w.currentChartIndex)
            components.map(x => {
                coords.push(w.chartJSON[w.currentChartIndex].result[x.replace(/_/g, ' ')] ? w.chartJSON[w.currentChartIndex].result[x.replace(/_/g, ' ')] : w.chartJSON[w.currentChartIndex].result[x] ? w.chartJSON[w.currentChartIndex].result[x] : 0)
            })
            console.log('components', components)
            console.log('coords', coords, coords.length)
            console.log('results', w.chartJSON[w.currentChartIndex].result)
            var query = getOraclesQuery
            var type = 'getOracle'
            var params = {
                filtered: true,
                admix: true,
                sampleCoords: {
                    sample: w.categories[w.currentIndex].replace(/-raw/, ''),
                    group: w.user.username,
                    coords: coords.join(',')
                }
            }
            let execArray = [{
                mode: 'mixed'
            }, {
                mode: 'multi'
            }]
            console.log(`ETA for query is ${Math.round(eta/1000)} seconds`);
            let credits = this.credits || 0
            let estimate = Math.ceil((0.8 * Math.round(eta / 1000)) / 3)
            if (estimate > credits) {
                let freesub = w.subs && w.subs.subType == 'free' ? true : false
                let buttons = [{
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.closable = false;
                        w.$modal.hide('dialog');
                    } // Button click handler
                }]
                if (freesub) {
                    buttons.unshift({
                        title: 'Subscribe',
                        handler: () => {
                            w.createNew = false;
                            w.$modal.hide('dialog');
                            w.recordEvent('subButtonAnalyze', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                }
                w.$modal.show('dialog', {
                    title: 'Apologies',
                    text: `Unfortunately, you appear to have insufficient credits to execute this action<br><br><b>You need ${estimate} credits</b>`,
                    class: 'warning',
                    buttons: buttons
                })
                this.spinner = false;
                return
            }
            let resultArr = [];
            var index = w.currentIndex ? w.currentIndex : 0
            async function getOracles(calculator, eta) {
                w.start = Date.now()
                const oraclesArr = execArray.map(async mode => {
                    let newParams = JSON.parse(JSON.stringify(params));
                    newParams.groups = [1, 2]
                    newParams.sample = w.user.username + ':' + w.categories[index].replace(/-raw/, '')
                    newParams.calculator = calculator;
                    newParams.creator = creator;
                    newParams.id = w.categories[index].replace(/ ► /g, ':') + ':oracle:' + mode.mode
                    newParams.sub = subId;
                    newParams.nearest = [];
                    newParams.multi = mode.mode && mode.mode === 'multi' ? true : false;
                    const data = await w.$apollo.query({
                        query: query,
                        variables: {
                            params: JSON.stringify(newParams)
                        }
                    })
                    if (data.data && data.data[type]) {
                        let output = data.data[type];
                        let result = output.result ? JSON.parse(output.result) : false
                        let nearest = output.nearest ? JSON.parse(output.nearest) : false
                        let outdata = {
                            result: result,
                            nearest: nearest
                        };
                        resultArr.push(outdata);
                        return outdata
                    } else {
                        return false;
                    }
                });
                //w.$sentry.configureScope(scope => { scope.setTag("transactionId", subId); });
                try {
                    const oracles = await Promise.all(oraclesArr);
                    let oraclesMsg = []
                    let multi2 = []
                    let multi4 = []
                    let nearest = []
                    let output = resultArr.map(result => {
                        if (result.result.oracles) {
                            result.result.oracles.map(oracle => {
                                let msg = ''
                                let result = oracle.result.map((x, i) => {
                                    let group = x.group.replace(/_/g, ' ')
                                    if (oracle.result.length === 1) {
                                        msg = `50% ${group} + 50% ${group}`
                                    } else {
                                        msg = msg === '' ? `${x.pct}% ${group}` : `${msg} + ${x.pct}% ${group}`
                                    }
                                })
                                oraclesMsg.push({
                                    message: msg,
                                    distance: oracle.distance
                                })
                            })
                        }
                        if (result.nearest) nearest = result.nearest
                        if (result.result.multi2) {
                            result.result.multi2.map(oracle => {
                                let msg = ''
                                let result = oracle.groups.map((x, i) => {
                                    let group = x.split(':').length > 1 ? x.split(':')[0].replace(/_/g, ' ') : x.replace(/_/g, ' ')
                                    msg = msg === '' ? `50% ${group}` : `${msg} + 50% ${group}`
                                })
                                multi2.push({
                                    message: msg,
                                    distance: oracle.distance
                                })
                            })
                        }
                        if (result.result.multi4) {
                            result.result.multi4.map(oracle => {
                                let msg = ''
                                let fullmsg = ''
                                let result = oracle.groups.map((x, i) => {
                                    let group = x.split(':').length > 1 ? x.split(':')[0].replace(/_/g, ' ') : x.replace(/_/g, ' ')
                                    fullmsg = fullmsg === '' ? `25% ${group}` : `${fullmsg} + 25% ${group}`
                                    //group = group.length > 12 ? group.substr(0,10) + '...' : group;
                                    msg = msg === '' ? `${group}` : `${msg} + ${group}`
                                    //msg = msg === '' ? `${group}` : `${msg} + ${group}`
                                })
                                multi4.push({
                                    message: msg,
                                    distance: oracle.distance,
                                    fullmsg: fullmsg
                                })
                            })
                        }
                    })
                    var status = `${new Date().toLocaleString()}:` + ' Query completed in ' + Math.round((Date.now() - w.start) / 1000) + ' seconds'
                    console.log(status)
                    //w.$store.commit('change', { checkFitsData: resultArr[0] })
                    w.$modal.show('oraclesmodal', {
                        nearest: nearest.slice(0, 20),
                        oracles: oraclesMsg,
                        multi2: multi2,
                        multi4: multi4
                    });
                    w.progress = 0;
                    return oracles;
                } catch (err) {
                    console.log('caught runOracles ', err);
                    w.progress = 0;
                    var error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                    w.$eventBus.$emit('appEvents', {
                        exec: 'setError',
                        component: 'nav',
                        params: error
                    })
                    if (error.indexOf('insufficient credits') >= 0) {
                        let freesub = w.subs && w.subs.subType == 'free' ? true : false
                        let buttons = [{
                            title: 'Cancel',
                            default: true,
                            handler: () => {
                                w.closable = false;
                                w.$modal.hide('dialog');
                            } // Button click handler
                        }]
                        if (freesub) {
                            buttons.unshift({
                                title: 'Subscribe',
                                handler: () => {
                                    w.createNew = false;
                                    w.$modal.hide('dialog');
                                    w.recordEvent('subButtonAnalyze', {
                                        'event_category': 'function',
                                        'event_label': 'User initiated'
                                    })
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'checkSubStatus',
                                        component: 'nav',
                                    })
                                } // Button click handler
                            })
                        }
                        w.$modal.show('dialog', {
                            title: 'Apologies',
                            text: "Unfortunately, you appear to have insufficient credits to execute this action",
                            class: 'warning',
                            buttons: buttons
                        })
                    } else {
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Error',
                                text: error,
                                class: 'failure'
                            }
                        })
                    }
                }
            }
            w.progress = 10;
            getOracles(calculator, eta);
        },
        runOraclesG25() {
            this.recordEvent('runOracles', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            let gmode = 'G25'
            this.tipDisabled = true;
            let customsamples = false;
            setTimeout(() => {
                this.tipDisabled = false;
            }, 70000)
            if (!this.onLine) {
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: 'Application offline',
                        text: 'Please re-run when the application is connected to the internet'
                    }
                });
                return false;
            }
            var subId = this.$store.getters.get('user').username + ':' + this.queryTimeStamp;
            var w = this;
            var nearGroups = [...w.chartJSON[w.currentIndex].nearest]
            var group = []
            nearGroups.map(x => {
                if (x._row) group.push(x._row.split(':')[0])
            })
            var unique = new Set(group)
            var groups = [...unique].slice(0, 8);
            var nearest = false
            var calculator = this.calcArray[0].calculator;
            var quantity = this.calcArray[0].samples;
            var filtered = quantity > 800 ? true : this.aggregatedCalc && !this.rswitches.removeOutliers ? false : true
            var averaged = quantity > 800 ? undefined : this.aggregatedCalc && this.rswitches.groupAveraged ? true : undefined
            var median = quantity > 800 ? true : this.aggregatedCalc && this.rswitches.groupMedian ? true : undefined
            var eta = filtered ? (quantity / 60) * 1000 : (quantity / 300) * 1000
            var creator = this.calcArray[0].user;
            var query = getOraclesQuery
            var type = 'getOracle'
            var params = {
                filtered: filtered,
                averaged: averaged,
                median: median,
            }
            let execArray = [{
                mode: 'mixed'
            }, {
                mode: 'multi'
            }]
            //let execArray = [{ mode: 'mixed'}]
            console.log(`ETA for query is ${Math.round(eta/1000)} seconds`);
            let credits = this.credits || 0
            let estimate = Math.ceil((0.8 * Math.round(eta / 1000)) / 3)
            if (estimate > credits) {
                let freesub = w.subs && w.subs.subType == 'free' ? true : false
                let buttons = [{
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.closable = false;
                        w.$modal.hide('dialog');
                    } // Button click handler
                }]
                if (freesub) {
                    buttons.unshift({
                        title: 'Subscribe',
                        handler: () => {
                            w.createNew = false;
                            w.$modal.hide('dialog');
                            w.recordEvent('subButtonAnalyze', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                }
                w.$modal.show('dialog', {
                    title: 'Apologies',
                    text: `Unfortunately, you appear to have insufficient credits to execute this action<br><br><b>You need ${estimate} credits</b>`,
                    class: 'warning',
                    buttons: buttons
                })
                this.spinner = false;
                return
            }
            let resultArr = [];
            var index = w.currentIndex ? w.currentIndex : 0
            async function getOracles(groups, calculator, nearest, eta) {
                w.start = Date.now()
                const oraclesArr = execArray.map(async mode => {

                    let newParams = JSON.parse(JSON.stringify(params));
                    let grpsmpl = w.categories[index].split(' (')
                    let grp = grpsmpl[1].replace(/\)/, '').trim()
                    let smpl = grpsmpl[0].trim()
                    grpsmpl = `${grp}:${smpl}`
                    //let fullsample = w.rawArrayLocal.find(x => x.index === grpsmpl)
                    let fullsample = w.rawArrayLocal.find(x => x.alias ? (x.alias + ':' + x.index.split(':')[1] == grpsmpl) : x.index === grpsmpl)
                    newParams.groups = groups;
                    //newParams.sample = w.categories[index].replace(/ ► /g, ':');
                    newParams.sample = fullsample.index
                    if (w.g25customsamples && w.g25customsamples.length > 0 && w.g25customsamples.findIndex(x => x == newParams.sample) >= 0) customsamples = w.g25Rerun
                    newParams.sample = fullsample.v ? newParams.sample.split(':')[0] + '|' + fullsample.v + ':' + newParams.sample.split(':')[1] : newParams.sample
                    newParams.calculator = calculator;
                    newParams.creator = creator;
                    newParams.raw = false
                    //newParams.id = subId;
                    newParams.id = w.categories[index].replace(/ ► /g, ':') + ':oracle:' + mode.mode
                    newParams.sub = subId;
                    newParams.nearest = nearest;
                    newParams.customsamples = customsamples;
                    newParams.result = w.chartJSON[w.currentChartIndex] && w.chartJSON[w.currentChartIndex].groupResult ? w.chartJSON[w.currentChartIndex].groupResult : w.chartJSON[w.currentChartIndex] && w.chartJSON[w.currentChartIndex].result ? w.chartJSON[w.currentChartIndex].result : false;
                    newParams.multi = mode.mode && mode.mode === 'multi' ? true : false;
                    const data = await w.$apollo.query({
                        query: query,
                        variables: {
                            params: JSON.stringify(newParams)
                        }
                    })
                    if (data.data && data.data[type]) {
                        let output = data.data[type];
                        let result = output.result ? JSON.parse(output.result) : false
                        let outdata = {
                            result: result,
                        };
                        resultArr.push(outdata);
                        return outdata
                    } else {
                        return false;
                    }
                });
                //w.$sentry.configureScope(scope => { scope.setTag("transactionId", subId); });
                try {
            console.log('currentChartIndex', w.currentChartIndex)
                    const oracles = await Promise.all(oraclesArr);
                    let oraclesMsg = []
                    let multi2 = []
                    let multi4 = []
                    let output = resultArr.map(result => {
                        if (result.result.oracles) {
                            result.result.oracles.map(oracle => {
                                let msg = ''
                                let result = oracle.result.map((x, i) => {
                                    let group = x.group.replace(/_/g, ' ')
                                    group = group.split(' [').length > 1 ? group.split(' [')[1].replace(/\]/, '') + '_' + group.split(' [')[0] : group
                                    if (oracle.result.length === 1) {
                                        msg = `50% ${group} + 50% ${group}`
                                    } else {
                                        msg = msg === '' ? `${x.pct}% ${group}` : `${msg} + ${x.pct}% ${group}`
                                    }
                                })
                                oraclesMsg.push({
                                    message: msg,
                                    distance: oracle.distance
                                })
                            })
                        }
                        if (result.result.multi2) {
                            result.result.multi2.map(oracle => {
                                let msg = ''
                                let result = oracle.groups.map((x, i) => {
                                    let group = x.split(':').length > 1 ? x.split(':')[0].replace(/_/g, ' ') : x.replace(/_/g, ' ')
                                    msg = msg === '' ? `50% ${group}` : `${msg} + 50% ${group}`
                                })
                                multi2.push({
                                    message: msg,
                                    distance: oracle.distance
                                })
                            })
                        }
                        if (result.result.multi4) {
                            result.result.multi4.map(oracle => {
                                let msg = ''
                                let fullmsg = ''
                                let result = oracle.groups.map((x, i) => {
                                    let group = x.split(':').length > 1 ? x.split(':')[0].replace(/_/g, ' ') : x.replace(/_/g, ' ')
                                    fullmsg = fullmsg === '' ? `25% ${group}` : `${fullmsg} + 25% ${group}`
                                    //group = group.length > 12 ? group.substr(0,10) + '...' : group;
                                    msg = msg === '' ? `${group}` : `${msg} + ${group}`
                                    //msg = msg === '' ? `${group}` : `${msg} + ${group}`
                                })
                                multi4.push({
                                    message: msg,
                                    distance: oracle.distance,
                                    fullmsg: fullmsg
                                })
                            })
                        }
                    })
                    var status = `${new Date().toLocaleString()}:` + ' Query completed in ' + Math.round((Date.now() - w.start) / 1000) + ' seconds'
                    console.log(status)
                    //w.$store.commit('change', { checkFitsData: resultArr[0] })
                    console.log('chartJSON', w.currentChartIndex);
                    var nearest = [...w.chartJSON[w.currentChartIndex].nearest].slice(0, checkfit)
                    let checkfit = 100
                    w.$modal.show('oraclesmodal', {
                        nearest: nearest,
                        oracles: oraclesMsg,
                        multi2: multi2,
                        multi4: multi4
                    });
                    w.progress = 0;
                    return oracles;
                } catch (err) {
                    console.log('caught runOracles ', err);
                    w.progress = 0;
                    var error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                    w.$eventBus.$emit('appEvents', {
                        exec: 'setError',
                        component: 'nav',
                        params: error
                    })
                    if (error.indexOf('insufficient credits') >= 0) {
                        let freesub = w.subs && w.subs.subType == 'free' ? true : false
                        let buttons = [{
                            title: 'Cancel',
                            default: true,
                            handler: () => {
                                w.closable = false;
                                w.$modal.hide('dialog');
                            } // Button click handler
                        }]
                        if (freesub) {
                            buttons.unshift({
                                title: 'Subscribe',
                                handler: () => {
                                    w.createNew = false;
                                    w.$modal.hide('dialog');
                                    w.recordEvent('subButtonAnalyze', {
                                        'event_category': 'function',
                                        'event_label': 'User initiated'
                                    })
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'checkSubStatus',
                                        component: 'nav',
                                    })
                                } // Button click handler
                            })
                        }
                        w.$modal.show('dialog', {
                            title: 'Apologies',
                            text: `Unfortunately, you appear to have insufficient credits to execute this action`,
                            class: 'warning',
                            buttons: buttons
                        })
                    } else {
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Error',
                                text: error,
                                class: 'failure'
                            }
                        })
                    }
                }
            }
            w.progress = 10;
            getOracles(groups, calculator, nearest, eta);
        },
        runFit() {
            console.log('here', this.chartJSON)
            if (this.secondaryTabs == 'table' && this.gridApi && this.gridApi.getSelectedRows && this.gridApi.getSelectedRows() && this.gridApi.getSelectedRows().length) {
                let selectedRows = this.gridApi.getSelectedRows();
                let chartindex = 0;
                try {
                chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '').replace(/_/g, ' ')} (${x.alias.split(':')[0]})`.trim() == selectedRows[0].originalsample.replace(/_/g, ' ').trim())
                this.currentChartIndex = chartindex;
                }
                catch(err) {
                console.log('runFit', err);
                }
            } else {
                let profile = this.categories[this.currentIndex]
                let chartindex = 0;
                try {
                chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '')} (${x.alias.split(':')[0]})`.replace(/_/g, ' ').trim() == this.categories[this.currentIndex].replace(/-raw/, '').replace(/_/g, ' ').trim() || (x.alias.split(':')[0].replace(/_/g, ' ').includes(profile.split(' (')[1].replace(/_/g, ' ').replace(')', '')) && x.alias.split(':')[1].replace(/_/g, ' ').trim().includes(profile.split(' (')[0].replace(/_/g, ' ').trim())))
                this.currentChartIndex = chartindex;
                }
                catch(err) {
                console.log('runFit2', err);
                }
            }
            this.currentChartIndex = this.currentChartIndex >= 0 ? this.currentChartIndex : 0;
            if (this.G25calc) {
                this.runOraclesG25()
            } else {
                this.runOracles();
            }
            return;
            if (this.calculator) {
                if (this.calcComponents.length > 0 && this.calcArray[0]) {} else {
                    this.$eventBus.$emit('appEvents', {
                        exec: 'show',
                        component: 'nav',
                        params: {
                            class: 'warning',
                            title: 'Error',
                            text: 'No calculator selected'
                        }
                    });
                    return
                }
            } else {
                this.runOracles();
                return;
            }
            this.tipDisabled = true;
            setTimeout(() => {
                this.tipDisabled = false;
            }, 70000)
            if (!this.onLine) {
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: 'Application offline',
                        text: 'Please re-run when the application is connected to the internet'
                    }
                });
                return false;
            }
            var subId = this.$store.getters.get('user').username + ':' + this.queryTimeStamp;
            var averaged = this.rswitches.groupAveraged ? true : false
            var median = this.rswitches.groupMedian ? true : false
            var filtered = this.rswitches.removeOutliers ? true : false
            var maxfits = this.slider.maxfits && this.slider.maxfits.value ? this.slider.maxfits.value : 20
            var params = {}
            if (averaged) params.averaged = averaged
            if (median) params.median = median
            if (filtered) params.filtered = filtered
            var filter = averaged ? 1 : median ? 2 : filtered ? 3 : 0;
            var w = this;
            var eta = params.median || params.averaged ? 3000 : params.filtered ? 5000 : 8000
            console.log(`ETA for query is ${Math.round(eta/1000)} seconds`);
            let credits = this.credits || 0
            let estimate = Math.ceil((0.8 * Math.round(eta / 1000)) / 3)
            if (estimate > credits) {
                let freesub = w.subs && w.subs.subType == 'free' ? true : false
                let buttons = [{
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.closable = false;
                        w.$modal.hide('dialog');
                    } // Button click handler
                }]
                if (freesub) {
                    buttons.unshift({
                        title: 'Subscribe',
                        handler: () => {
                            w.createNew = false;
                            w.$modal.hide('dialog');
                            w.recordEvent('subButtonAnalyze', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                }
                w.$modal.show('dialog', {
                    title: 'Apologies',
                    text: `Unfortunately, you appear to have insufficient credits to execute this action<br><br><b>You need ${estimate} credits</b>`,
                    class: 'warning',
                    buttons: buttons
                })
                this.spinner = false;
                return
            }
            let resultArr = [];
            var index = w.currentIndex ? w.currentIndex : 0
            var samples = [w.categories[index].replace(/ ► /g, ':')]
            async function getResults(samples, eta) {
                w.start = Date.now()
                const profilesArr = samples.map(async sample => {
                    let newParams = JSON.parse(JSON.stringify(params));
                    let fullsample = w.rawArrayLocal.find(x => x.index === sample)
                    newParams.sample = sample
                    newParams.sample = fullsample.v ? newParams.sample.split(':')[0] + '|' + fullsample.v + ':' + newParams.sample.split(':')[1] : newParams.sample
                    newParams.id = sample + ':fit:' + filter + ':' + maxfits + ':' + w.categories[index];
                    newParams.sub = subId;
                    //newParams.phrase = true;
                    newParams.maxfits = maxfits;
                    const data = await w.$apollo.query({
                        query: getFitQuery,
                        variables: {
                            params: JSON.stringify(newParams)
                        }
                    })
                    if (data.data && data.data.getFit) {
                        let output = data.data.getFit;
                        let result = output.result ? JSON.parse(output.result) : false
                        w.filterResults = {
                            quantity: output.quantity,
                            filtered: output.filtered
                        }
                        let outdata = {
                            result: result,
                        };
                        resultArr.push(outdata);
                        return outdata
                    } else {
                        return false;
                    }
                });
                //w.$sentry.configureScope(scope => { scope.setTag("transactionId", subId); });
                try {
                    const profiles = await Promise.all(profilesArr);
                    var obj = resultArr[0].result
                    var filterMsg = w.filterResults && w.filterResults.filtered && w.filterResults.filtered > 0 ? ` >> filtered: ${w.filterResults.filtered} outliers/${w.filterResults.quantity} samples` : ''
                    var status = `${new Date().toLocaleString()}:` + ' Query completed in ' + Math.round((Date.now() - w.start) / 1000) + ' seconds' + filterMsg
                    console.log(status)
                    w.$store.commit('change', {
                        checkFitsData: resultArr[0]
                    })
                    w.progress = 0;
                    var nearest = w.chartJSON[index].nearest
                    w.$modal.show('checkfits', {
                        nearest: nearest.slice(0, maxfits)
                    });
                    return profiles
                } catch (err) {
                    console.log('caught runFit ', err);
                    w.progress = 0;
                    var error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                    w.$eventBus.$emit('appEvents', {
                        exec: 'setError',
                        component: 'nav',
                        params: error
                    })
                    if (error.indexOf('insufficient credits') >= 0) {
                        let freesub = w.subs && w.subs.subType == 'free' ? true : false
                        let buttons = [{
                            title: 'Cancel',
                            default: true,
                            handler: () => {
                                w.closable = false;
                                w.$modal.hide('dialog');
                            } // Button click handler
                        }]
                        if (freesub) {
                            buttons.unshift({
                                title: 'Subscribe',
                                handler: () => {
                                    w.createNew = false;
                                    w.$modal.hide('dialog');
                                    w.recordEvent('subButtonAnalyze', {
                                        'event_category': 'function',
                                        'event_label': 'User initiated'
                                    })
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'checkSubStatus',
                                        component: 'nav',
                                    })
                                } // Button click handler
                            })
                        }
                        w.$modal.show('dialog', {
                            title: 'Apologies',
                            text: `Unfortunately, you appear to have insufficient credits to execute this action`,
                            class: 'warning',
                            buttons: buttons
                        })
                    } else {
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Error',
                                text: error,
                                class: 'failure'
                            }
                        })
                    }
                }
            }
            w.progress = 10;
            getResults(samples);
        },
        getKey() {
            this.destroyIntro();
            if (this.spinner) {
                this.spinner = false
                return false;
            }
            if (this.nocredits) {
                let freesub = this.subs && this.subs.subType == 'free' ? true : false
                let buttons = [{
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        this.closable = false;
                        this.$modal.hide('dialog');
                    } // Button click handler
                }]
                if (freesub) {
                    buttons.unshift({
                        title: 'Subscribe',
                        handler: () => {
                            this.createNew = false;
                            this.$modal.hide('dialog');
                            this.recordEvent('subButtonAnalyze', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            this.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                }
                this.$modal.show('dialog', {
                    title: 'Apologies',
                    text: `Unfortunately, you appear to have insufficient credits to execute this action`,
                    class: 'warning',
                    buttons: buttons
                })
                return
            }
            if (this.G25calc) {
                this.spinner = true
                this.runCalc()
                return;
            }
            if (!this.$store.getters.get('lastsync') && this.rawArrayLocal.findIndex(x => x.SSE !== true) >= 0) {
                let buttons = [{
                    title: 'OK',
                    handler: (i, event) => {
                        this.$eventBus.$emit('appEvents', {
                            exec: 'runMonte',
                            component: 'g25',
                            params: this.decryptToken
                        })
                        this.$modal.hide('getkeymodal');
                    }
                }, {
                    title: 'CANCEL',
                    default: true
                }]
                this.$modal.show('getkeymodal', {
                    title: 'Please paste your decryption token',
                    text: "Your raw DNA file(s) cannot be read without your previously provided encryption token",
                    input: "decryption key",
                    buttons: buttons,
                    clickToClose: false,
                    class: 'default',
                    beforeClosed: function(event) {
                        console.log('closing', event)
                    }
                })
            } else {
                if (this.running) {
                    this.$store.commit('change', {
                        spinner: false
                    })
                    return false;
                } else {
                    this.$store.commit('change', {
                        spinner: true
                    })
                    this.runMonte()
                }
            }
        },
        getIsotope: () => {
            return new Promise((resolve, reject) => {
                if (!window.Isotope) {
                    let script = document.createElement('script')
                    script.onload = () => {
                        console.log('loaded isotope script')
                        resolve(true)
                    }
                    script.async = true
                    script.src = 'https://static.genoplot.com/dist/isotope.pkgd.min.js'
                    document.head.appendChild(script)
                } else {
                    resolve(false)
                }
            })
        },
        getVueIsotope: () => {
            return new Promise((resolve, reject) => {
                let script = document.createElement('script')
                script.onload = () => {
                    console.log('loaded vue-isotope script')
                    resolve(true)
                }
                script.async = true
                script.src = 'https://static.genoplot.com/dist/vue-isotope.min.js'
                document.head.appendChild(script)
            })
        },
        runMonte: async function() {
            let w = this;
            //w.refs = { samples: [], components: [] };
                if (this.chromo) {
                    if (this.rawArrayLocal.length > 1) {
                        w.spinner = false;
                        this.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Unable to run calculator',
                                text: 'You can only run one DNA sample at a time when running individual cycles for all 22 chromosomes',
                                class: 'warning'
                            }
                        });
                        return false;
                    }
                }
            w.start = Date.now()
            w.subResults = [];
            let subArray = JSON.parse(JSON.stringify(w.rawArrayLocal))
            if (!w.G25 && w.chromo) {
                let n = 1;
                while (n < 23) {
                    let sample = {
                        ...subArray[0]
                    }
                    sample.chromosome = n.toString();
                    subArray.push(sample)
                    n++
                }
            }
            w.subArray = subArray;
            w.counterArray = subArray.map(x => x.profile)
            w.maxVals = {}
            w.maxRefVals = {}
            let decryptKey = window.atob && this.$store.getters.get('lastsync') ? atob(this.$store.getters.get('lastsync')) : ''
            var evt = 'collapse-select';
            let ca = w.scrollCalcs[w.activeItemIndex]
            let calculator = w.calcArray[0]
            /*
            if (calculator.oracle) {
                w.subArray.push({
                    ref: true,
                    calculator: calculator.calculator,
                    creator: "internalGenoplot",
                    id: calculator.calculator + Date.now(),
                    sub: calculator.calculator + Date.now()
                })
            }
            */
            setTimeout(() => {
                this.$root.$emit(evt, 'collapse');
            }, 0)
            let eta = this.calcArray[0].eta * 1000
            this.recordEvent('runRawCalc', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            this.chartReady = false;
            let calc = this.calcArray[0].mapped ? this.calcArray[0].mapped.replace(/_V.*?$/, '') : this.calcArray[0].calculator.replace(/_V.*?$/, '')
            if (!this.recalc) {
                const rawResultsArr = w.subArray.map(async (sample) => {
                    sample.simrun = false;
                    let response, variables, query;
                    if (sample.ref) {
                        variables = {
                            params: JSON.stringify(sample)
                        }
                        response = 'getRef'
                        query = getRefsQuery;
                    } else {
                        query = getRawResultQuery;
                        response = 'getRawResults'
                        variables = {
                            userid: sample.mode === 'raw' ? 'publicsamples' : w.user.username,
                            result: sample.mode === 'raw' ? `${calc}|${sample.index.split(':')[0]}|${sample.index.split(':')[1]}` + (sample.chromosome ? `:${sample.chromosome}` : '') : `${sample.object.split('/')[1]}|${sample.object.split('/')[2]}|${calc}` + (sample.chromosome ? `:${sample.chromosome}` : '')
                        }
                    }
                    let data = await w.$apollo.query({
                        query: query,
                        variables: variables,
                        fetchPolicy: response == 'getRawResults' ? 'network-only' : undefined
                    })
                    if (data && data.data && data.data[response]) {
                        if (response == 'getRawResults') {
                            let result = JSON.parse(JSON.parse(data.data.getRawResults.json))
                            w.subResults.push(result);
                            consoleWithNoSource(`${result.profile.replace(/-raw/,'')}: ${result.stats.matches}/${result.stats.snps} SNPs (${(result.stats.matches/result.stats.snps * 100).toFixed(2)}%) used for this analysis (count: ${result.stats.total})`)
                            let index = w.subArray.findIndex(x => x.index == sample.index)
                            w.subArray.splice(index, 1)

                        } else {
                            if (data && data.data && data.data[response] && data.data[response].result) {
                                let ref = data.data[response].result
                                ref = ref.split('||')
                                let refs = {
                                    components: ['samples'],
                                    samples: []
                                }
                                refs.components = ref[0].split(',').slice(1, ref[0].split(',').length)
                                let len = ref.length
                                refs.samples = new Array(len - 1);
                                let maxVals = {}
                                for (let i = 0; i < len; i++) {
                                    if (i > 0) {
                                        let reference = ref[i].split(',')
                                        refs.samples[i - 1] = reference
                                        refs.components.forEach((x, n) => {
                                            let comp = x
                                            maxVals[comp] = maxVals[comp] == undefined ? parseFloat(reference[n + 1]) : maxVals[comp] < parseFloat(reference[n + 1]) ? parseFloat(reference[n + 1]) : maxVals[comp]
                                        })
                                    }
                                }
                                w.maxRefVals = maxVals;
                                w.refs = refs
                                let index = w.subArray.findIndex(x => x.ref)
                                w.subArray.splice(index, 1)
                            }
                        }
                    }
                })
                try {
                    const rawResults = await Promise.all(rawResultsArr);
                    console.log('Existing', w.subResults.length);
                } catch (err) {
                    consoleWithNoSource(err)
                }
            }
            //w.spinner = false;
            //return;
            let rerun = this.recalc ? true : false;
            this.simrun = this.recalc ? true : false;
            this.recalc = false;
            eta = eta < 2000 ? 2000 : eta;
            eta = rerun ? eta * 1.25 : eta
            eta = w.chromo ? 1.5 * eta : eta
            let estimate = Math.ceil((Math.round(eta / 1000)) / 3) * this.subArray.length
            console.log('estimate', estimate);
            let credits = this.credits || 0
            if (w.subArray.length > 0) {
                consoleWithNoSource(`ETA for query is ${Math.ceil(eta/1000)} seconds`);
            } else {}
            if (estimate > credits && (estimate > 0)) {
                let freesub = w.subs && w.subs.subType == 'free' ? true : false
                let buttons = [{
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.closable = false;
                        w.$modal.hide('dialog');
                    } // Button click handler
                }]
                if (freesub) {
                    buttons.unshift({
                        title: 'Subscribe',
                        handler: () => {
                            w.createNew = false;
                            w.$modal.hide('dialog');
                            w.recordEvent('subButtonChromo', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                }
                let text = w.chromo ? 'You are attempting to run all 22 chromosomes individually which works out to 23 calculator cycles.<br></br><b>You need a minimum of 200 credits to complete this action</b>' : `Unfortunately, you appear to have insufficient credits to execute this action<br><br><b>You need ${estimate} credits</b>`
                w.$modal.show('dialog', {
                    title: 'Apologies',
                    text: text,
                    class: 'warning',
                    buttons: buttons
                })
                this.spinner = false;
                return
            }
            this.$store.commit('change', {
                statusMessage: ''
            })
            if (!this.onLine) {
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: 'Application offline',
                        text: 'Please re-run when the application is connected to the internet'
                    }
                });
                return false;
            }
            this.gridKey += 1;
            this.$store.commit('change', {
                g25firstRun: true
            })
            if (!this.gridApi) this.gridApi = this.gridOptions.api;
            this.$store.commit('change', {
                lastSort: false
            })
            var subId = this.$store.getters.get('user').username + ':' + Date.now()
            this.$store.commit('change', {
                subId: subId
            })
            var success = false;
            this.chartReady = false;
            var arr = this.calcArray;
            this.$store.commit('change', {
                rawchartSeries: []
            })
            this.components = this.calcArray[0].components
            this.$store.commit('change', {
                rawchartComponents: this.components
            })
            var chartColors = this.chartColors[this.slider.colors.value - 1]
            var colors = [...chartColors].slice(0, this.components.length);
            this.$store.commit('change', {
                rawchartColors: colors
            })
            var chartOptions = this.chartOptions;
            chartOptions.colors = colors;
            this.chartOptions = chartOptions;
            var arr2 = this.rawArrayLocal;
            var leftArr = []
            arr2.forEach(sample => {
                leftArr.push(sample.sample)
            })
            this.$store.commit('change', {
                rawchartCategories: leftArr
            })
            var chartOptions = this.chartOptions;
            this.chartOptions = chartOptions;
            var params = {
                sub: subId,
                models: [this.calcArray[0].mapped ? this.calcArray[0].mapped : this.calcArray[0].calculator],
                sort: false
            }
            var samples = leftArr;
            w.$store.commit('change', {
                rawchartJSON: []
            })
            w.$store.commit('change', {
                rawchartRefs: false
            })
            w.$store.commit('change', {
                rawchartCategories: samples
            })
            chartOptions = w.chartOptions
            w.chartOptions = chartOptions;
            async function invokeLambda(samples, eta) {
                    if ( w.chromo ) {
                            w.recordEvent('execChromo', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            }
                w.reqnum = w.subArray.length;
                const profilesArr = w.subArray.map(async (sample, i) => {
                    let query, variables, response;
                    if (sample.ref) {
                        variables = {
                            params: JSON.stringify(sample)
                        }
                        response = 'getRef'
                        query = getRefsQuery;
                    } else {
                        let largecalc = w.calcArray[0].mapped ? w.calcArray[0].mapped : w.calcArray[0].calculator
                        largecalc = w.largeCalcs.some(x => x == largecalc)
                        try {
                            if (w.configs && w.configs.length) {
                                await Promise.all(w.configs.map(async parameter => {
                                    let query = getConfigQuery;
                                    try {
                                        const data = await w.$apollo.query({
                                            query: query,
                                            variables: {
                                                component: 'admix',
                                                parameter: parameter
                                            },
                                            fetchPolicy: 'network-only'
                                        })
                                        if (data && data.data && data.data.getConfig && data.data.getConfig.value) {
                                            w[parameter] = data.data.getConfig.value
                                            console.log(`${parameter} set to ${w[parameter]}`)
                                        }
                                    } catch (err) {
                                        console.log(err)
                                    }
                                }))
                            }
                        } catch (err) {
                            console.log('get config err', err)
                        }
                        query = (w.G25calc || largecalc || w.rawcalcfunction == 'lambda') ? invokeCalcQuery : invokeCalcModalQuery;
                        response = (w.G25calc || largecalc || w.rawcalcfunction == 'lambda') ? 'invokeCalc' : 'invokeCalcModal';
                        let newParams = JSON.parse(JSON.stringify(params));
                        newParams.sample = sample.index
                        newParams.rerun = rerun ? true : false,
                            newParams.tolerance = rerun ? "1e-4" : "1e-3",
                            newParams.id = sample.sample + ':' + Date.now();
                        newParams.noDelay = true,
                            newParams.vendor = sample.mode === 'raw' ? '23andme' : sample.vendor;
                        if (sample.chromosome) newParams.chromosome = sample.chromosome;
                        newParams.key = sample.SSE ? 'sse' : decryptKey
                        newParams.obj = sample.mode === 'raw' ? sample.index.split(':')[0] + '/' + sample.index.split(':')[1] + '.zip' : sample.object
                        newParams.monitor = true;
                        newParams.background = true;
                        if (sample.v2) {
                            newParams.phrase = true;
                            if (w.user && w.user.sub) newParams.sequence = w.user.sub
                        }
                        variables = {
                            event: JSON.stringify(newParams)
                        }
                    }
                    //console.log('querying', variables, query, response);
                    const data = await w.$apollo.query({
                        query: query,
                        variables: variables
                    })
                    if (response == 'invokeCalcQuery' || response == 'invokeCalcModalQuery') {
                        if (data.data && data.data[response] && data.data[response].status == "PENDIMG") {
                            return data.data[response].status
                        } else if (data.data && data.data.invokeOptiFit && data.data.invokeOptiFit.status == "PENDIMG") {
                            return data.data.invokeOptiFit.status

                        } else {
                            consoleWithNoSource('Invoke lambda failed for ' + sample);
                            consoleWithNoSource(data);
                            return data;
                        }
                    } else {
                        if (data && data.data && data.data[response] && data.data[response].result) {
                            let ref = data.data[response].result
                            ref = ref.split('|')
                            let refs = {
                                components: ['samples'],
                                samples: []
                            }
                            refs.components = ref[0].split(',').slice(1, ref[0].split(',').length)
                            let len = ref.length
                            let maxVals = {}
                            for (let i = 0; i < len; i++) {
                                if (i > 0) {
                                    let reference = ref[i].split(',')
                                    refs.samples[i - 1] = reference
                                    refs.components.forEach((x, n) => {
                                        let comp = x
                                        maxVals[comp] = maxVals[comp] == undefined ? parseFloat(reference[n + 1]) : maxVals[comp] < parseFloat(reference[n + 1]) ? parseFloat(reference[n + 1]) : maxVals[comp]
                                    })
                                }
                            }
                            w.maxRefVals = maxVals;
                            w.subResults.forEach((sample, i) => {
                                let result = {}
                                Object.keys(sample.result).map(x => result[x.replace(/_/g, ' ')] = sample.result[x])
                                sample.result = result;
                                w.components.forEach((comp, n) => {
                                    if (sample.result[comp]) {
                                        maxVals[comp] = maxVals[comp] == undefined ? sample.result[comp] : maxVals[comp] < sample.result[comp] ? sample.result[comp] : maxVals[comp]
                                    }
                                    if (sample.result[comp] && sample.result[comp] > 0) nonZeroComp[comp] = true
                                    if (sample.result[comp] >= val) {
                                        sortKey = comp;
                                        val = sample.result[comp]
                                        profile = sample.profile
                                        index = i
                                        compindex = n
                                    }
                                })
                            })
                            w.maxVals = maxVals;
                            w.refs = refs
                            let index = w.subArray.findIndex(x => x.ref)
                            w.subArray.splice(index, 1)
                            //console.log(refs);
                        }
                    }
                });
                //w.$sentry.configureScope(scope => { scope.setTag("transactionId", subId); });
                try {
                    const profiles = await Promise.all(profilesArr);
                    return profiles
                } catch (err) {
                    consoleWithNoSource('caught invokeCalc', err);
                    w.error = err.info && err.message ? err.info + err.message : err.message ? err.message : err.Message ? err.Message : err
                    w.$eventBus.$emit('appEvents', {
                        exec: 'setError',
                        component: 'nav',
                        params: w.error

                    })
                    w.$store.commit('change', {
                        spinner: false
                    })
                    w.progress = 0;
                    if (w.error.indexOf('insufficient credits') >= 0) {
                        let freesub = w.subs && w.subs.subType == 'free' ? true : false
                        let buttons = [{
                            title: 'Cancel',
                            default: true,
                            handler: () => {
                                w.closable = false;
                                w.$modal.hide('dialog');
                            } // Button click handler
                        }]
                        if (freesub) {
                            buttons.unshift({
                                title: 'Subscribe',
                                handler: () => {
                                    w.createNew = false;
                                    w.$modal.hide('dialog');
                                    w.recordEvent('subButtonAnalyze', {
                                        'event_category': 'function',
                                        'event_label': 'User initiated'
                                    })
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'checkSubStatus',
                                        component: 'nav',
                                    })
                                } // Button click handler
                            })
                        }
                        w.$modal.show('dialog', {
                            title: 'Apologies',
                            text: `Unfortunately, you appear to have insufficient credits to execute this action`,
                            class: 'warning',
                            buttons: buttons
                        })
                    } else {
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Error',
                                text: w.error,
                                class: 'failure'
                            }
                        })
                    }
                    var json = w.$store.getters.get('rawchartJSON')
                    if (Array.isArray(json) && json.length > 2) {
                        w.$store.commit('change', {
                            spinner: false
                        })
                        w.unchanged = true;
                        w.processJSON(w.components[0]);
                    }
                    if (w.refs && w.refs.samples && w.refs.samples.length > 0) {
                        w.$store.commit('change', {
                            rawchartRefs: w.refs
                        })
                    }
                }
            }
            let timeout = samples.length < 20 ? 2000 : samples.length < 40 ? 5000 : 10000
            w.subMonte(params.sub, eta + timeout);
            if (w.subArray.length > 0) {
                setTimeout(() => {
                    invokeLambda(samples);
                }, timeout)
            }
        },
        subMonte(subId, eta) {
            this.progress = 0;
            var subscription;
            const w = this;
            if (w.subResults.length === w.counterArray.length) {
                endSubscription()
            }

            async function endSubscription() {
                if (subscription && subscription.unsubscribe && typeof(subscription.unsubscribe) == 'function') {
                    w.progress = 100;
                    //w.$Progress.finish()
                    consoleWithNoSource('ending subscription...');
                    subscription.unsubscribe();
                    subscription = false;
                    w.$store.commit('change', {
                        spinner: false
                    })
                    w.progress = 0;
                    if (w.errorArray.length > 0) {
                        var errMessage = ''
                        w.errorArray.forEach(error => {
                            errMessage = errMessage + error + '<br>';
                        })
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Error',
                                text: errMessage,
                                class: 'failure'
                            }
                        })
                    }
                    if (w.subResults.length > 0 && w.calcArray && w.calcArray.length > 0 && (w.calcArray[0].calculator.indexOf("EUROGENESK13") >= 0 || w.calcArray[0].calculator.indexOf("EUROGENESK15") >= 0 || w.calcArray[0].calculator.indexOf("HARAPPAWORLD") >= 0 || w.calcArray[0].calculator.indexOf("K36") >= 0 || w.calcArray[0].g25sim)) {
                        let invokeSims = async function() {
                            const profilesArr = w.subResults.map(async sample => {
                                if (sample.runsim && (sample.profile.split(':')[0] == w.user.username)) {
                                    let coords;
                                    if (w.calcArray[0].calculator.indexOf("K36") >= 0) {
                                        coords = w.calcArray[0].components.map(x => sample.result[x.replace(/_/g, ' ')] ? sample.result[x.replace(/_/g, ' ')] : 0).join(',')
                                    } else {
                                        coords = w.calcArray[0].components.map(x => sample.result[x] ? sample.result[x] : 0).join(',')
                                    }
                                    let params = {
                                        sub: w.user.username,
                                        id: w.user.username + Date.now(),
                                        sample: sample.profile.replace(/-raw/, '') + '-sim',
                                        coords: coords,
                                        sim: true,
                                        mode: w.calcArray[0].calculator.indexOf("EUROGENESK15") >= 0 ? 'EUROGENESK15' : w.calcArray[0].calculator.indexOf("EUROGENESK13") >= 0 ? 'EUROGENESK13' : w.calcArray[0].calculator.indexOf("K36") >= 0 ? 'K36' : w.calcArray[0].calculator.split('_')[0]
                                    }
                                    if ( sample.chromosome || sample.profile.includes('_chr') )   params.quiet = true;
                                    const data = await w.$apollo.query({
                                        query: invokeSimQuery,
                                        variables: {
                                            event: JSON.stringify(params)
                                        }
                                    })
                                    if (data && data.data && data.data.invokeSim && data.data.invokeSim.status) {
                                        console.log(`Simulation created for ${params.sample} (${params.mode})`)
                                    } else {
                                        console.log(`Simulation failed for ${params.sample} (${params.mode})`, data)
                                    }
                                }
                            });
                            try {
                                const profiles = await Promise.all(profilesArr);
                                w.simrun = false;
                                return profiles
                            } catch (err) {
                                console.log(err)
                                w.simrun = false;
                            }
                        }
                        invokeSims()
                    }
                    if (w.subResults.length === 1) {
                        var obj = w.subResults[0].result
                        var keys = w.subResults.length === 1 ? Object.keys(w.subResults[0].result) : w.components
                    } else {
                        let nonZeroComp = {}
                        var val = 0;
                        var index = 0;
                        var compindex = 0;
                        var profile = false;
                        w.components = w.components.map(x => x = x.replace(/_/g, ' '))
                        var sortKey = w.components[0]
                        let maxVals = {}
                        w.subResults.forEach((sample, i) => {
                            let result = {}
                            Object.keys(sample.result).map(x => result[x.replace(/_/g, ' ')] = sample.result[x])
                            sample.result = result;
                            w.components.forEach((comp, n) => {
                                if (sample.result[comp]) {
                                    maxVals[comp] = maxVals[comp] == undefined ? sample.result[comp] : maxVals[comp] < sample.result[comp] ? sample.result[comp] : maxVals[comp]
                                }
                                if (sample.result[comp] && sample.result[comp] > 0) nonZeroComp[comp] = true
                                if (sample.result[comp] >= val) {
                                    sortKey = comp;
                                    val = sample.result[comp]
                                    profile = sample.profile
                                    index = i
                                    compindex = n
                                }
                            })
                        })
                        w.maxVals = maxVals;
                        var obj = w.subResults[index].result
                        var keys = Object.keys(nonZeroComp);
                    }
                    keys.sort(function(a, b) {
                        var x = obj[a] ? obj[a] : 0;
                        var y = obj[b] ? obj[b] : 0;
                        return ((x < y) ? 1 : ((x > y) ? -1 : 0))
                    })
                    w.components = keys
                    w.$store.commit('change', {
                        rawchartJSON: w.subResults
                    })
                    if (w.refs && w.refs.samples && w.refs.samples.length > 0) {
                        w.$store.commit('change', {
                            rawchartRefs: w.refs
                        })
                    }
                    w.$store.commit('change', {
                        spinner: false
                    })
                    //w.processJSON( w.chromo ?  'sample' : w.components[0]);
                    w.processJSON(w.components[0], w.chromo ? true : false);
                    w.chromo = false;
                    w.progress = 0;
                }
            }
            const observable = this.$apollo.subscribe({
                query: onPublishResultSub,
                variables: {
                    id: subId
                }
            });
            var checkSub = function() {
                if (subscription !== false) {
                    endSubscription()
                    var status = `${new Date().toLocaleString()}: Query ${subId} did not complete ${w.reqnum} subqueries/${w.subArray.length} within 15 seconds of first subquery`
                    consoleWithNoSource(status);
                    w.$eventBus.$emit('appEvents', {
                        exec: 'setError',
                        component: 'nav',
                        params: status
                    })
                    //w.$sentry.configureScope(scope => { scope.setTag("errorType", "incompleteResults"); });
                    //w.$sentry.captureException(new Error(`${new Date().toLocaleString()}: Query ${subId} did not complete ${w.reqnum} subqueries/${w.rawArrayLocal.length} within 15 seconds of first subquery`))
                } else {
                    var filterMsg = w.filterResults && w.filterResults.filtered && w.filterResults.filtered > 0 ? ` >> filtered: ${w.filterResults.filtered} outliers/${w.filterResults.quantity} samples` : ''
                    var status = `${new Date().toLocaleString()}: Subscription for query ${subId} ended in ${Math.round((Date.now() - w.start) / 1000)} seconds with no incomplete subqueries/${w.subArray.length}` + filterMsg
                    consoleWithNoSource(status);
                    w.$store.commit('change', {
                        lastQuery: status
                    })
                    if (w.subArray.length == 1) {
                        w.secondaryTabs = 'references'
                    }
                }
            }
            var subTimer;
            w.errorArray = []
            let substart = Date.now()
            var noresultTimer = setTimeout(function() {
                checkSub();
                clearTimeout(subTimer);
            }, eta + 25000)
            const realtimeResults = function realtimeResults(data) {
                w.reqnum = w.reqnum - 1
                try {
                    var result = JSON.parse(data.data.onPublishResult.result)
                    if (result && result.profile && result.stats && result.stats.matches) {
                        consoleWithNoSource(`${result.profile.replace(/-raw/,'')}: ${result.stats.matches}/${result.stats.snps} SNPs (${(result.stats.matches/result.stats.snps * 100).toFixed(2)}%) used for this analysis`)
                    }
                    if (result && !result.error) {
                        if (w.subResults.length === 0) {
                            let elapse = Date.now() - substart
                            subTimer = setTimeout(function() {
                                checkSub();
                            }, eta < 25000 ? 25000 : eta)
                        }
                        result.runsim = true;
                        w.subResults.push(result)
                    } else {
                        let message
                        if (result.error && result.error == 999) {
                            w.$store.commit('change', {
                                lastsync: false
                            })
                            message = '<b>invalid decryption key provided</b><br/><i>' + result.message + '</i>'
                        } else if (result.error && result.error == 991) {
                            message = '<b>RAW DNA file not found</b><br/><i>' + result.message + '</i>'
                        } else {
                            message = '<b>Code: ' + result.error + '</b><br/><i>' + result.message + '</i><br>the support team has been notified'
                        }
                        w.errorArray.push(message)
                    }
                    w.filterResults = {
                        quantity: result.quantity,
                        filtered: result.filtered
                    }
                } catch (e) {
                    consoleWithNoSource(e, 'No data received for ' + subId)
                }
                if (w.reqnum == 0) {
                    var filterMsg = w.filterResults && w.filterResults.filtered && w.filterResults.filtered > 0 ? ` filtered: ${w.filterResults.filtered}/${w.filterResults.quantity} outliers` : ''
                    consoleWithNoSource('Query completed in ' + Math.round((Date.now() - w.start) / 1000) + ' seconds' + filterMsg);
                    endSubscription();
                    checkSub();
                    clearTimeout(subTimer);
                    clearTimeout(noresultTimer);
                }
            }
            subscription = observable.subscribe({
                next: realtimeResults,
                complete: consoleWithNoSource,
                connect: function(evt) {
                    consoleWithNoSource('connected ', evt)
                },
                error: function(error) {
                    consoleWithNoSource('subscription error', error)
                }
            })
            /*
            function showProgress(eta) {
                w.progress = 0;
                var i = 0;
                var eta = eta;
                var timer = Math.round(eta / 100)
                var incr = 1
                var increment = function() {
                    i++;
                    if (i < 100) {
                        if (i > 93) timer = timer * 2
                        var incrementTimer = setTimeout(function() {
                            if (w.subResults.length === w.rawArrayLocal.length) {
                                endSubscription()
                                checkSub();
                                clearTimeout(subTimer);
                                clearTimeout(noresultTimer);
                            }

                            if (!w.chartReady) {
                                w.progress = i;
                                increment()
                            } else {
                                w.progress = 0;
                            }
                        }, timer);
                    }
                }
                increment();
            }
            */
            function showProgress(eta, w) {
                w.progress = 0;
                let i = 0;
                let timer = Math.round(eta / 100)
                let lastTime = 0;
                const increment = function(time) {
                    if (w.progress < 100 && ((time - lastTime) >= timer)) {
                        if (w.progress > 93) timer = timer * 2
                        if (w.subResults.length === w.counterArray.length) {
                            endSubscription()
                            checkSub();
                            clearTimeout(subTimer);
                            clearTimeout(noresultTimer);
                            return;
                        }
                        w.progress += 1;
                        if (!w.chartReady) {
                            requestAnimationFrame(increment);
                        } else {
                            w.progress = 100;
                        }
                        lastTime = time;
                    } else {
                        requestAnimationFrame(increment)
                    }
                }
                requestAnimationFrame(increment)
            }
            showProgress(eta, w);
        },
        updateConfig(params) {
            let w = this;
            if (params.parameter && params.value) {
                w[params.parameter] = params.value
                console.log(`${params.parameter} set to ${w[params.parameter]}`)
            }
        },
        refreshCache(cache) {
            let w = this;
            let currentDT = Math.floor(Date.now() / 1000)
            if (typeof(cache) !== 'undefined' && cache.tos) localStorage.setItem('cacheVer', JSON.stringify(cache));
            var cache = typeof(cache) !== 'undefined' && cache.tos ? cache : localStorage.getItem('cacheVer') ? JSON.parse(localStorage.getItem('cacheVer')) : {
                groups: {
                    g25: currentDT
                },
                samples: currentDT,
                tos: 0,
                calcVersion: currentDT
            }
            var UTF8to16 = function(convertMe) {
                var out = "";
                for (var i = 0; i < convertMe.length; i += 2) {
                    var charCode = convertMe.charCodeAt(i) * 256;
                    charCode += convertMe.charCodeAt(i + 1);
                    out += String.fromCharCode(charCode);
                }
                return out;
            }
            var queryParam = '?v=0.'
            var stage = this.$store.getters.get('env') === 'production' ? '' : 'staging/';
            this.$dbCache.getRawGroups(cache, 'calculators', stage).then(str => {
                w.publicRawGroups = str
            })
            this.$dbCache.getRawAncientgroups(cache, 'calculators', stage).then(str => {
                w.publicRawAncientGroups = str
            })
            this.$dbCache.getAdmixCalculators(cache, 'calculators', stage).then(async str => {
                w.publicCalcsAdmix = JSON.parse(JSON.stringify(str))
            })
            this.$dbCache.getCalculators(cache, 'calculators', stage).then(async str => {
                w.publicCalcsG25 = JSON.parse(JSON.stringify(str))
            })
            this.$dbCache.getG25Groups(cache, 'calculators', stage).then(str => {
                w.publicGroupsG25 = str
            })
            this.$dbCache.getSampleGroups(cache, 'calculators', stage).then(str => {
                let customGroups = []
                str.forEach(x => {
                    let indexes = []
                    x.samples.map((sample, i) => {
                        if (sample.customgroup) {
                            indexes.push(i)
                            let customIndex = customGroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customGroups[customIndex].samples.push(sample)
                            } else {
                                customGroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    label: sample.customgroup + ' [' + sample.group + ']',
                                    customgroup: sample.customgroup,
                                    type: sample.mode,
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    if (indexes.length > 0) {
                        x.samples = x.samples.filter((value, index) => indexes.indexOf(index) == -1)
                    }
                })
                w.customGroupsG25 = customGroups
                w.publicSamplesG25 = str;
            })
            this.$dbCache.getRawGroupsCache(cache, 'calculators', stage).then(str => {
                w.publicRawGroupsG25 = str;
            })
            this.$dbCache.getRawGroupedSamplesCache(cache, 'calculators', stage).then(str => {
                w.publicRawSamplesG25 = str;
            })
            this.$dbCache.getAll(cache, 'from calculators', stage, ['getRawGroupedSamplesCache', 'getRawGroupsCache', 'getSampleGroups', 'getG25Groups', 'getCalculators', 'getAdmixCalculators', 'getRawAncientgroups', 'getRawGroups'])
        },
        startPGS() {
            this.$Progress.start()
        },
        setPGS(num) {
            this.$Progress.set(num)
        },
        increasePGS(num) {
            this.$Progress.increase(num)
        },
        decreasePGS(num) {
            this.$Progress.decrease(num)
        },
        finishPGS() {
            this.$Progress.finish()
        },
        failPGS() {
            this.$Progress.fail()
        },
        testPGS() {
            this.$Progress.start()

            this.$http.jsonp('http://api.rottentomatoes.com/api/public/v1.0/lists/movies/in_theaters.json?apikey=7waqfqbprs7pajbz28mqf6vz')
                .then((response) => {
                    this.$Progress.finish()
                }, (response) => {
                    this.$Progress.fail()
                })
        },
        copyNearestTableBB() {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.distance = 'Distance'
            var nearest = this.optimaEnabled ? this.chartJSON[this.currentIndex].nearest : this.chartJSON[this.currentIndex].nearest.splice(0, 5);
            var tabledata = []
            nearest.forEach(sample => {
                var obj = {};
                obj.sample = sample._row;
                obj.distance = sample.distance;
                tabledata.push(obj)
            })
            var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
            copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
            var replace = new RegExp(' class=.*?]', 'g')
            copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']').replace(/:/g, " ► ")
            copyhtml = `[size=1]${copyhtml}[/size]`
            copy(copyhtml, {
                asHtml: false,
            });
        },
        copyNearestTable() {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.distance = 'Distance'
            var nearest = this.optimaEnabled ? this.chartJSON[this.currentIndex].nearest : this.chartJSON[this.currentIndex].nearest.splice(0, 5);
            var tabledata = []
            nearest.forEach(sample => {
                var obj = {};
                obj.sample = sample._row;
                obj.distance = sample.distance;
                tabledata.push(obj)
            })
            var copyhtml = new Table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            copyhtml = juice.inlineContent(copyhtml, tablecss)
            let copytext = this.$yaml.stringify(tabledata, 2).replace(/-\n/g, '\n').replace(/'/g, '')
            copy(text, {
                asHtml: false,
            });
        },
        clipNearest: function(type) {
            var nearest = this.optimaEnabled ? this.chartJSON[this.currentIndex].nearest : this.chartJSON[this.currentIndex].nearest.splice(0, 5);
            let data = []
            nearest.forEach(sample => {
                let obj = {};
                obj.sample = {
                    ...sample
                }.sample ? {
                    ...sample
                }.sample : {
                    ...sample
                }._row;
                obj.distance = {
                    ...sample
                }.distance
                data.push(obj);
            })
            let prettyJSON = JSON.stringify(data, null, 2);
            copy(prettyJSON, {
                asHtml: false,
            });
        },
        changeCalcType: async function(evt, params) {
            console.log('Elapsed time Started', Date.now() - window.__GenoStart)
            let w = this;
            this.calcReady = false;
            try {
                this.$refs.leftSelectinput.updateSearch('');
            } catch (err) {}
            window.__GenoStart = Date.now()
            this.spinner = true;
            this.scrollCalcs = []
            this.calclength = 0;
            requestIdleCallback(async () => {
                this.sortOrder = 'desc';
                this.sortModel = 'rating';
                w.setActive(0)
                this.setCalcType(evt, params)
            })
        },
        setCalcType: async function(evt, index) {
            this.scrollCalcs = []
            index = index && typeof(index) == 'object' ? index : false
            if (index) {
                console.log('waiting for new samples');
                await this.getUserSamples();
            } else {
                this.getUserSamples();
            }
            if (evt == true) {
                this.rawArray = [];
                this.calcArray = [];
                let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname
                window.history.replaceState({
                    path: newurl
                }, '', newurl);
            }
            console.log('Elapsed time Started 2', Date.now() - window.__GenoStart)
            let w = this;
            if (!this.G25) {
                this.publicCalcs = this.publicCalcsAdmix.slice(0.40)
                w.calcCount = w.calcCountAdmix
            } else {
                this.publicCalcs = this.publicCalcsG25.slice(0, 40)
                w.calcCount = w.calcCountG25
            }
            //this.publicCalcs = JSON.parse(JSON.stringify(this.publicCalcs.filter(x => x.owner)))
            this.scroller = 40;
            if (this.datasearch) {
                this.updateCount(true)
            } else {
                this.scrollCalcs = this.publicCalcs.slice(0, 40)
            }
            this.calcReady = this.publicCalcs.length > 0 ? true : false
            this.spinner = false
            //this.badcalcs = this.publicCalcs.filter(x => !x.owner)
            /*
            await this.$nextTick(() => {
                this.filterizr = new Filterizr('.filtr-container', {
                    controlsSelector: '.fltr-controls',
                    layout: 'sameSize',
                    gutterPixels: 25,
                    delay: 0,
                    delayMode: 'alternate',
                    spinner: {
                        enabled: false,
                    },
                    callbacks: {
                        onInit: w.initF(index),
                    }
                });
            })
            */
            setTimeout(() => {
                this.G25calc = this.G25
                let name = w.user ? w.user.username + ':' + 'G25calc' : false
                if (this.G25calc) {
                    localStorage.setItem(name, 'true')
                } else {
                    localStorage.removeItem(name)
                }
                this.$nextTick(() => {
                    console.log('finished setting calctype', this.G25calc, this.datasearch)
                    if (this.datasearch) {
                        this.searchCalcs()
                    } else if (this.scrollCalcs.length == 0) {
                        this.datasearch = undefined;
                    } else if (index) {
                        this.completeRerun(index);
                    }
                })
            }, 0)
        },
        showArticle(evt) {
            this.startTour();
            return;
            this.$genericevent.showArticle(evt);
        },
        getXLS: () => {
            return new Promise((resolve, reject) => {
                if (!window.XLSX) {
                    let script = document.createElement('script')
                    script.onload = () => {
                        resolve(true)
                    }
                    script.async = true
                    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.15.2/xlsx.core.min.js'
                    document.head.appendChild(script)
                } else {
                    resolve(true)
                }
            })
        },
        showShared: async function(url, element) {
            let w = this;
            let buttons = [{
                title: "Copy URL",
                handler: (i, event) => {
                    copy(url)
                    document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                }
            }, {
                title: "Copy URL (BBCode)",
                handler: (i, event) => {
                    let bburl = `[URL="${url}"][IMG]${url}[/IMG][/URL]`
                    copy(bburl)
                    document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                }
            }, {
                title: 'Close',
                default: true
            }]
            w.$modal.show('dialog', {
                title: 'Link to sharable image',
                text: `You can now share an image of this ${element} from this <a style='color:steelblue;' target='_blank' href=${url}>link</a>`,
                buttons: buttons,
                clickToClose: false,
                beforeClosed: function(event) {
                    console.log('closing', event)
                }
            })
        },
        putImage: async function(svg, prefix, path, sigparams, element, type) {
            let w = this;
            if (type == 'png') {
                try {
                    async function convertSvgToPngBlob(svgString) {
                        const div = document.createElement('div');
                        div.style.position = 'absolute';
                        div.style.left = '-9999px';
                        div.innerHTML = svgString.trim();
                        document.body.appendChild(div);
                        try {
                            let bgcolor = w.theme ? '#14191f' : '#f2f2f2';
                            const blob = await domtoimage.toBlob(div.firstChild, {
                                bgcolor: bgcolor
                            });
                            svg = await blob.arrayBuffer();
                            document.body.removeChild(div);
                        } catch (error) {
                            console.log('error', error);
                            document.body.removeChild(div);
                            w.spinner = false;
                        }
                    };
                    let blob = await convertSvgToPngBlob(svg);
                } catch (err) {
                    console.log('err', err)
                    document.body.removeChild(div);
                    w.spinner = false;
                }
            };
            let data = await w.$apollo.query({
                query: getFilebaseSignatureQuery,
                variables: {
                    params: JSON.stringify(sigparams)
                },
                fetchPolicy: 'network-only'
            })
            if (data && data.data && data.data.getFilebaseSignature && data.data.getFilebaseSignature.result) {
                let result = JSON.parse(data.data.getFilebaseSignature.result);
                let signedUrl = result.url;
                let options = {
                    headers: {
                        'Content-Type': sigparams.contentType,
                        'Content-Encoding': 'gzip',
                        'Cache-Control': 'max-age=86400'
                    }
                }
                const operation = w.$retry.operation({
                    retries: 3,
                    factor: 2,
                    minTimeout: 125,
                    maxTimeout: 1000,
                    randomize: false,
                });
                operation.attempt(async (currentAttempt) => {
                    console.log('sending request: ', currentAttempt, ' attempt');
                    try {
                        axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(svg)), options)
                            .then(function(result) {
                                w.spinner = false
                                w.exporting = false
                                console.log(`${prefix}/${path}`)
                                w.lastShared = w.plotId
                                if (w.markerState) {
                                    w.markerState.savedlink = `${prefix}/${path}`
                                }
                                w.lastMarkerState = w.markerState
                                delete w.markerArea
                                w.showShared(`${prefix}/${path}`, element)
                            })
                            .catch(function(err) {
                                if (operation.retry(err)) {
                                    return;
                                }
                                w.spinner = false
                                w.exporting = false;
                                console.log(err);
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'show',
                                    component: 'nav',
                                    params: {
                                        title: "Error",
                                        text: "unable to upload Image",
                                        class: 'warning'
                                    }
                                })
                            });
                    } catch (e) {
                        if (operation.retry(e)) {
                            return;
                        }
                    }
                })
            } else {
                console.log(data);
                w.spinner = false
                w.exporting = false;
                w.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: "Error",
                        text: "unable to upload Image",
                        class: 'warning'
                    }
                })
            }
        },
        uploadImage: async function(el, type) {
            let w = this;
            type = w.screenshot ? 'svg' : 'png'
            console.log('started')
            w.$store.commit('change', {
                spinner: true
            })
            setTimeout(() => {
                delete w.markerArea
                w.editedImageUrl = undefined
                w.editedImageUrl2 = undefined
                w.exporting = true;
                let element = (el === 'table' || el === 'map') ? el : el === 'apex-heatmap' ? 'heatmap' : 'chart'
                try {
                    let image = type;
                    let contentType = type == 'png' ? "image/png" : "image/svg+xml"
                    let fileType = 'image'
                    let name = w.alias ? w.alias : w.user.username;
                    let path = `${name}/${element}-${Date.now().toString(16)}`
                    let sigparams = {
                        filePath: path,
                        fileType: fileType,
                        contentType: contentType
                    }
                    let node = document.getElementById(el);
                    let style = el === 'table' && type == 'svg' ? {
                        marginTop: '-50px',
                        marginLeft: '50px',
                        padding: 0
                    } : el === 'barchart' ? {
                        'margin': 0,
                        'width': '100%',
                        marginTop: '0px',
                        padding: 'unset',
                    } : el === 'table' ? {
                        marginLeft: 0,
                        marginTop: '-50px',
                        padding: 0,
                        paddingLeft: '50px',
                        paddingRight: '10px'
                    } : el === 'apex-heatmap' ? {
                        marginTop: '-25',
                        padding: 0
                    } : el === 'map' ? {
                        marginTop: '50px',
                        padding: 0
                    } : el === 'chartresult' ? {
                        marginTop: '50px',
                        padding: '20px 0'
                    } : {
                        marginTop: '50px',
                        padding: 0
                    }
                    domtoimage.toSvg(node, {
                            bgcolor: this.theme && el === 'table' ? '#14191f' : this.theme ? '#14191f' : '#f2f2f2',
                            style: style
                        })
                        .then(async function(blob) {
                            let prefix = 'https://shared.genoplot.com/file/genofiles'
                            let svg = blob.replace(/data\:image\/svg\+xml\;charset\=utf-8\,/, '').replace(/\%0A/g, '')
                            let style = ''
                            if (element === 'chart') {
                                let background = w.theme ? '#14191f' : '#f2f2f2'
                                style = `<style>` + (el === 'chart' ? '.profile { margin-top: -38px !important; }' : el == 'barchart' ? 'svg {margin-left: 100px;}' : '') + `#maplegend-wrapper { background: ${background} !important;} .profile { transform: translateY(-72px) !important;}</style>`
                            } else {
                                if (w.theme) {
                                    style = "<style>* { pointer-events: none;}foreignObject, foreignObject > *, foreignObject .switchChartType { background: #14191f !important;}</style>"
                                } else {
                                    style = "<style>* { pointer-events: none;}</style>"
                                }
                            }
                            svg = svg.replace(/\>\<foreignObject/, `>${style}<foreignObject`)
                            var svgBlob = new Blob([svg], {
                                type: "image/svg+xml;charset=utf-8"
                            });
                            var svgUrl = URL.createObjectURL(svgBlob);
                            w.markup = false;
                            if (el === 'sunburst' || el === 'map' || el === 'apex-wrapper' || el === 'chart') {
                                let image = document.getElementById('editImage')
                                image.onload = () => {
                                    if (!w.markerArea) {
                                        console.log('Loading markers')
                                        let markerArea = new markerjs2.MarkerArea(image);
                                        markerArea.addCloseEventListener(data => {
                                            delete w.markerArea
                                            if (!w.markup) {
                                                w.spinner = false;
                                                w.exporting = false;
                                            } else {}
                                        })
                                        markerArea.addRenderEventListener(async (dataUrl, state) => {
                                            w.spinner = true;
                                            w.editedImageUrl2 = dataUrl;
                                            let replaceStr = svg.substring(svg.indexOf("<svg"), svg.indexOf(">"))
                                            let newSVG = document.getElementById('markerSVG').outerHTML
                                            console.log('markup as pushed')
                                            if (newSVG) {
                                                w.markup = newSVG
                                                let markup = newSVG.replace(/<svg xml.*?view/, replaceStr + ' view')
                                                svg = svg.replace(/\/foreignObject\>/, `/foreignObject>${markup}`)
                                            }
                                            w.markerState = state;
                                            await w.putImage(svg, prefix, path, sigparams, element, type)
                                            w.editedImageUrl = undefined
                                            w.editedImageUrl2 = undefined
                                        });
                                        w.markerArea = markerArea
                                    }
                                    let theme = (w.slider.colors.value - 1) % 5
                                    let colors = w.chartColors[theme];
                                    w.markerArea.settings.defaultColorSet = w.theme ? colors.concat(['transparent', '#ffffff']) : colors.concat(['transparent', '#e31a1c'])
                                    w.markerArea.settings.displayMode = 'popup';
                                    w.markerArea.renderAtNaturalSize = false;
                                    w.markerArea.settings.defaultOpacitySteps = [0.05, 0.1, 0.15, 0.2, 0.25, 0.5, 0.75, 1]
                                    w.markerArea.settings.defaultColor = w.theme ? '#ffffff' : '#e31a1c'
                                    w.markerArea.settings.defaultFontFamilies = ["Segoe UI", "Helvetica", "Arial", "sans-serif"]
                                    w.markerArea.settings.defaultFontFamily = "Segoe UI"
                                    w.markerArea.settings.savedlink = false;
                                    w.markerArea.renderImageType = "image/svg+xml;charset=utf-8"
                                    w.markerArea.renderMarkersOnly = true;
                                    w.markerArea.availableMarkerTypes = ["ArrowMarker", 'LineMarker', 'MeasurementMarker', "FreehandMarker", "FrameMarker", "HighlightMarker", EllipseMarker2, HighlightEllipseMarker, 'CalloutMarker', "TextMarker"];
                                    if (w.markerState && w.markerState.savedlink) {
                                        w.markerArea.settings.savedlink = w.markerState.savedlink
                                    }
                                    w.markerArea.show();
                                    w.spinner = false;
                                    if (w.markerState) {
                                        w.markerArea.restoreState(w.markerState);
                                    }
                                }
                                w.editedImageUrl = svgUrl;
                            } else {
                                w.putImage(svg, prefix, path, sigparams, element, type)
                            }
                        }).catch(function(err) {
                            console.log(err);
                            w.$store.commit('change', {
                                spinner: false
                            })
                            w.exporting = false;

                        })
                } catch (err) {
                    w.spinner = false
                    w.exporting = false;
                    console.log(err);
                }
            }, 0)
        },
        uploadImage2: async function(el, type) {
            let w = this;
            w.exporting = true;
            w.$store.commit('change', {
                spinner: true
            })
            let element = (el === 'table' || el === 'map') ? el : el === 'apex-heatmap' ? 'heatmap' : 'chart'

            function showShare(url, element) {
                let buttons = [{
                    title: "Copy URL",
                    handler: (i, event) => {
                        copy(url)
                        document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                    }
                }, {
                    title: "Copy URL (BBCode)",
                    handler: (i, event) => {
                        let bburl = `[URL="${url}"][IMG]${url}[/IMG][/URL]`
                        copy(bburl)
                        document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                    }
                }, {
                    title: 'Close',
                    default: true
                }]
                w.$modal.show('dialog', {
                    title: 'Link to sharable image',
                    text: `You can now share an image of this ${element} from this <a style='color:steelblue;' target='_blank' href=${url}>link</a>`,
                    buttons: buttons,
                    clickToClose: false,
                    beforeClosed: function(event) {
                        console.log('closing', event)
                    }
                })
            }
            try {
                let image = type;
                let contentType = "image/svg+xml"
                let fileType = 'image'
                let path = `${w.user.username}/${element}-${Date.now().toString(16)}`
                let sigparams = {
                    filePath: path,
                    fileType: fileType,
                    contentType: contentType
                }
                let data = await w.$apollo.query({
                    query: getFilebaseSignatureQuery,
                    //query: getS3SignatureQuery,
                    variables: {
                        params: JSON.stringify(sigparams)
                    },
                    fetchPolicy: 'network-only'
                })
                //if ( data && data.data && data.data.gets3Signature && data.data.gets3Signature.result ) {
                //let result = JSON.parse(data.data.gets3Signature.result);
                if (data && data.data && data.data.getFilebaseSignature && data.data.getFilebaseSignature.result) {
                    let result = JSON.parse(data.data.getFilebaseSignature.result);
                    let signedUrl = result.url;
                    let options = {
                        headers: {
                            'Content-Type': contentType,
                            'Content-Encoding': 'gzip',
                            'Cache-Control': 'max-age=86400'
                        }
                    }
                    let node = document.getElementById(el);
                    let style = el === 'table' ? {
                        marginTop: '-50px',
                        marginLeft: '100px',
                        padding: 0
                    } : el === 'barchart' ? {
                        'margin': 0,
                        'width': '100%',
                        marginTop: '-10px',
                        padding: 'unset'
                    } : el === 'apex-heatmap' ? {
                        marginTop: '-25',
                        padding: 0
                    } : el === 'map' ? {
                        marginTop: '50px',
                        padding: 0
                    } : {
                        marginTop: '50px',
                        padding: 0
                    }
                    let w = this;
                    domtoimage.toSvg(node, {
                            bgcolor: this.theme && el === 'table' ? '#14191f' : this.theme ? 'black' : 'white',
                            style: style
                        })
                        .then(async function(blob) {
                            let prefix = 'https://shared.genoplot.com/file/genofiles'
                            let svg = blob.replace(/data\:image\/svg\+xml\;charset\=utf-8\,/, '').replace(/\%0A/g, '')
                            let style = ''
                            if (element === 'chart') {
                                let background = w.theme ? '#000000b5' : '#ffffffb5'
                                style = `<style>#maplegend-wrapper { background: ${background} !important;} .profile { transform: translateY(-72px) !important;}</style>`
                            } else {
                                style = "<style>* { pointer-events: none;}</style>"
                            }
                            svg = svg.replace(/\>\<foreignObject/, `>${style}<foreignObject`)
                            axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(svg)), options)
                                .then(function(result) {
                                    w.spinner = false
                                    w.exporting = false
                                    console.log(`${prefix}/${path}`)
                                    w.lastShared = w.plotId
                                    showShare(`${prefix}/${path}`, element)
                                })
                                .catch(function(err) {
                                    w.spinner = false
                                    w.exporting = false;
                                    console.log(err);
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'show',
                                        component: 'nav',
                                        params: {
                                            title: "Error",
                                            text: "unable to upload Image",
                                            class: 'warning'
                                        }
                                    })
                                });
                        }).catch(function(err) {
                            console.log(err);
                            w.$store.commit('change', {
                                spinner: false
                            })
                            w.exporting = false;

                        })
                } else {
                    console.log(data);
                    w.spinner = false
                    w.exporting = false;
                    w.$eventBus.$emit('appEvents', {
                        exec: 'show',
                        component: 'nav',
                        params: {
                            title: "Error",
                            text: "unable to upload Image",
                            class: 'warning'
                        }
                    })
                }
            } catch (err) {
                w.spinner = false
                w.exporting = false;
                console.log(err);
            }
        }
    },
}

function tokenize(inputStr) {
    const regex = /"([^"]+)"|'([^']+)'|(\S+)/g;
    const tokens = [];
    let match;
    while ((match = regex.exec(inputStr)) !== null) {
        if (match[1]) {
            tokens.push(match[1]);
        } else if (match[2]) {
            tokens.push(match[2]);
        } else if (match[3]) {
            tokens.push(match[3]);
        }
    }
    return tokens;
}

function parseConditions(tokens, defaultField) {
    const conditions = [];
    let currentOperator = 'OR'; // Default operator in uppercase
    tokens.forEach(token => {
        const lower = token.toLowerCase();
        if (lower === 'and' || lower === 'or') {
            currentOperator = lower.toUpperCase();
        } else {
            const parts = token.split(':');
            let field, value;
            if (parts.length === 3) {
                field = parts[0].toLowerCase();
                value = parts[1].toLowerCase();
            } else {
                field = defaultField.toLowerCase();
                value = token.toLowerCase();
            }
            conditions.push({
                field,
                value,
                operator: currentOperator
            });
            currentOperator = 'OR'; // Reset to default
        }
    });

    return conditions;
}

function getFieldValue(obj, field) {
    const fields = field.split('.');
    let value = obj;
    for (const f of fields) {
        if (value[f] === undefined || value[f] === null) {
            return '';
        }
        value = value[f];
    }
    return typeof value === 'string' ? value : String(value);
}

function buildFilterFunction(conditions) {
    return function(item) {
        let result = (conditions[0].operator === 'AND') ? true : false;

        conditions.forEach(cond => {
            const fieldValue = getFieldValue(item, cond.field).toLowerCase();
            const conditionMet1 = fieldValue == cond.value;
            const conditionMet2 = fieldValue.includes(cond.value);

            if (cond.operator === 'AND') {
                result = (result && conditionMet1 || result && conditionMet2)
            } else if (cond.operator === 'OR') {
                result = (result || conditionMet1 || conditionMet2);
            }
        });

        return result;
    };
}

function generateFilterString(conditions) {
    const filterConditions = conditions.map(cond => {
        return `item.${cond.field}.toLowerCase().includes('${cond.value}')`;
    });

    let filterString = 'const result = data.filter(item => ';

    filterConditions.forEach((cond, index) => {
        if (index === 0) {
            filterString += cond;
        } else {
            const operator = conditions[index].operator;
            filterString += ` ${operator} ${cond}`;
        }
    });

    filterString += ');';

    return filterString;
}

function filterNestedData(data, filterFunc, nestedArrayKey) {
    //console.log(data[0]);
    return data.reduce((acc, item) => {
        if (Array.isArray(item[nestedArrayKey])) {
            const filteredNested = item[nestedArrayKey].filter(filterFunc);
            if (filteredNested.length > 0) {
                acc.push({
                    ...item,
                    [nestedArrayKey]: filteredNested
                });
            }
        }
        // console.log(acc[0])
        return acc;
    }, []);
}

function filterData(inputStr, data, defaultField = 'refs', nestedArrayKey = 'samples') {
    if (!Array.isArray(data) || data.length === 0 || !inputStr || inputStr < 4) return {
        filteredData: data,
        filterString: ''
    };
    const tokens = tokenize(inputStr);
    const conditions = parseConditions(tokens, defaultField);
    const filterString = generateFilterString(conditions);
    //const filterString = '';
    const filterFunc = buildFilterFunction(conditions);

    const firstItem = data[0];
    const isNested = nestedArrayKey && firstItem.hasOwnProperty(nestedArrayKey) && Array.isArray(firstItem[nestedArrayKey]);

    let filteredData;
    if (isNested) {
        filteredData = filterNestedData(data, filterFunc, nestedArrayKey);
    } else {
        filteredData = data.filter(filterFunc);
    }

    return {
        filteredData,
        filterString
    };
}
